//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiClientConfiguration } from 'api/swagger/ApiClientConfiguration';
import { ApiClientBase } from 'api/swagger/ApiClientBase';
import { inject } from 'aurelia-framework';
import { HttpClient, RequestInit } from 'aurelia-fetch-client';

export interface IAccommodationTypesClient {

    getById(id: number): Promise<AccommodationTypeDetailDTO>;

    updateAccomodationType(id: number, request: AccommodationTypeUpdateDTO): Promise<AccommodationTypeDetailDTO>;

    getAll(): Promise<AccommodationTypeDetailDTO[]>;

    createAccomodationType(request: AccommodationTypeCreateDTO): Promise<AccommodationTypeDetailDTO>;

    getAllActiveKeywords(): Promise<AccommodationTypeInfoDTO[]>;

    setAccommodationTypesOrder(idsInOrder?: number[] | undefined): Promise<void>;

    archiveAccomodationType(id: number): Promise<AccommodationTypeDetailDTO>;

    unarchiveAccomodationType(id: number): Promise<AccommodationTypeDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class AccommodationTypesClient extends ApiClientBase implements IAccommodationTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<AccommodationTypeDetailDTO> {
        let url_ = this.baseUrl + "/AccommodationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<AccommodationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccommodationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO>(null as any);
    }

    updateAccomodationType(id: number, request: AccommodationTypeUpdateDTO): Promise<AccommodationTypeDetailDTO> {
        let url_ = this.baseUrl + "/AccommodationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAccomodationType(_response));
        });
    }

    protected processUpdateAccomodationType(response: Response): Promise<AccommodationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccommodationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO>(null as any);
    }

    getAll(): Promise<AccommodationTypeDetailDTO[]> {
        let url_ = this.baseUrl + "/AccommodationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<AccommodationTypeDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccommodationTypeDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO[]>(null as any);
    }

    createAccomodationType(request: AccommodationTypeCreateDTO): Promise<AccommodationTypeDetailDTO> {
        let url_ = this.baseUrl + "/AccommodationTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAccomodationType(_response));
        });
    }

    protected processCreateAccomodationType(response: Response): Promise<AccommodationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AccommodationTypeDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<AccommodationTypeInfoDTO[]> {
        let url_ = this.baseUrl + "/AccommodationTypes/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<AccommodationTypeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccommodationTypeInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeInfoDTO[]>(null as any);
    }

    setAccommodationTypesOrder(idsInOrder?: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/AccommodationTypes/setOrder?";
        if (idsInOrder === null)
            throw new Error("The parameter 'idsInOrder' cannot be null.");
        else if (idsInOrder !== undefined)
            idsInOrder && idsInOrder.forEach(item => { url_ += "idsInOrder=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetAccommodationTypesOrder(_response));
        });
    }

    protected processSetAccommodationTypesOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    archiveAccomodationType(id: number): Promise<AccommodationTypeDetailDTO> {
        let url_ = this.baseUrl + "/AccommodationTypes/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveAccomodationType(_response));
        });
    }

    protected processArchiveAccomodationType(response: Response): Promise<AccommodationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccommodationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO>(null as any);
    }

    unarchiveAccomodationType(id: number): Promise<AccommodationTypeDetailDTO> {
        let url_ = this.baseUrl + "/AccommodationTypes/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveAccomodationType(_response));
        });
    }

    protected processUnarchiveAccomodationType(response: Response): Promise<AccommodationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccommodationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccommodationTypeDetailDTO>(null as any);
    }
}

export interface IAirlinesClient {

    getById(id: number): Promise<AirlineDetailDTO>;

    updateAirline(id: number, request: AirlineUpdateDTO): Promise<AirlineDetailDTO>;

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, airlineRating?: AirlineRating[] | undefined, airlineStatus?: AirlineStatus[] | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfAirlineListQueryDTO>;

    createAirline(request: AirlineCreateDTO): Promise<AirlineDetailDTO>;

    getAllActiveKeywords(): Promise<AirlineInfoDTO[]>;

    archiveAirline(id: number): Promise<AirlineDetailDTO>;

    unarchiveAirline(id: number): Promise<AirlineDetailDTO>;

    getAirlinesOverviewReport(): Promise<FileResponse>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class AirlinesClient extends ApiClientBase implements IAirlinesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<AirlineDetailDTO> {
        let url_ = this.baseUrl + "/Airlines/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<AirlineDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirlineDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineDetailDTO>(null as any);
    }

    updateAirline(id: number, request: AirlineUpdateDTO): Promise<AirlineDetailDTO> {
        let url_ = this.baseUrl + "/Airlines/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAirline(_response));
        });
    }

    protected processUpdateAirline(response: Response): Promise<AirlineDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirlineDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineDetailDTO>(null as any);
    }

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, airlineRating?: AirlineRating[] | undefined, airlineStatus?: AirlineStatus[] | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfAirlineListQueryDTO> {
        let url_ = this.baseUrl + "/Airlines?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (airlineRating === null)
            throw new Error("The parameter 'airlineRating' cannot be null.");
        else if (airlineRating !== undefined)
            airlineRating && airlineRating.forEach(item => { url_ += "AirlineRating=" + encodeURIComponent("" + item) + "&"; });
        if (airlineStatus === null)
            throw new Error("The parameter 'airlineStatus' cannot be null.");
        else if (airlineStatus !== undefined)
            airlineStatus && airlineStatus.forEach(item => { url_ += "AirlineStatus=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByFilter(_response));
        });
    }

    protected processGetAllByFilter(response: Response): Promise<QueryResultOfAirlineListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfAirlineListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfAirlineListQueryDTO>(null as any);
    }

    createAirline(request: AirlineCreateDTO): Promise<AirlineDetailDTO> {
        let url_ = this.baseUrl + "/Airlines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAirline(_response));
        });
    }

    protected processCreateAirline(response: Response): Promise<AirlineDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AirlineDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<AirlineInfoDTO[]> {
        let url_ = this.baseUrl + "/Airlines/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<AirlineInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirlineInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineInfoDTO[]>(null as any);
    }

    archiveAirline(id: number): Promise<AirlineDetailDTO> {
        let url_ = this.baseUrl + "/Airlines/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveAirline(_response));
        });
    }

    protected processArchiveAirline(response: Response): Promise<AirlineDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirlineDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineDetailDTO>(null as any);
    }

    unarchiveAirline(id: number): Promise<AirlineDetailDTO> {
        let url_ = this.baseUrl + "/Airlines/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveAirline(_response));
        });
    }

    protected processUnarchiveAirline(response: Response): Promise<AirlineDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirlineDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AirlineDetailDTO>(null as any);
    }

    getAirlinesOverviewReport(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Airlines/overviewReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAirlinesOverviewReport(_response));
        });
    }

    protected processGetAirlinesOverviewReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IApprovalLevelsClient {

    getById(id: number): Promise<ApprovalLevelDetailDTO>;

    updateApprovalLevel(id: number, request: ApprovalLevelUpdateDTO): Promise<ApprovalLevelDetailDTO>;

    getAll(): Promise<ApprovalLevelDetailDTO[]>;

    createApprovalLevel(request: ApprovalLevelCreateDTO): Promise<ApprovalLevelDetailDTO>;

    getAllActiveKeywords(): Promise<ApprovalLevelInfoDTO[]>;

    setApprovalLevelsOrder(idsInOrder?: number[] | undefined): Promise<void>;

    archiveApprovalLevel(id: number): Promise<ApprovalLevelDetailDTO>;

    unarchiveApprovalLevel(id: number): Promise<ApprovalLevelDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class ApprovalLevelsClient extends ApiClientBase implements IApprovalLevelsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<ApprovalLevelDetailDTO> {
        let url_ = this.baseUrl + "/ApprovalLevels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ApprovalLevelDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalLevelDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO>(null as any);
    }

    updateApprovalLevel(id: number, request: ApprovalLevelUpdateDTO): Promise<ApprovalLevelDetailDTO> {
        let url_ = this.baseUrl + "/ApprovalLevels/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateApprovalLevel(_response));
        });
    }

    protected processUpdateApprovalLevel(response: Response): Promise<ApprovalLevelDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalLevelDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO>(null as any);
    }

    getAll(): Promise<ApprovalLevelDetailDTO[]> {
        let url_ = this.baseUrl + "/ApprovalLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ApprovalLevelDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalLevelDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO[]>(null as any);
    }

    createApprovalLevel(request: ApprovalLevelCreateDTO): Promise<ApprovalLevelDetailDTO> {
        let url_ = this.baseUrl + "/ApprovalLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateApprovalLevel(_response));
        });
    }

    protected processCreateApprovalLevel(response: Response): Promise<ApprovalLevelDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApprovalLevelDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<ApprovalLevelInfoDTO[]> {
        let url_ = this.baseUrl + "/ApprovalLevels/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<ApprovalLevelInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalLevelInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelInfoDTO[]>(null as any);
    }

    setApprovalLevelsOrder(idsInOrder?: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ApprovalLevels/setOrder?";
        if (idsInOrder === null)
            throw new Error("The parameter 'idsInOrder' cannot be null.");
        else if (idsInOrder !== undefined)
            idsInOrder && idsInOrder.forEach(item => { url_ += "idsInOrder=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetApprovalLevelsOrder(_response));
        });
    }

    protected processSetApprovalLevelsOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    archiveApprovalLevel(id: number): Promise<ApprovalLevelDetailDTO> {
        let url_ = this.baseUrl + "/ApprovalLevels/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveApprovalLevel(_response));
        });
    }

    protected processArchiveApprovalLevel(response: Response): Promise<ApprovalLevelDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalLevelDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO>(null as any);
    }

    unarchiveApprovalLevel(id: number): Promise<ApprovalLevelDetailDTO> {
        let url_ = this.baseUrl + "/ApprovalLevels/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveApprovalLevel(_response));
        });
    }

    protected processUnarchiveApprovalLevel(response: Response): Promise<ApprovalLevelDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalLevelDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalLevelDetailDTO>(null as any);
    }
}

export interface ICitiesClient {

    lookupActiveCities(search: string): Promise<CityInfoDTO[]>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class CitiesClient extends ApiClientBase implements ICitiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    lookupActiveCities(search: string): Promise<CityInfoDTO[]> {
        let url_ = this.baseUrl + "/Cities/lookup/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookupActiveCities(_response));
        });
    }

    protected processLookupActiveCities(response: Response): Promise<CityInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityInfoDTO[]>(null as any);
    }
}

export interface ICountriesClient {

    getById(id: number): Promise<CountryDetailDTO>;

    updateCountry(id: number, request: CountryUpdateDTO): Promise<CountryDetailDTO>;

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, approvalRequirement?: CountryApprovalRequirement | null | undefined, approveType?: ApproveType | null | undefined, approvalLevelId?: number | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfCountryListQueryDTO>;

    createCountry(request: CountryCreateDTO): Promise<CountryDetailDTO>;

    getAllActiveKeywords(): Promise<CountryInfoDTO[]>;

    getAllActiveCountrySettingsInfoDTOs(): Promise<CountrySettingsInfoDTO[]>;

    addCountryApprover(id: number, request: AddCountryApproverModel): Promise<CountryDetailDTO>;

    removeCountryApprover(id: number, request: RemoveCountryApproverModel): Promise<CountryDetailDTO>;

    addCountryContact(id: number, request: AddCountryContactModel): Promise<CountryDetailDTO>;

    removeCountryContact(id: number, request: RemoveCountryContactModel): Promise<CountryDetailDTO>;

    archiveCountry(id: number): Promise<CountryDetailDTO>;

    unarchiveCountry(id: number): Promise<CountryDetailDTO>;

    getCountriesOverviewReport(): Promise<FileResponse>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class CountriesClient extends ApiClientBase implements ICountriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    updateCountry(id: number, request: CountryUpdateDTO): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCountry(_response));
        });
    }

    protected processUpdateCountry(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, approvalRequirement?: CountryApprovalRequirement | null | undefined, approveType?: ApproveType | null | undefined, approvalLevelId?: number | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfCountryListQueryDTO> {
        let url_ = this.baseUrl + "/Countries?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (approvalRequirement !== undefined && approvalRequirement !== null)
            url_ += "ApprovalRequirement=" + encodeURIComponent("" + approvalRequirement) + "&";
        if (approveType !== undefined && approveType !== null)
            url_ += "ApproveType=" + encodeURIComponent("" + approveType) + "&";
        if (approvalLevelId !== undefined && approvalLevelId !== null)
            url_ += "ApprovalLevelId=" + encodeURIComponent("" + approvalLevelId) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByFilter(_response));
        });
    }

    protected processGetAllByFilter(response: Response): Promise<QueryResultOfCountryListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfCountryListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfCountryListQueryDTO>(null as any);
    }

    createCountry(request: CountryCreateDTO): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCountry(_response));
        });
    }

    protected processCreateCountry(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CountryDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<CountryInfoDTO[]> {
        let url_ = this.baseUrl + "/Countries/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<CountryInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryInfoDTO[]>(null as any);
    }

    getAllActiveCountrySettingsInfoDTOs(): Promise<CountrySettingsInfoDTO[]> {
        let url_ = this.baseUrl + "/Countries/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveCountrySettingsInfoDTOs(_response));
        });
    }

    protected processGetAllActiveCountrySettingsInfoDTOs(response: Response): Promise<CountrySettingsInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountrySettingsInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountrySettingsInfoDTO[]>(null as any);
    }

    addCountryApprover(id: number, request: AddCountryApproverModel): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/addapprover";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCountryApprover(_response));
        });
    }

    protected processAddCountryApprover(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    removeCountryApprover(id: number, request: RemoveCountryApproverModel): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/removeapprover";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCountryApprover(_response));
        });
    }

    protected processRemoveCountryApprover(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    addCountryContact(id: number, request: AddCountryContactModel): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/addcontact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCountryContact(_response));
        });
    }

    protected processAddCountryContact(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    removeCountryContact(id: number, request: RemoveCountryContactModel): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/removecontact";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCountryContact(_response));
        });
    }

    protected processRemoveCountryContact(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    archiveCountry(id: number): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveCountry(_response));
        });
    }

    protected processArchiveCountry(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    unarchiveCountry(id: number): Promise<CountryDetailDTO> {
        let url_ = this.baseUrl + "/Countries/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveCountry(_response));
        });
    }

    protected processUnarchiveCountry(response: Response): Promise<CountryDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailDTO>(null as any);
    }

    getCountriesOverviewReport(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Countries/overviewReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountriesOverviewReport(_response));
        });
    }

    protected processGetCountriesOverviewReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICountryChangeRequestsClient {

    getById(id: number): Promise<CountryChangeRequestDetailDTO>;

    createCountryChangeRequest(request: CountryChangeRequestCreateDTO): Promise<CountryChangeRequestDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class CountryChangeRequestsClient extends ApiClientBase implements ICountryChangeRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<CountryChangeRequestDetailDTO> {
        let url_ = this.baseUrl + "/CountryChangeRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CountryChangeRequestDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryChangeRequestDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryChangeRequestDetailDTO>(null as any);
    }

    createCountryChangeRequest(request: CountryChangeRequestCreateDTO): Promise<CountryChangeRequestDetailDTO> {
        let url_ = this.baseUrl + "/CountryChangeRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCountryChangeRequest(_response));
        });
    }

    protected processCreateCountryChangeRequest(response: Response): Promise<CountryChangeRequestDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CountryChangeRequestDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryChangeRequestDetailDTO>(null as any);
    }
}

export interface IDeviationRequestsClient {

    getById(id: number): Promise<DeviationRequestDetailModel>;

    updateDeviationRequest(id: number, request: DeviationRequestUpdateDTO): Promise<DeviationRequestDetailModel>;

    getForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO>;

    getEntityWides(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO>;

    getForReview(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO>;

    getReviewed(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO>;

    getAll(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO>;

    createDeviationRequest(request: DeviationRequestCreateDTO): Promise<DeviationRequestDetailModel>;

    updateDeviationAttachmentRequest(id: number, request: DeviationRequestAttachmentUpdateDTO): Promise<DeviationRequestDetailModel>;

    assignTo(id: number, request: AssignDeviationToModel): Promise<DeviationRequestDetailModel>;

    changeStatus(id: number, request: ChangeDeviationStatusModel): Promise<DeviationRequestDetailModel>;

    archiveDeviationRequest(id: number): Promise<DeviationRequestDetailModel>;

    unarchiveDeviationRequest(id: number): Promise<DeviationRequestDetailModel>;

    getAttachmentSettings(): Promise<AttachmentSettingsModel>;

    downloadAttachment(attachmentId: number): Promise<FileResponse>;

    downloadAttachment2(id: number, attachmentId: number): Promise<FileResponse>;

    uploadAttachment(file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO>;

    uploadAttachment2(id: number, file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO>;

    getWorkflowStrategy(deviationType: DeviationType, deviationWorkflowType: DeviationWorkflowType): Promise<DeviationRequestWorkflowStrategyDTO>;

    getEntityWidesReport(sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<FileResponse>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class DeviationRequestsClient extends ApiClientBase implements IDeviationRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    updateDeviationRequest(id: number, request: DeviationRequestUpdateDTO): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDeviationRequest(_response));
        });
    }

    protected processUpdateDeviationRequest(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    getForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/user?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetForCurrentUser(_response));
        });
    }

    protected processGetForCurrentUser(response: Response): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDeviationRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfDeviationRequestListQueryDTO>(null as any);
    }

    getEntityWides(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/entityWide?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityWides(_response));
        });
    }

    protected processGetEntityWides(response: Response): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDeviationRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfDeviationRequestListQueryDTO>(null as any);
    }

    getForReview(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/forReview?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetForReview(_response));
        });
    }

    protected processGetForReview(response: Response): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDeviationRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfDeviationRequestListQueryDTO>(null as any);
    }

    getReviewed(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/reviewed?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReviewed(_response));
        });
    }

    protected processGetReviewed(response: Response): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDeviationRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfDeviationRequestListQueryDTO>(null as any);
    }

    getAll(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/all?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<QueryResultOfDeviationRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDeviationRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfDeviationRequestListQueryDTO>(null as any);
    }

    createDeviationRequest(request: DeviationRequestCreateDTO): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDeviationRequest(_response));
        });
    }

    protected processCreateDeviationRequest(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DeviationRequestDetailModel.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    updateDeviationAttachmentRequest(id: number, request: DeviationRequestAttachmentUpdateDTO): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/updateAttachment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDeviationAttachmentRequest(_response));
        });
    }

    protected processUpdateDeviationAttachmentRequest(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    assignTo(id: number, request: AssignDeviationToModel): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/assignTo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignTo(_response));
        });
    }

    protected processAssignTo(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    changeStatus(id: number, request: ChangeDeviationStatusModel): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/changeStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeStatus(_response));
        });
    }

    protected processChangeStatus(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    archiveDeviationRequest(id: number): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveDeviationRequest(_response));
        });
    }

    protected processArchiveDeviationRequest(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    unarchiveDeviationRequest(id: number): Promise<DeviationRequestDetailModel> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveDeviationRequest(_response));
        });
    }

    protected processUnarchiveDeviationRequest(response: Response): Promise<DeviationRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestDetailModel>(null as any);
    }

    getAttachmentSettings(): Promise<AttachmentSettingsModel> {
        let url_ = this.baseUrl + "/DeviationRequests/attachmentSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachmentSettings(_response));
        });
    }

    protected processGetAttachmentSettings(response: Response): Promise<AttachmentSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentSettingsModel>(null as any);
    }

    downloadAttachment(attachmentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DeviationRequests/{attachmentId}/download";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadAttachment(_response));
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadAttachment2(id: number, attachmentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/{attachmentId}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadAttachment2(_response));
        });
    }

    protected processDownloadAttachment2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadAttachment(file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/uploadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachment(_response));
        });
    }

    protected processUploadAttachment(response: Response): Promise<UploadedFileDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadedFileDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadedFileDetailDTO>(null as any);
    }

    uploadAttachment2(id: number, file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/{id}/uploadAttachment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachment2(_response));
        });
    }

    protected processUploadAttachment2(response: Response): Promise<UploadedFileDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadedFileDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadedFileDetailDTO>(null as any);
    }

    getWorkflowStrategy(deviationType: DeviationType, deviationWorkflowType: DeviationWorkflowType): Promise<DeviationRequestWorkflowStrategyDTO> {
        let url_ = this.baseUrl + "/DeviationRequests/workflowStrategy/{deviationType}/{deviationWorkflowType}";
        if (deviationType === undefined || deviationType === null)
            throw new Error("The parameter 'deviationType' must be defined.");
        url_ = url_.replace("{deviationType}", encodeURIComponent("" + deviationType));
        if (deviationWorkflowType === undefined || deviationWorkflowType === null)
            throw new Error("The parameter 'deviationWorkflowType' must be defined.");
        url_ = url_.replace("{deviationWorkflowType}", encodeURIComponent("" + deviationWorkflowType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkflowStrategy(_response));
        });
    }

    protected processGetWorkflowStrategy(response: Response): Promise<DeviationRequestWorkflowStrategyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationRequestWorkflowStrategyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationRequestWorkflowStrategyDTO>(null as any);
    }

    getEntityWidesReport(sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, status?: DeviationRequestStatus | null | undefined, deviationType?: DeviationType | null | undefined, workflowType?: DeviationWorkflowType | null | undefined, detailType?: DeviationDetailType | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/DeviationRequests/entityWidesReport?";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (deviationType !== undefined && deviationType !== null)
            url_ += "DeviationType=" + encodeURIComponent("" + deviationType) + "&";
        if (workflowType !== undefined && workflowType !== null)
            url_ += "WorkflowType=" + encodeURIComponent("" + workflowType) + "&";
        if (detailType !== undefined && detailType !== null)
            url_ += "DetailType=" + encodeURIComponent("" + detailType) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEntityWidesReport(_response));
        });
    }

    protected processGetEntityWidesReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDeviationTeamsClient {

    getAll(): Promise<DeviationTeamDetailDTO[]>;

    getKeywords(): Promise<DeviationTeamInfoDTO[]>;

    updateDeviationTeam(id: number, request: DeviationTeamUpdateDTO): Promise<DeviationTeamDetailDTO>;

    addTeamMember(id: number, model: AddTeamMemberModel): Promise<DeviationTeamDetailDTO>;

    removeTeamMember(id: number, model: RemoveTeamMember): Promise<DeviationTeamDetailDTO>;

    addRegionDirector(id: number, dto: DeviationTeamRegionDirectorCreateDTO): Promise<DeviationTeamRegionDirectorDetailDTO>;

    updateRegionDirector(id: number, dto: DeviationTeamRegionDirectorUpdateDTO): Promise<DeviationTeamRegionDirectorDetailDTO>;

    archiveRegionDirector(id: number, model: ChangeActiveRegionDirector): Promise<DeviationTeamRegionDirectorDetailDTO>;

    unarchiveRegionDirector(id: number, model: ChangeActiveRegionDirector): Promise<DeviationTeamRegionDirectorDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class DeviationTeamsClient extends ApiClientBase implements IDeviationTeamsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<DeviationTeamDetailDTO[]> {
        let url_ = this.baseUrl + "/DeviationTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<DeviationTeamDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviationTeamDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamDetailDTO[]>(null as any);
    }

    getKeywords(): Promise<DeviationTeamInfoDTO[]> {
        let url_ = this.baseUrl + "/DeviationTeams/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetKeywords(_response));
        });
    }

    protected processGetKeywords(response: Response): Promise<DeviationTeamInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviationTeamInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamInfoDTO[]>(null as any);
    }

    updateDeviationTeam(id: number, request: DeviationTeamUpdateDTO): Promise<DeviationTeamDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDeviationTeam(_response));
        });
    }

    protected processUpdateDeviationTeam(response: Response): Promise<DeviationTeamDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamDetailDTO>(null as any);
    }

    addTeamMember(id: number, model: AddTeamMemberModel): Promise<DeviationTeamDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/addteammember";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddTeamMember(_response));
        });
    }

    protected processAddTeamMember(response: Response): Promise<DeviationTeamDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamDetailDTO>(null as any);
    }

    removeTeamMember(id: number, model: RemoveTeamMember): Promise<DeviationTeamDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/removeteammember";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveTeamMember(_response));
        });
    }

    protected processRemoveTeamMember(response: Response): Promise<DeviationTeamDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamDetailDTO>(null as any);
    }

    addRegionDirector(id: number, dto: DeviationTeamRegionDirectorCreateDTO): Promise<DeviationTeamRegionDirectorDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/addregiondirector";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRegionDirector(_response));
        });
    }

    protected processAddRegionDirector(response: Response): Promise<DeviationTeamRegionDirectorDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamRegionDirectorDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamRegionDirectorDetailDTO>(null as any);
    }

    updateRegionDirector(id: number, dto: DeviationTeamRegionDirectorUpdateDTO): Promise<DeviationTeamRegionDirectorDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/updateregiondirector";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRegionDirector(_response));
        });
    }

    protected processUpdateRegionDirector(response: Response): Promise<DeviationTeamRegionDirectorDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamRegionDirectorDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamRegionDirectorDetailDTO>(null as any);
    }

    archiveRegionDirector(id: number, model: ChangeActiveRegionDirector): Promise<DeviationTeamRegionDirectorDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/archiveregiondirector";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveRegionDirector(_response));
        });
    }

    protected processArchiveRegionDirector(response: Response): Promise<DeviationTeamRegionDirectorDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamRegionDirectorDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamRegionDirectorDetailDTO>(null as any);
    }

    unarchiveRegionDirector(id: number, model: ChangeActiveRegionDirector): Promise<DeviationTeamRegionDirectorDetailDTO> {
        let url_ = this.baseUrl + "/DeviationTeams/{id}/unarchiveregiondirector";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveRegionDirector(_response));
        });
    }

    protected processUnarchiveRegionDirector(response: Response): Promise<DeviationTeamRegionDirectorDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviationTeamRegionDirectorDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviationTeamRegionDirectorDetailDTO>(null as any);
    }
}

export interface IHolidayTripsClient {

    getById(id: number): Promise<HolidayTripDetailModel>;

    updateHolidayTrip(id: number, request: HolidayTripUpdateDTO): Promise<HolidayTripDetailModel>;

    getAllForAdministrator(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO>;

    getPastForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO>;

    getFutureForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO>;

    createHolidayTrip(request: HolidayTripCreateDTO): Promise<HolidayTripDetailModel>;

    archiveHolidayTrip(id: number): Promise<HolidayTripDetailModel>;

    unarchiveHolidayTrip(id: number): Promise<HolidayTripDetailModel>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class HolidayTripsClient extends ApiClientBase implements IHolidayTripsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<HolidayTripDetailModel> {
        let url_ = this.baseUrl + "/HolidayTrips/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<HolidayTripDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayTripDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayTripDetailModel>(null as any);
    }

    updateHolidayTrip(id: number, request: HolidayTripUpdateDTO): Promise<HolidayTripDetailModel> {
        let url_ = this.baseUrl + "/HolidayTrips/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateHolidayTrip(_response));
        });
    }

    protected processUpdateHolidayTrip(response: Response): Promise<HolidayTripDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayTripDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayTripDetailModel>(null as any);
    }

    getAllForAdministrator(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO> {
        let url_ = this.baseUrl + "/HolidayTrips/all?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllForAdministrator(_response));
        });
    }

    protected processGetAllForAdministrator(response: Response): Promise<QueryResultOfHolidayTripListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfHolidayTripListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfHolidayTripListQueryDTO>(null as any);
    }

    getPastForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO> {
        let url_ = this.baseUrl + "/HolidayTrips/past?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPastForCurrentUser(_response));
        });
    }

    protected processGetPastForCurrentUser(response: Response): Promise<QueryResultOfHolidayTripListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfHolidayTripListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfHolidayTripListQueryDTO>(null as any);
    }

    getFutureForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfHolidayTripListQueryDTO> {
        let url_ = this.baseUrl + "/HolidayTrips/future?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFutureForCurrentUser(_response));
        });
    }

    protected processGetFutureForCurrentUser(response: Response): Promise<QueryResultOfHolidayTripListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfHolidayTripListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfHolidayTripListQueryDTO>(null as any);
    }

    createHolidayTrip(request: HolidayTripCreateDTO): Promise<HolidayTripDetailModel> {
        let url_ = this.baseUrl + "/HolidayTrips";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateHolidayTrip(_response));
        });
    }

    protected processCreateHolidayTrip(response: Response): Promise<HolidayTripDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = HolidayTripDetailModel.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayTripDetailModel>(null as any);
    }

    archiveHolidayTrip(id: number): Promise<HolidayTripDetailModel> {
        let url_ = this.baseUrl + "/HolidayTrips/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveHolidayTrip(_response));
        });
    }

    protected processArchiveHolidayTrip(response: Response): Promise<HolidayTripDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayTripDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayTripDetailModel>(null as any);
    }

    unarchiveHolidayTrip(id: number): Promise<HolidayTripDetailModel> {
        let url_ = this.baseUrl + "/HolidayTrips/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveHolidayTrip(_response));
        });
    }

    protected processUnarchiveHolidayTrip(response: Response): Promise<HolidayTripDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HolidayTripDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HolidayTripDetailModel>(null as any);
    }
}

export interface IMapZonesClient {

    getById(id: number): Promise<MapZoneDetailDTO>;

    updateMapZone(id: number, request: MapZoneUpdateDTO): Promise<MapZoneDetailDTO>;

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfMapZoneDetailDTO>;

    createMapZone(request: MapZoneCreateDTO): Promise<MapZoneDetailDTO>;

    getAllActiveKeywords(): Promise<MapZoneInfoDTO[]>;

    archiveMapZone(id: number): Promise<MapZoneDetailDTO>;

    unarchiveMapZone(id: number): Promise<MapZoneDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class MapZonesClient extends ApiClientBase implements IMapZonesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<MapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<MapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapZoneDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneDetailDTO>(null as any);
    }

    updateMapZone(id: number, request: MapZoneUpdateDTO): Promise<MapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMapZone(_response));
        });
    }

    protected processUpdateMapZone(response: Response): Promise<MapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapZoneDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneDetailDTO>(null as any);
    }

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfMapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByFilter(_response));
        });
    }

    protected processGetAllByFilter(response: Response): Promise<QueryResultOfMapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfMapZoneDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfMapZoneDetailDTO>(null as any);
    }

    createMapZone(request: MapZoneCreateDTO): Promise<MapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMapZone(_response));
        });
    }

    protected processCreateMapZone(response: Response): Promise<MapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MapZoneDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<MapZoneInfoDTO[]> {
        let url_ = this.baseUrl + "/MapZones/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<MapZoneInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MapZoneInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneInfoDTO[]>(null as any);
    }

    archiveMapZone(id: number): Promise<MapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveMapZone(_response));
        });
    }

    protected processArchiveMapZone(response: Response): Promise<MapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapZoneDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneDetailDTO>(null as any);
    }

    unarchiveMapZone(id: number): Promise<MapZoneDetailDTO> {
        let url_ = this.baseUrl + "/MapZones/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveMapZone(_response));
        });
    }

    protected processUnarchiveMapZone(response: Response): Promise<MapZoneDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapZoneDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MapZoneDetailDTO>(null as any);
    }
}

export interface IMobileAppDashboardClient {

    getUsersLatestsLocations(): Promise<UsersLatestLocationsModel>;

    getActiveUsers(): Promise<ActiveUsersDTO[]>;

    getInstalledVersions(): Promise<InstallationInfoDTO[]>;

    getPanicRequests(): Promise<PanicRequestDTO[]>;

    getDelayedPanicRequests(): Promise<DelayedPanicRequestDTO[]>;

    getTrackingUsers(): Promise<TrackingUsersDTO[]>;

    getTrackingHourly(): Promise<TrackingHourlyDTO[]>;

    getUserLocationRequests(): Promise<UserLocationRequestDTO[]>;

    requestUserLocation(uniqueId: string): Promise<UserLocationRequestDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class MobileAppDashboardClient extends ApiClientBase implements IMobileAppDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getUsersLatestsLocations(): Promise<UsersLatestLocationsModel> {
        let url_ = this.baseUrl + "/MobileAppDashboard/latests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsersLatestsLocations(_response));
        });
    }

    protected processGetUsersLatestsLocations(response: Response): Promise<UsersLatestLocationsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersLatestLocationsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersLatestLocationsModel>(null as any);
    }

    getActiveUsers(): Promise<ActiveUsersDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/activeUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActiveUsers(_response));
        });
    }

    protected processGetActiveUsers(response: Response): Promise<ActiveUsersDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveUsersDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActiveUsersDTO[]>(null as any);
    }

    getInstalledVersions(): Promise<InstallationInfoDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/installedVersions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstalledVersions(_response));
        });
    }

    protected processGetInstalledVersions(response: Response): Promise<InstallationInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstallationInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstallationInfoDTO[]>(null as any);
    }

    getPanicRequests(): Promise<PanicRequestDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/panicRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPanicRequests(_response));
        });
    }

    protected processGetPanicRequests(response: Response): Promise<PanicRequestDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PanicRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PanicRequestDTO[]>(null as any);
    }

    getDelayedPanicRequests(): Promise<DelayedPanicRequestDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/delayedPanicRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDelayedPanicRequests(_response));
        });
    }

    protected processGetDelayedPanicRequests(response: Response): Promise<DelayedPanicRequestDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DelayedPanicRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DelayedPanicRequestDTO[]>(null as any);
    }

    getTrackingUsers(): Promise<TrackingUsersDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/trackingUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrackingUsers(_response));
        });
    }

    protected processGetTrackingUsers(response: Response): Promise<TrackingUsersDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrackingUsersDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackingUsersDTO[]>(null as any);
    }

    getTrackingHourly(): Promise<TrackingHourlyDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/trackingHourly";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrackingHourly(_response));
        });
    }

    protected processGetTrackingHourly(response: Response): Promise<TrackingHourlyDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrackingHourlyDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackingHourlyDTO[]>(null as any);
    }

    getUserLocationRequests(): Promise<UserLocationRequestDTO[]> {
        let url_ = this.baseUrl + "/MobileAppDashboard/userLocationRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserLocationRequests(_response));
        });
    }

    protected processGetUserLocationRequests(response: Response): Promise<UserLocationRequestDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLocationRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLocationRequestDTO[]>(null as any);
    }

    requestUserLocation(uniqueId: string): Promise<UserLocationRequestDTO> {
        let url_ = this.baseUrl + "/MobileAppDashboard/users/{uniqueId}/requestLocation";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestUserLocation(_response));
        });
    }

    protected processRequestUserLocation(response: Response): Promise<UserLocationRequestDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserLocationRequestDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLocationRequestDTO>(null as any);
    }
}

export interface IOrganisationEntitiesClient {

    getById(id: number): Promise<OrganisationEntityDetailDTO>;

    updateOrganisationEntity(id: number, request: OrganisationEntityUpdateDTO): Promise<OrganisationEntityDetailDTO>;

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfOrganisationEntityDetailDTO>;

    createOrganisationEntity(request: OrganisationEntityCreateDTO): Promise<OrganisationEntityDetailDTO>;

    getAllActiveKeywords(): Promise<OrganisationEntityInfoDTO[]>;

    archiveOrganisationEntity(id: number): Promise<OrganisationEntityDetailDTO>;

    unarchiveOrganisationEntity(id: number): Promise<OrganisationEntityDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class OrganisationEntitiesClient extends ApiClientBase implements IOrganisationEntitiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<OrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<OrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationEntityDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityDetailDTO>(null as any);
    }

    updateOrganisationEntity(id: number, request: OrganisationEntityUpdateDTO): Promise<OrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateOrganisationEntity(_response));
        });
    }

    protected processUpdateOrganisationEntity(response: Response): Promise<OrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationEntityDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityDetailDTO>(null as any);
    }

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfOrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByFilter(_response));
        });
    }

    protected processGetAllByFilter(response: Response): Promise<QueryResultOfOrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfOrganisationEntityDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfOrganisationEntityDetailDTO>(null as any);
    }

    createOrganisationEntity(request: OrganisationEntityCreateDTO): Promise<OrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrganisationEntity(_response));
        });
    }

    protected processCreateOrganisationEntity(response: Response): Promise<OrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrganisationEntityDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<OrganisationEntityInfoDTO[]> {
        let url_ = this.baseUrl + "/OrganisationEntities/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<OrganisationEntityInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganisationEntityInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityInfoDTO[]>(null as any);
    }

    archiveOrganisationEntity(id: number): Promise<OrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveOrganisationEntity(_response));
        });
    }

    protected processArchiveOrganisationEntity(response: Response): Promise<OrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationEntityDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityDetailDTO>(null as any);
    }

    unarchiveOrganisationEntity(id: number): Promise<OrganisationEntityDetailDTO> {
        let url_ = this.baseUrl + "/OrganisationEntities/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveOrganisationEntity(_response));
        });
    }

    protected processUnarchiveOrganisationEntity(response: Response): Promise<OrganisationEntityDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationEntityDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationEntityDetailDTO>(null as any);
    }
}

export interface IQuestionsClient {

    getById(id: number): Promise<QuestionDetailDTO>;

    updateQuestion(id: number, request: QuestionUpdateDTO): Promise<QuestionDetailDTO>;

    getAll(): Promise<QuestionDetailDTO[]>;

    createQuestion(request: QuestionCreateDTO): Promise<QuestionDetailDTO>;

    getAllActiveKeywords(): Promise<QuestionInfoDTO[]>;

    addQuestionCountry(id: number, model: QuestionCountryModel): Promise<QuestionDetailDTO>;

    removeQuestionCountry(id: number, model: QuestionCountryModel): Promise<QuestionDetailDTO>;

    archiveQuestion(id: number): Promise<QuestionDetailDTO>;

    unarchiveQuestion(id: number): Promise<QuestionDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class QuestionsClient extends ApiClientBase implements IQuestionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    updateQuestion(id: number, request: QuestionUpdateDTO): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateQuestion(_response));
        });
    }

    protected processUpdateQuestion(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    getAll(): Promise<QuestionDetailDTO[]> {
        let url_ = this.baseUrl + "/Questions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<QuestionDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO[]>(null as any);
    }

    createQuestion(request: QuestionCreateDTO): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateQuestion(_response));
        });
    }

    protected processCreateQuestion(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = QuestionDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<QuestionInfoDTO[]> {
        let url_ = this.baseUrl + "/Questions/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<QuestionInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionInfoDTO[]>(null as any);
    }

    addQuestionCountry(id: number, model: QuestionCountryModel): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}/addcountry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddQuestionCountry(_response));
        });
    }

    protected processAddQuestionCountry(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    removeQuestionCountry(id: number, model: QuestionCountryModel): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}/removecountry";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveQuestionCountry(_response));
        });
    }

    protected processRemoveQuestionCountry(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    archiveQuestion(id: number): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveQuestion(_response));
        });
    }

    protected processArchiveQuestion(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }

    unarchiveQuestion(id: number): Promise<QuestionDetailDTO> {
        let url_ = this.baseUrl + "/Questions/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveQuestion(_response));
        });
    }

    protected processUnarchiveQuestion(response: Response): Promise<QuestionDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDetailDTO>(null as any);
    }
}

export interface ISitesClient {

    getAllActiveKeywords(): Promise<SiteInfoDTO[]>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class SitesClient extends ApiClientBase implements ISitesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAllActiveKeywords(): Promise<SiteInfoDTO[]> {
        let url_ = this.baseUrl + "/Sites/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<SiteInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteInfoDTO[]>(null as any);
    }
}

export interface ISystemsClient {

    getEnums(): Promise<EnumsModelDTO>;

    getFeatures(): Promise<FeaturesModelDTO>;

    getApiVersion(): Promise<string>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class SystemsClient extends ApiClientBase implements ISystemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getEnums(): Promise<EnumsModelDTO> {
        let url_ = this.baseUrl + "/Systems/enums";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEnums(_response));
        });
    }

    protected processGetEnums(response: Response): Promise<EnumsModelDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnumsModelDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnumsModelDTO>(null as any);
    }

    getFeatures(): Promise<FeaturesModelDTO> {
        let url_ = this.baseUrl + "/Systems/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFeatures(_response));
        });
    }

    protected processGetFeatures(response: Response): Promise<FeaturesModelDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeaturesModelDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeaturesModelDTO>(null as any);
    }

    getApiVersion(): Promise<string> {
        let url_ = this.baseUrl + "/Systems/api-version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetApiVersion(_response));
        });
    }

    protected processGetApiVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISystemUsersClient {

    getById(id: number): Promise<SystemUserDetailDTO>;

    updateSystemUser(id: number, request: SystemUserUpdateDTO): Promise<SystemUserDetailDTO>;

    getCurrentUser(): Promise<SystemUserDetailDTO>;

    lookupADUsers(search: string): Promise<ADUserSearchResult[]>;

    getCountryUser(uniqueId: string): Promise<SystemUserCountryRoleInfoModel>;

    getAllCountriesUsers(): Promise<SystemUserCountryRoleInfoModel[]>;

    getAllAdministrators(): Promise<SystemUserContactInfoDTO[]>;

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, systemRoles?: SystemRole | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfSystemUserDetailDTO>;

    transferCountryUserRoles(id: number, request: TransferCountryUserModel): Promise<SystemUserCountryRoleInfoModel>;

    addAdministrator(uniqueId: string): Promise<SystemUserDetailDTO>;

    removeAdministrator(id: number): Promise<SystemUserDetailDTO>;

    addApproverDelegate(id: number, model: AddApproverDelegateModel): Promise<SystemUserDetailDTO>;

    removeApproverDelegate(id: number, model: RemoveApproverDelegateModel): Promise<SystemUserDetailDTO>;

    addDelegateApprover(id: number, model: AddDelegateApproverModel): Promise<SystemUserDetailDTO>;

    removeDelegateApprover(id: number, model: RemoveDelegateApproverModel): Promise<SystemUserDetailDTO>;

    archiveSystemUser(id: number): Promise<SystemUserDetailDTO>;

    unarchiveSystemUser(id: number): Promise<SystemUserDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class SystemUsersClient extends ApiClientBase implements ISystemUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    updateSystemUser(id: number, request: SystemUserUpdateDTO): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSystemUser(_response));
        });
    }

    protected processUpdateSystemUser(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    getCurrentUser(): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrentUser(_response));
        });
    }

    protected processGetCurrentUser(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    lookupADUsers(search: string): Promise<ADUserSearchResult[]> {
        let url_ = this.baseUrl + "/SystemUsers/lookupADUsers/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLookupADUsers(_response));
        });
    }

    protected processLookupADUsers(response: Response): Promise<ADUserSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ADUserSearchResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ADUserSearchResult[]>(null as any);
    }

    getCountryUser(uniqueId: string): Promise<SystemUserCountryRoleInfoModel> {
        let url_ = this.baseUrl + "/SystemUsers/countriesusers/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountryUser(_response));
        });
    }

    protected processGetCountryUser(response: Response): Promise<SystemUserCountryRoleInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserCountryRoleInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserCountryRoleInfoModel>(null as any);
    }

    getAllCountriesUsers(): Promise<SystemUserCountryRoleInfoModel[]> {
        let url_ = this.baseUrl + "/SystemUsers/countriesusers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCountriesUsers(_response));
        });
    }

    protected processGetAllCountriesUsers(response: Response): Promise<SystemUserCountryRoleInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUserCountryRoleInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserCountryRoleInfoModel[]>(null as any);
    }

    getAllAdministrators(): Promise<SystemUserContactInfoDTO[]> {
        let url_ = this.baseUrl + "/SystemUsers/administrators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAdministrators(_response));
        });
    }

    protected processGetAllAdministrators(response: Response): Promise<SystemUserContactInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserContactInfoDTO[]>(null as any);
    }

    getAllByFilter(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, systemRoles?: SystemRole | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfSystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (systemRoles !== undefined && systemRoles !== null)
            url_ += "SystemRoles=" + encodeURIComponent("" + systemRoles) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllByFilter(_response));
        });
    }

    protected processGetAllByFilter(response: Response): Promise<QueryResultOfSystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfSystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfSystemUserDetailDTO>(null as any);
    }

    transferCountryUserRoles(id: number, request: TransferCountryUserModel): Promise<SystemUserCountryRoleInfoModel> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/transfercountryuserroles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransferCountryUserRoles(_response));
        });
    }

    protected processTransferCountryUserRoles(response: Response): Promise<SystemUserCountryRoleInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserCountryRoleInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserCountryRoleInfoModel>(null as any);
    }

    addAdministrator(uniqueId: string): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{uniqueId}/addadministrator";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddAdministrator(_response));
        });
    }

    protected processAddAdministrator(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    removeAdministrator(id: number): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/removeadministrator";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveAdministrator(_response));
        });
    }

    protected processRemoveAdministrator(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    addApproverDelegate(id: number, model: AddApproverDelegateModel): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/addapproverdelegate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddApproverDelegate(_response));
        });
    }

    protected processAddApproverDelegate(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    removeApproverDelegate(id: number, model: RemoveApproverDelegateModel): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/removeapproverdelegate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveApproverDelegate(_response));
        });
    }

    protected processRemoveApproverDelegate(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    addDelegateApprover(id: number, model: AddDelegateApproverModel): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/adddelegateapprover";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddDelegateApprover(_response));
        });
    }

    protected processAddDelegateApprover(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    removeDelegateApprover(id: number, model: RemoveDelegateApproverModel): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/removedelegateapprover";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveDelegateApprover(_response));
        });
    }

    protected processRemoveDelegateApprover(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    archiveSystemUser(id: number): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveSystemUser(_response));
        });
    }

    protected processArchiveSystemUser(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }

    unarchiveSystemUser(id: number): Promise<SystemUserDetailDTO> {
        let url_ = this.baseUrl + "/SystemUsers/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveSystemUser(_response));
        });
    }

    protected processUnarchiveSystemUser(response: Response): Promise<SystemUserDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemUserDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemUserDetailDTO>(null as any);
    }
}

export interface ITransportationTypesClient {

    getById(id: number): Promise<TransportationTypeDetailDTO>;

    updateTransportationType(id: number, request: TransportationTypeUpdateDTO): Promise<TransportationTypeDetailDTO>;

    getAll(): Promise<TransportationTypeDetailDTO[]>;

    createTransportationType(request: TransportationTypeCreateDTO): Promise<TransportationTypeDetailDTO>;

    getAllActiveKeywords(): Promise<TransportationTypeInfoDTO[]>;

    setTransportationTypesOrder(idsInOrder?: number[] | undefined): Promise<void>;

    archiveTransportationType(id: number): Promise<TransportationTypeDetailDTO>;

    unarchiveTransportationType(id: number): Promise<TransportationTypeDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class TransportationTypesClient extends ApiClientBase implements ITransportationTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<TransportationTypeDetailDTO> {
        let url_ = this.baseUrl + "/TransportationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<TransportationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO>(null as any);
    }

    updateTransportationType(id: number, request: TransportationTypeUpdateDTO): Promise<TransportationTypeDetailDTO> {
        let url_ = this.baseUrl + "/TransportationTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTransportationType(_response));
        });
    }

    protected processUpdateTransportationType(response: Response): Promise<TransportationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO>(null as any);
    }

    getAll(): Promise<TransportationTypeDetailDTO[]> {
        let url_ = this.baseUrl + "/TransportationTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<TransportationTypeDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportationTypeDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO[]>(null as any);
    }

    createTransportationType(request: TransportationTypeCreateDTO): Promise<TransportationTypeDetailDTO> {
        let url_ = this.baseUrl + "/TransportationTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTransportationType(_response));
        });
    }

    protected processCreateTransportationType(response: Response): Promise<TransportationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TransportationTypeDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<TransportationTypeInfoDTO[]> {
        let url_ = this.baseUrl + "/TransportationTypes/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<TransportationTypeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransportationTypeInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeInfoDTO[]>(null as any);
    }

    setTransportationTypesOrder(idsInOrder?: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TransportationTypes/setOrder?";
        if (idsInOrder === null)
            throw new Error("The parameter 'idsInOrder' cannot be null.");
        else if (idsInOrder !== undefined)
            idsInOrder && idsInOrder.forEach(item => { url_ += "idsInOrder=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetTransportationTypesOrder(_response));
        });
    }

    protected processSetTransportationTypesOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    archiveTransportationType(id: number): Promise<TransportationTypeDetailDTO> {
        let url_ = this.baseUrl + "/TransportationTypes/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveTransportationType(_response));
        });
    }

    protected processArchiveTransportationType(response: Response): Promise<TransportationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO>(null as any);
    }

    unarchiveTransportationType(id: number): Promise<TransportationTypeDetailDTO> {
        let url_ = this.baseUrl + "/TransportationTypes/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveTransportationType(_response));
        });
    }

    protected processUnarchiveTransportationType(response: Response): Promise<TransportationTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportationTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransportationTypeDetailDTO>(null as any);
    }
}

export interface ITravelRequestsClient {

    getById(id: number): Promise<TravelRequestDetailModel>;

    updateTravelRequest(id: number, request: TravelRequestUpdateDTO): Promise<TravelRequestDetailModel>;

    getAllForAdministrator(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO>;

    getToReviewForApprover(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO>;

    getReviewedForApprover(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO>;

    getPastForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO>;

    getFutureForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO>;

    createTravelRequest(request: TravelRequestCreateDTO): Promise<TravelRequestDetailModel>;

    changeApproverApprovalStatus(id: number, request: ChangeApproverApprovalStatusModel): Promise<TravelRequestDetailModel>;

    archiveTravelRequest(id: number): Promise<TravelRequestDetailModel>;

    unarchiveTravelRequest(id: number): Promise<TravelRequestDetailModel>;

    getAttachmentSettings(): Promise<AttachmentSettingsModel>;

    downloadAttachment(attachmentId: number): Promise<FileResponse>;

    downloadAttachmentFromTravelRequest(id: number, attachmentId: number): Promise<FileResponse>;

    uploadAttachment(file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO>;

    uploadAttachmentToTravelRequest(id: number, file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class TravelRequestsClient extends ApiClientBase implements ITravelRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    updateTravelRequest(id: number, request: TravelRequestUpdateDTO): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTravelRequest(_response));
        });
    }

    protected processUpdateTravelRequest(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    getAllForAdministrator(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO> {
        let url_ = this.baseUrl + "/TravelRequests/all?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllForAdministrator(_response));
        });
    }

    protected processGetAllForAdministrator(response: Response): Promise<QueryResultOfTravelRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfTravelRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfTravelRequestListQueryDTO>(null as any);
    }

    getToReviewForApprover(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO> {
        let url_ = this.baseUrl + "/TravelRequests/toreview?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetToReviewForApprover(_response));
        });
    }

    protected processGetToReviewForApprover(response: Response): Promise<QueryResultOfTravelRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfTravelRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfTravelRequestListQueryDTO>(null as any);
    }

    getReviewedForApprover(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO> {
        let url_ = this.baseUrl + "/TravelRequests/reviewed?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReviewedForApprover(_response));
        });
    }

    protected processGetReviewedForApprover(response: Response): Promise<QueryResultOfTravelRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfTravelRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfTravelRequestListQueryDTO>(null as any);
    }

    getPastForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO> {
        let url_ = this.baseUrl + "/TravelRequests/past?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPastForCurrentUser(_response));
        });
    }

    protected processGetPastForCurrentUser(response: Response): Promise<QueryResultOfTravelRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfTravelRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfTravelRequestListQueryDTO>(null as any);
    }

    getFutureForCurrentUser(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, dateFrom?: string | null | undefined, dateTo?: string | null | undefined, approvalStatus?: ApprovalStatus | null | undefined, search?: string | null | undefined, isActive?: boolean | null | undefined): Promise<QueryResultOfTravelRequestListQueryDTO> {
        let url_ = this.baseUrl + "/TravelRequests/future?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (approvalStatus !== undefined && approvalStatus !== null)
            url_ += "ApprovalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (search !== undefined && search !== null)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFutureForCurrentUser(_response));
        });
    }

    protected processGetFutureForCurrentUser(response: Response): Promise<QueryResultOfTravelRequestListQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfTravelRequestListQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResultOfTravelRequestListQueryDTO>(null as any);
    }

    createTravelRequest(request: TravelRequestCreateDTO): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTravelRequest(_response));
        });
    }

    protected processCreateTravelRequest(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TravelRequestDetailModel.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    changeApproverApprovalStatus(id: number, request: ChangeApproverApprovalStatusModel): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests/{id}/changeApproverApprovalStatus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeApproverApprovalStatus(_response));
        });
    }

    protected processChangeApproverApprovalStatus(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    archiveTravelRequest(id: number): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveTravelRequest(_response));
        });
    }

    protected processArchiveTravelRequest(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    unarchiveTravelRequest(id: number): Promise<TravelRequestDetailModel> {
        let url_ = this.baseUrl + "/TravelRequests/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveTravelRequest(_response));
        });
    }

    protected processUnarchiveTravelRequest(response: Response): Promise<TravelRequestDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestDetailModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestDetailModel>(null as any);
    }

    getAttachmentSettings(): Promise<AttachmentSettingsModel> {
        let url_ = this.baseUrl + "/TravelRequests/attachmentSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAttachmentSettings(_response));
        });
    }

    protected processGetAttachmentSettings(response: Response): Promise<AttachmentSettingsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentSettingsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentSettingsModel>(null as any);
    }

    downloadAttachment(attachmentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TravelRequests/{attachmentId}/download";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadAttachment(_response));
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadAttachmentFromTravelRequest(id: number, attachmentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/TravelRequests/{id}/{attachmentId}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadAttachmentFromTravelRequest(_response));
        });
    }

    protected processDownloadAttachmentFromTravelRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadAttachment(file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO> {
        let url_ = this.baseUrl + "/TravelRequests/uploadAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachment(_response));
        });
    }

    protected processUploadAttachment(response: Response): Promise<UploadedFileDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadedFileDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadedFileDetailDTO>(null as any);
    }

    uploadAttachmentToTravelRequest(id: number, file?: FileParameter | null | undefined): Promise<UploadedFileDetailDTO> {
        let url_ = this.baseUrl + "/TravelRequests/{id}/uploadAttachment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadAttachmentToTravelRequest(_response));
        });
    }

    protected processUploadAttachmentToTravelRequest(response: Response): Promise<UploadedFileDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadedFileDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadedFileDetailDTO>(null as any);
    }
}

export interface ITravelTypesClient {

    getById(id: number): Promise<TravelTypeDetailDTO>;

    updateTravelType(id: number, request: TravelTypeUpdateDTO): Promise<TravelTypeDetailDTO>;

    getAll(): Promise<TravelTypeDetailDTO[]>;

    createTravelType(request: TravelTypeCreateDTO): Promise<TravelTypeDetailDTO>;

    getAllActiveKeywords(): Promise<TravelTypeInfoDTO[]>;

    setTravelTypesOrder(idsInOrder?: number[] | undefined): Promise<void>;

    archiveTravelType(id: number): Promise<TravelTypeDetailDTO>;

    unarchiveTravelType(id: number): Promise<TravelTypeDetailDTO>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class TravelTypesClient extends ApiClientBase implements ITravelTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getById(id: number): Promise<TravelTypeDetailDTO> {
        let url_ = this.baseUrl + "/TravelTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<TravelTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO>(null as any);
    }

    updateTravelType(id: number, request: TravelTypeUpdateDTO): Promise<TravelTypeDetailDTO> {
        let url_ = this.baseUrl + "/TravelTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateTravelType(_response));
        });
    }

    protected processUpdateTravelType(response: Response): Promise<TravelTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO>(null as any);
    }

    getAll(): Promise<TravelTypeDetailDTO[]> {
        let url_ = this.baseUrl + "/TravelTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<TravelTypeDetailDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TravelTypeDetailDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO[]>(null as any);
    }

    createTravelType(request: TravelTypeCreateDTO): Promise<TravelTypeDetailDTO> {
        let url_ = this.baseUrl + "/TravelTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTravelType(_response));
        });
    }

    protected processCreateTravelType(response: Response): Promise<TravelTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TravelTypeDetailDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO>(null as any);
    }

    getAllActiveKeywords(): Promise<TravelTypeInfoDTO[]> {
        let url_ = this.baseUrl + "/TravelTypes/keywords";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllActiveKeywords(_response));
        });
    }

    protected processGetAllActiveKeywords(response: Response): Promise<TravelTypeInfoDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TravelTypeInfoDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeInfoDTO[]>(null as any);
    }

    setTravelTypesOrder(idsInOrder?: number[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/TravelTypes/setOrder?";
        if (idsInOrder === null)
            throw new Error("The parameter 'idsInOrder' cannot be null.");
        else if (idsInOrder !== undefined)
            idsInOrder && idsInOrder.forEach(item => { url_ += "idsInOrder=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetTravelTypesOrder(_response));
        });
    }

    protected processSetTravelTypesOrder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    archiveTravelType(id: number): Promise<TravelTypeDetailDTO> {
        let url_ = this.baseUrl + "/TravelTypes/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArchiveTravelType(_response));
        });
    }

    protected processArchiveTravelType(response: Response): Promise<TravelTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO>(null as any);
    }

    unarchiveTravelType(id: number): Promise<TravelTypeDetailDTO> {
        let url_ = this.baseUrl + "/TravelTypes/{id}/unarchive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnarchiveTravelType(_response));
        });
    }

    protected processUnarchiveTravelType(response: Response): Promise<TravelTypeDetailDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelTypeDetailDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelTypeDetailDTO>(null as any);
    }
}

export interface IUsersLocationsClient {

    getFeatures(): Promise<UsersLocationsFeaturesModelDTO>;

    getNewUsersLatestLocationsSearch(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, userUniqueId?: string | null | undefined, userSearch?: string | null | undefined, countryId?: number | null | undefined, mapZoneId?: number | null | undefined, insideMapZone?: boolean | null | undefined, siteId?: number | null | undefined, selectedLocation_Latitude?: number | undefined, selectedLocation_Longitude?: number | undefined, distanceFromSiteInMeters?: number | null | undefined, locationCurrentnessStatus?: LocationCurrentnessStatus | null | undefined): Promise<UsersLocationsModel>;

    loadFromUsersLatestLocationQuery(searchUniqueId: string, loadMapRecords?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined): Promise<UsersLocationsModel>;

    invalidateQueryCache(searchUniqueId?: string | undefined): Promise<void>;

    requestUsersLocations(model: UsersLocationsRequestModel): Promise<UserLocationRequestDTO[]>;

    sendUserLocationEmails(model: UserLocationEmailsModel): Promise<void>;
}

@inject(ApiClientConfiguration, String, HttpClient)
export class UsersLocationsClient extends ApiClientBase implements IUsersLocationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfiguration, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getFeatures(): Promise<UsersLocationsFeaturesModelDTO> {
        let url_ = this.baseUrl + "/UsersLocations/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFeatures(_response));
        });
    }

    protected processGetFeatures(response: Response): Promise<UsersLocationsFeaturesModelDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersLocationsFeaturesModelDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersLocationsFeaturesModelDTO>(null as any);
    }

    getNewUsersLatestLocationsSearch(offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined, userUniqueId?: string | null | undefined, userSearch?: string | null | undefined, countryId?: number | null | undefined, mapZoneId?: number | null | undefined, insideMapZone?: boolean | null | undefined, siteId?: number | null | undefined, selectedLocation_Latitude?: number | undefined, selectedLocation_Longitude?: number | undefined, distanceFromSiteInMeters?: number | null | undefined, locationCurrentnessStatus?: LocationCurrentnessStatus | null | undefined): Promise<UsersLocationsModel> {
        let url_ = this.baseUrl + "/UsersLocations/search?";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        if (userUniqueId !== undefined && userUniqueId !== null)
            url_ += "UserUniqueId=" + encodeURIComponent("" + userUniqueId) + "&";
        if (userSearch !== undefined && userSearch !== null)
            url_ += "UserSearch=" + encodeURIComponent("" + userSearch) + "&";
        if (countryId !== undefined && countryId !== null)
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&";
        if (mapZoneId !== undefined && mapZoneId !== null)
            url_ += "MapZoneId=" + encodeURIComponent("" + mapZoneId) + "&";
        if (insideMapZone !== undefined && insideMapZone !== null)
            url_ += "InsideMapZone=" + encodeURIComponent("" + insideMapZone) + "&";
        if (siteId !== undefined && siteId !== null)
            url_ += "SiteId=" + encodeURIComponent("" + siteId) + "&";
        if (selectedLocation_Latitude === null)
            throw new Error("The parameter 'selectedLocation_Latitude' cannot be null.");
        else if (selectedLocation_Latitude !== undefined)
            url_ += "SelectedLocation.Latitude=" + encodeURIComponent("" + selectedLocation_Latitude) + "&";
        if (selectedLocation_Longitude === null)
            throw new Error("The parameter 'selectedLocation_Longitude' cannot be null.");
        else if (selectedLocation_Longitude !== undefined)
            url_ += "SelectedLocation.Longitude=" + encodeURIComponent("" + selectedLocation_Longitude) + "&";
        if (distanceFromSiteInMeters !== undefined && distanceFromSiteInMeters !== null)
            url_ += "DistanceFromSiteInMeters=" + encodeURIComponent("" + distanceFromSiteInMeters) + "&";
        if (locationCurrentnessStatus !== undefined && locationCurrentnessStatus !== null)
            url_ += "LocationCurrentnessStatus=" + encodeURIComponent("" + locationCurrentnessStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNewUsersLatestLocationsSearch(_response));
        });
    }

    protected processGetNewUsersLatestLocationsSearch(response: Response): Promise<UsersLocationsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersLocationsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersLocationsModel>(null as any);
    }

    loadFromUsersLatestLocationQuery(searchUniqueId: string, loadMapRecords?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortExpression?: string | null | undefined): Promise<UsersLocationsModel> {
        let url_ = this.baseUrl + "/UsersLocations/load/{searchUniqueId}?";
        if (searchUniqueId === undefined || searchUniqueId === null)
            throw new Error("The parameter 'searchUniqueId' must be defined.");
        url_ = url_.replace("{searchUniqueId}", encodeURIComponent("" + searchUniqueId));
        if (loadMapRecords === null)
            throw new Error("The parameter 'loadMapRecords' cannot be null.");
        else if (loadMapRecords !== undefined)
            url_ += "loadMapRecords=" + encodeURIComponent("" + loadMapRecords) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (sortExpression !== undefined && sortExpression !== null)
            url_ += "sortExpression=" + encodeURIComponent("" + sortExpression) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadFromUsersLatestLocationQuery(_response));
        });
    }

    protected processLoadFromUsersLatestLocationQuery(response: Response): Promise<UsersLocationsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersLocationsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersLocationsModel>(null as any);
    }

    invalidateQueryCache(searchUniqueId?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/UsersLocations/invalidateSearch?";
        if (searchUniqueId === null)
            throw new Error("The parameter 'searchUniqueId' cannot be null.");
        else if (searchUniqueId !== undefined)
            url_ += "searchUniqueId=" + encodeURIComponent("" + searchUniqueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidateQueryCache(_response));
        });
    }

    protected processInvalidateQueryCache(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    requestUsersLocations(model: UsersLocationsRequestModel): Promise<UserLocationRequestDTO[]> {
        let url_ = this.baseUrl + "/UsersLocations/requestUsersLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestUsersLocations(_response));
        });
    }

    protected processRequestUsersLocations(response: Response): Promise<UserLocationRequestDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLocationRequestDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserLocationRequestDTO[]>(null as any);
    }

    sendUserLocationEmails(model: UserLocationEmailsModel): Promise<void> {
        let url_ = this.baseUrl + "/UsersLocations/sendUserLocationEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendUserLocationEmails(_response));
        });
    }

    protected processSendUserLocationEmails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export abstract class EntityDTO implements IEntityDTO {
    id!: number;

    constructor(data?: IEntityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): EntityDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }

    clone(): EntityDTO {
        throw new Error("The abstract class 'EntityDTO' cannot be instantiated.");
    }
}

export interface IEntityDTO {
    id: number;
}

export abstract class ArchivableEntityDetailDTO extends EntityDTO implements IArchivableEntityDetailDTO {
    archivedOn!: string | null;
    archivedBy!: SystemUserInfoDTO | null;
    isActive!: boolean;

    constructor(data?: IArchivableEntityDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.archivedOn = _data["archivedOn"] !== undefined ? _data["archivedOn"] : <any>null;
            this.archivedBy = _data["archivedBy"] ? SystemUserInfoDTO.fromJS(_data["archivedBy"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableEntityDetailDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableEntityDetailDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archivedOn"] = this.archivedOn !== undefined ? this.archivedOn : <any>null;
        data["archivedBy"] = this.archivedBy ? this.archivedBy.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableEntityDetailDTO {
        throw new Error("The abstract class 'ArchivableEntityDetailDTO' cannot be instantiated.");
    }
}

export interface IArchivableEntityDetailDTO extends IEntityDTO {
    archivedOn: string | null;
    archivedBy: SystemUserInfoDTO | null;
    isActive: boolean;
}

export abstract class ArchivableKeywordDetailDTO extends ArchivableEntityDetailDTO implements IArchivableKeywordDetailDTO {
    name!: string;

    constructor(data?: IArchivableKeywordDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableKeywordDetailDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableKeywordDetailDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableKeywordDetailDTO {
        throw new Error("The abstract class 'ArchivableKeywordDetailDTO' cannot be instantiated.");
    }
}

export interface IArchivableKeywordDetailDTO extends IArchivableEntityDetailDTO {
    name: string;
}

export abstract class ArchivableIconKeywordDetailDTO extends ArchivableKeywordDetailDTO implements IArchivableIconKeywordDetailDTO {
    icon!: string | null;

    constructor(data?: IArchivableIconKeywordDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableIconKeywordDetailDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableIconKeywordDetailDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableIconKeywordDetailDTO {
        throw new Error("The abstract class 'ArchivableIconKeywordDetailDTO' cannot be instantiated.");
    }
}

export interface IArchivableIconKeywordDetailDTO extends IArchivableKeywordDetailDTO {
    icon: string | null;
}

export class AccommodationTypeDetailDTO extends ArchivableIconKeywordDetailDTO implements IAccommodationTypeDetailDTO {
    isForTravelRequest!: boolean;
    isForHolidayTrip!: boolean;

    constructor(data?: IAccommodationTypeDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isForTravelRequest = _data["isForTravelRequest"] !== undefined ? _data["isForTravelRequest"] : <any>null;
            this.isForHolidayTrip = _data["isForHolidayTrip"] !== undefined ? _data["isForHolidayTrip"] : <any>null;
        }
    }

    static fromJS(data: any): AccommodationTypeDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccommodationTypeDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isForTravelRequest"] = this.isForTravelRequest !== undefined ? this.isForTravelRequest : <any>null;
        data["isForHolidayTrip"] = this.isForHolidayTrip !== undefined ? this.isForHolidayTrip : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AccommodationTypeDetailDTO {
        const json = this.toJSON();
        let result = new AccommodationTypeDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IAccommodationTypeDetailDTO extends IArchivableIconKeywordDetailDTO {
    isForTravelRequest: boolean;
    isForHolidayTrip: boolean;
}

export class SystemUserInfoDTO extends EntityDTO implements ISystemUserInfoDTO {
    uniqueId!: string;
    loginName!: string | null;
    firstName!: string | null;
    lastName!: string | null;
    fullName!: string;
    initials!: string;

    constructor(data?: ISystemUserInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : <any>null;
            this.loginName = _data["loginName"] !== undefined ? _data["loginName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.initials = _data["initials"] !== undefined ? _data["initials"] : <any>null;
        }
    }

    static fromJS(data: any): SystemUserInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : <any>null;
        data["loginName"] = this.loginName !== undefined ? this.loginName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["initials"] = this.initials !== undefined ? this.initials : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SystemUserInfoDTO {
        const json = this.toJSON();
        let result = new SystemUserInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISystemUserInfoDTO extends IEntityDTO {
    uniqueId: string;
    loginName: string | null;
    firstName: string | null;
    lastName: string | null;
    fullName: string;
    initials: string;
}

export abstract class ArchivableEntityInfoDTO extends EntityDTO implements IArchivableEntityInfoDTO {
    isActive!: boolean;

    constructor(data?: IArchivableEntityInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableEntityInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableEntityInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableEntityInfoDTO {
        throw new Error("The abstract class 'ArchivableEntityInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableEntityInfoDTO extends IEntityDTO {
    isActive: boolean;
}

export abstract class ArchivableKeywordInfoDTO extends ArchivableEntityInfoDTO implements IArchivableKeywordInfoDTO {
    name!: string;

    constructor(data?: IArchivableKeywordInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableKeywordInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableKeywordInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableKeywordInfoDTO {
        throw new Error("The abstract class 'ArchivableKeywordInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableKeywordInfoDTO extends IArchivableEntityInfoDTO {
    name: string;
}

export abstract class ArchivableIconKeywordInfoDTO extends ArchivableKeywordInfoDTO implements IArchivableIconKeywordInfoDTO {
    icon!: string | null;

    constructor(data?: IArchivableIconKeywordInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableIconKeywordInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableIconKeywordInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableIconKeywordInfoDTO {
        throw new Error("The abstract class 'ArchivableIconKeywordInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableIconKeywordInfoDTO extends IArchivableKeywordInfoDTO {
    icon: string | null;
}

export abstract class ArchivableOrderIconKeywordInfoDTO extends ArchivableIconKeywordInfoDTO implements IArchivableOrderIconKeywordInfoDTO {
    order!: number;

    constructor(data?: IArchivableOrderIconKeywordInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableOrderIconKeywordInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableOrderIconKeywordInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableOrderIconKeywordInfoDTO {
        throw new Error("The abstract class 'ArchivableOrderIconKeywordInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableOrderIconKeywordInfoDTO extends IArchivableIconKeywordInfoDTO {
    order: number;
}

export class AccommodationTypeInfoDTO extends ArchivableOrderIconKeywordInfoDTO implements IAccommodationTypeInfoDTO {
    isForTravelRequest!: boolean;
    isForHolidayTrip!: boolean;

    constructor(data?: IAccommodationTypeInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isForTravelRequest = _data["isForTravelRequest"] !== undefined ? _data["isForTravelRequest"] : <any>null;
            this.isForHolidayTrip = _data["isForHolidayTrip"] !== undefined ? _data["isForHolidayTrip"] : <any>null;
        }
    }

    static fromJS(data: any): AccommodationTypeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccommodationTypeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isForTravelRequest"] = this.isForTravelRequest !== undefined ? this.isForTravelRequest : <any>null;
        data["isForHolidayTrip"] = this.isForHolidayTrip !== undefined ? this.isForHolidayTrip : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AccommodationTypeInfoDTO {
        const json = this.toJSON();
        let result = new AccommodationTypeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IAccommodationTypeInfoDTO extends IArchivableOrderIconKeywordInfoDTO {
    isForTravelRequest: boolean;
    isForHolidayTrip: boolean;
}

export abstract class KeywordUpdateBaseDTO implements IKeywordUpdateBaseDTO {
    name!: string;

    constructor(data?: IKeywordUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): KeywordUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'KeywordUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): KeywordUpdateBaseDTO {
        throw new Error("The abstract class 'KeywordUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IKeywordUpdateBaseDTO {
    name: string;
}

export abstract class IconKeywordUpdateBaseDTO extends KeywordUpdateBaseDTO implements IIconKeywordUpdateBaseDTO {
    icon!: string | null;

    constructor(data?: IIconKeywordUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): IconKeywordUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IconKeywordUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): IconKeywordUpdateBaseDTO {
        throw new Error("The abstract class 'IconKeywordUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IIconKeywordUpdateBaseDTO extends IKeywordUpdateBaseDTO {
    icon: string | null;
}

export class AccommodationTypeUpdateBaseDTO extends IconKeywordUpdateBaseDTO implements IAccommodationTypeUpdateBaseDTO {
    isForTravelRequest!: boolean;
    isForHolidayTrip!: boolean;

    constructor(data?: IAccommodationTypeUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isForTravelRequest = _data["isForTravelRequest"] !== undefined ? _data["isForTravelRequest"] : <any>null;
            this.isForHolidayTrip = _data["isForHolidayTrip"] !== undefined ? _data["isForHolidayTrip"] : <any>null;
        }
    }

    static fromJS(data: any): AccommodationTypeUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccommodationTypeUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isForTravelRequest"] = this.isForTravelRequest !== undefined ? this.isForTravelRequest : <any>null;
        data["isForHolidayTrip"] = this.isForHolidayTrip !== undefined ? this.isForHolidayTrip : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AccommodationTypeUpdateBaseDTO {
        const json = this.toJSON();
        let result = new AccommodationTypeUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IAccommodationTypeUpdateBaseDTO extends IIconKeywordUpdateBaseDTO {
    isForTravelRequest: boolean;
    isForHolidayTrip: boolean;
}

export class AccommodationTypeCreateDTO extends AccommodationTypeUpdateBaseDTO implements IAccommodationTypeCreateDTO {

    constructor(data?: IAccommodationTypeCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AccommodationTypeCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccommodationTypeCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AccommodationTypeCreateDTO {
        const json = this.toJSON();
        let result = new AccommodationTypeCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IAccommodationTypeCreateDTO extends IAccommodationTypeUpdateBaseDTO {
}

export class AccommodationTypeUpdateDTO extends AccommodationTypeUpdateBaseDTO implements IAccommodationTypeUpdateDTO {

    constructor(data?: IAccommodationTypeUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AccommodationTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AccommodationTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AccommodationTypeUpdateDTO {
        const json = this.toJSON();
        let result = new AccommodationTypeUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IAccommodationTypeUpdateDTO extends IAccommodationTypeUpdateBaseDTO {
}

export abstract class ArchivableCodeKeywordDetailDTO extends ArchivableKeywordDetailDTO implements IArchivableCodeKeywordDetailDTO {
    code!: string;

    constructor(data?: IArchivableCodeKeywordDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableCodeKeywordDetailDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableCodeKeywordDetailDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableCodeKeywordDetailDTO {
        throw new Error("The abstract class 'ArchivableCodeKeywordDetailDTO' cannot be instantiated.");
    }
}

export interface IArchivableCodeKeywordDetailDTO extends IArchivableKeywordDetailDTO {
    code: string;
}

export class AirlineDetailDTO extends ArchivableCodeKeywordDetailDTO implements IAirlineDetailDTO {
    airlineRating!: EnumModel;
    airlineStatus!: EnumModel;
    comment!: string | null;
    hasDeviation!: boolean;

    constructor(data?: IAirlineDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineRating = _data["airlineRating"] ? EnumModel.fromJS(_data["airlineRating"]) : <any>null;
            this.airlineStatus = _data["airlineStatus"] ? EnumModel.fromJS(_data["airlineStatus"]) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.hasDeviation = _data["hasDeviation"] !== undefined ? _data["hasDeviation"] : <any>null;
        }
    }

    static fromJS(data: any): AirlineDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineRating"] = this.airlineRating ? this.airlineRating.toJSON() : <any>null;
        data["airlineStatus"] = this.airlineStatus ? this.airlineStatus.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["hasDeviation"] = this.hasDeviation !== undefined ? this.hasDeviation : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AirlineDetailDTO {
        const json = this.toJSON();
        let result = new AirlineDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IAirlineDetailDTO extends IArchivableCodeKeywordDetailDTO {
    airlineRating: EnumModel;
    airlineStatus: EnumModel;
    comment: string | null;
    hasDeviation: boolean;
}

export class EnumModel implements IEnumModel {
    value!: number;
    name!: string;
    shortName!: string | null;

    constructor(data?: IEnumModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
        }
    }

    static fromJS(data: any): EnumModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnumModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        return data;
    }

    clone(): EnumModel {
        const json = this.toJSON();
        let result = new EnumModel();
        result.init(json);
        return result;
    }
}

export interface IEnumModel {
    value: number;
    name: string;
    shortName: string | null;
}

export class QueryResultOfAirlineListQueryDTO implements IQueryResultOfAirlineListQueryDTO {
    metaData!: QueryResultMetaDataOfAirlineListQueryDTO;
    data!: AirlineListQueryDTO[];

    constructor(data?: IQueryResultOfAirlineListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfAirlineListQueryDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AirlineListQueryDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfAirlineListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfAirlineListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfAirlineListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultOfAirlineListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfAirlineListQueryDTO {
    metaData: QueryResultMetaDataOfAirlineListQueryDTO;
    data: AirlineListQueryDTO[];
}

export class QueryResultMetaDataOfAirlineListQueryDTO implements IQueryResultMetaDataOfAirlineListQueryDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfAirlineListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfAirlineListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfAirlineListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfAirlineListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfAirlineListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfAirlineListQueryDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export abstract class ArchivableCodeKeywordInfoDTO extends ArchivableKeywordInfoDTO implements IArchivableCodeKeywordInfoDTO {
    code!: string;

    constructor(data?: IArchivableCodeKeywordInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableCodeKeywordInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableCodeKeywordInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableCodeKeywordInfoDTO {
        throw new Error("The abstract class 'ArchivableCodeKeywordInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableCodeKeywordInfoDTO extends IArchivableKeywordInfoDTO {
    code: string;
}

export class AirlineListQueryDTO extends ArchivableCodeKeywordInfoDTO implements IAirlineListQueryDTO {
    comment!: string | null;
    airlineRating!: EnumModel;
    airlineStatus!: EnumModel;

    constructor(data?: IAirlineListQueryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.airlineRating = _data["airlineRating"] ? EnumModel.fromJS(_data["airlineRating"]) : <any>null;
            this.airlineStatus = _data["airlineStatus"] ? EnumModel.fromJS(_data["airlineStatus"]) : <any>null;
        }
    }

    static fromJS(data: any): AirlineListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["airlineRating"] = this.airlineRating ? this.airlineRating.toJSON() : <any>null;
        data["airlineStatus"] = this.airlineStatus ? this.airlineStatus.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AirlineListQueryDTO {
        const json = this.toJSON();
        let result = new AirlineListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IAirlineListQueryDTO extends IArchivableCodeKeywordInfoDTO {
    comment: string | null;
    airlineRating: EnumModel;
    airlineStatus: EnumModel;
}

export enum AirlineRating {
    Class1 = 1,
    Class2 = 2,
    Class3 = 3,
    Class4 = 4,
    Class5 = 5,
}

export enum AirlineStatus {
    Approved = 1,
    ApprovedDeviation = 2,
    NonApproved = 3,
}

export class AirlineInfoDTO extends ArchivableCodeKeywordInfoDTO implements IAirlineInfoDTO {
    airlineRating!: AirlineRating;
    airlineStatus!: AirlineStatus;
    comment!: string | null;

    constructor(data?: IAirlineInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineRating = _data["airlineRating"] !== undefined ? _data["airlineRating"] : <any>null;
            this.airlineStatus = _data["airlineStatus"] !== undefined ? _data["airlineStatus"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): AirlineInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineRating"] = this.airlineRating !== undefined ? this.airlineRating : <any>null;
        data["airlineStatus"] = this.airlineStatus !== undefined ? this.airlineStatus : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AirlineInfoDTO {
        const json = this.toJSON();
        let result = new AirlineInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IAirlineInfoDTO extends IArchivableCodeKeywordInfoDTO {
    airlineRating: AirlineRating;
    airlineStatus: AirlineStatus;
    comment: string | null;
}

export abstract class CodeKeywordUpdateBaseDTO extends KeywordUpdateBaseDTO implements ICodeKeywordUpdateBaseDTO {
    code!: string;

    constructor(data?: ICodeKeywordUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): CodeKeywordUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CodeKeywordUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CodeKeywordUpdateBaseDTO {
        throw new Error("The abstract class 'CodeKeywordUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface ICodeKeywordUpdateBaseDTO extends IKeywordUpdateBaseDTO {
    code: string;
}

export abstract class AirlineUpdateBaseDTO extends CodeKeywordUpdateBaseDTO implements IAirlineUpdateBaseDTO {
    airlineRating!: AirlineRating;
    comment!: string | null;

    constructor(data?: IAirlineUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.airlineRating = _data["airlineRating"] !== undefined ? _data["airlineRating"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): AirlineUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AirlineUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["airlineRating"] = this.airlineRating !== undefined ? this.airlineRating : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): AirlineUpdateBaseDTO {
        throw new Error("The abstract class 'AirlineUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IAirlineUpdateBaseDTO extends ICodeKeywordUpdateBaseDTO {
    airlineRating: AirlineRating;
    comment: string | null;
}

export class AirlineCreateDTO extends AirlineUpdateBaseDTO implements IAirlineCreateDTO {

    constructor(data?: IAirlineCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AirlineCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AirlineCreateDTO {
        const json = this.toJSON();
        let result = new AirlineCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IAirlineCreateDTO extends IAirlineUpdateBaseDTO {
}

export class AirlineUpdateDTO extends AirlineUpdateBaseDTO implements IAirlineUpdateDTO {

    constructor(data?: IAirlineUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AirlineUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AirlineUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AirlineUpdateDTO {
        const json = this.toJSON();
        let result = new AirlineUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IAirlineUpdateDTO extends IAirlineUpdateBaseDTO {
}

export class ApprovalLevelDetailDTO extends ArchivableKeywordDetailDTO implements IApprovalLevelDetailDTO {
    description!: string | null;

    constructor(data?: IApprovalLevelDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ApprovalLevelDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalLevelDetailDTO {
        const json = this.toJSON();
        let result = new ApprovalLevelDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelDetailDTO extends IArchivableKeywordDetailDTO {
    description: string | null;
}

export class ApprovalLevelInfoDTO extends ArchivableKeywordInfoDTO implements IApprovalLevelInfoDTO {
    description!: string | null;

    constructor(data?: IApprovalLevelInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ApprovalLevelInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalLevelInfoDTO {
        const json = this.toJSON();
        let result = new ApprovalLevelInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelInfoDTO extends IArchivableKeywordInfoDTO {
    description: string | null;
}

export class ApprovalLevelUpdateBaseDTO extends KeywordUpdateBaseDTO implements IApprovalLevelUpdateBaseDTO {
    description!: string | null;

    constructor(data?: IApprovalLevelUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): ApprovalLevelUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalLevelUpdateBaseDTO {
        const json = this.toJSON();
        let result = new ApprovalLevelUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelUpdateBaseDTO extends IKeywordUpdateBaseDTO {
    description: string | null;
}

export class ApprovalLevelCreateDTO extends ApprovalLevelUpdateBaseDTO implements IApprovalLevelCreateDTO {

    constructor(data?: IApprovalLevelCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApprovalLevelCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalLevelCreateDTO {
        const json = this.toJSON();
        let result = new ApprovalLevelCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelCreateDTO extends IApprovalLevelUpdateBaseDTO {
}

export class ApprovalLevelUpdateDTO extends ApprovalLevelUpdateBaseDTO implements IApprovalLevelUpdateDTO {

    constructor(data?: IApprovalLevelUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApprovalLevelUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ApprovalLevelUpdateDTO {
        const json = this.toJSON();
        let result = new ApprovalLevelUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelUpdateDTO extends IApprovalLevelUpdateBaseDTO {
}

export class CityInfoDTO extends ArchivableEntityInfoDTO implements ICityInfoDTO {
    name!: string;
    region!: string | null;
    displayName!: string;
    country!: CountryInfoDTO;

    constructor(data?: ICityInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
        }
    }

    static fromJS(data: any): CityInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CityInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CityInfoDTO {
        const json = this.toJSON();
        let result = new CityInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ICityInfoDTO extends IArchivableEntityInfoDTO {
    name: string;
    region: string | null;
    displayName: string;
    country: CountryInfoDTO;
}

export class CountryInfoDTO extends ArchivableIconKeywordInfoDTO implements ICountryInfoDTO {
    isoCode2!: string;
    isoCode3!: string;

    constructor(data?: ICountryInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isoCode2 = _data["isoCode2"] !== undefined ? _data["isoCode2"] : <any>null;
            this.isoCode3 = _data["isoCode3"] !== undefined ? _data["isoCode3"] : <any>null;
        }
    }

    static fromJS(data: any): CountryInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoCode2"] = this.isoCode2 !== undefined ? this.isoCode2 : <any>null;
        data["isoCode3"] = this.isoCode3 !== undefined ? this.isoCode3 : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CountryInfoDTO {
        const json = this.toJSON();
        let result = new CountryInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryInfoDTO extends IArchivableIconKeywordInfoDTO {
    isoCode2: string;
    isoCode3: string;
}

export class CountryDetailDTO extends ArchivableIconKeywordDetailDTO implements ICountryDetailDTO {
    isoCode2!: string;
    isoCode3!: string;
    updateISOSData!: boolean;
    approvalRequirement!: EnumModel;
    approvalLevel!: ApprovalLevelInfoDTO;
    approveType!: EnumModel;
    hasSpecificCondition!: boolean;
    specificCondition!: string | null;
    travelOverview!: string | null;
    genericEmailAddresses!: string[];
    questions!: QuestionInfoDTO[];
    approvers!: SystemUserContactInfoDTO[];
    contacts!: SystemUserContactInfoDTO[];

    constructor(data?: ICountryDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isoCode2 = _data["isoCode2"] !== undefined ? _data["isoCode2"] : <any>null;
            this.isoCode3 = _data["isoCode3"] !== undefined ? _data["isoCode3"] : <any>null;
            this.updateISOSData = _data["updateISOSData"] !== undefined ? _data["updateISOSData"] : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] ? EnumModel.fromJS(_data["approvalRequirement"]) : <any>null;
            this.approvalLevel = _data["approvalLevel"] ? ApprovalLevelInfoDTO.fromJS(_data["approvalLevel"]) : <any>null;
            this.approveType = _data["approveType"] ? EnumModel.fromJS(_data["approveType"]) : <any>null;
            this.hasSpecificCondition = _data["hasSpecificCondition"] !== undefined ? _data["hasSpecificCondition"] : <any>null;
            this.specificCondition = _data["specificCondition"] !== undefined ? _data["specificCondition"] : <any>null;
            this.travelOverview = _data["travelOverview"] !== undefined ? _data["travelOverview"] : <any>null;
            if (Array.isArray(_data["genericEmailAddresses"])) {
                this.genericEmailAddresses = [] as any;
                for (let item of _data["genericEmailAddresses"])
                    this.genericEmailAddresses!.push(item);
            }
            else {
                this.genericEmailAddresses = <any>null;
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionInfoDTO.fromJS(item));
            }
            else {
                this.questions = <any>null;
            }
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.approvers = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.contacts = <any>null;
            }
        }
    }

    static fromJS(data: any): CountryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoCode2"] = this.isoCode2 !== undefined ? this.isoCode2 : <any>null;
        data["isoCode3"] = this.isoCode3 !== undefined ? this.isoCode3 : <any>null;
        data["updateISOSData"] = this.updateISOSData !== undefined ? this.updateISOSData : <any>null;
        data["approvalRequirement"] = this.approvalRequirement ? this.approvalRequirement.toJSON() : <any>null;
        data["approvalLevel"] = this.approvalLevel ? this.approvalLevel.toJSON() : <any>null;
        data["approveType"] = this.approveType ? this.approveType.toJSON() : <any>null;
        data["hasSpecificCondition"] = this.hasSpecificCondition !== undefined ? this.hasSpecificCondition : <any>null;
        data["specificCondition"] = this.specificCondition !== undefined ? this.specificCondition : <any>null;
        data["travelOverview"] = this.travelOverview !== undefined ? this.travelOverview : <any>null;
        if (Array.isArray(this.genericEmailAddresses)) {
            data["genericEmailAddresses"] = [];
            for (let item of this.genericEmailAddresses)
                data["genericEmailAddresses"].push(item);
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): CountryDetailDTO {
        const json = this.toJSON();
        let result = new CountryDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryDetailDTO extends IArchivableIconKeywordDetailDTO {
    isoCode2: string;
    isoCode3: string;
    updateISOSData: boolean;
    approvalRequirement: EnumModel;
    approvalLevel: ApprovalLevelInfoDTO;
    approveType: EnumModel;
    hasSpecificCondition: boolean;
    specificCondition: string | null;
    travelOverview: string | null;
    genericEmailAddresses: string[];
    questions: QuestionInfoDTO[];
    approvers: SystemUserContactInfoDTO[];
    contacts: SystemUserContactInfoDTO[];
}

export class QuestionInfoDTO extends ArchivableEntityInfoDTO implements IQuestionInfoDTO {
    name!: string;
    isGlobal!: boolean;
    isMandatory!: boolean;
    isDefaultChecked!: boolean;

    constructor(data?: IQuestionInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.isMandatory = _data["isMandatory"] !== undefined ? _data["isMandatory"] : <any>null;
            this.isDefaultChecked = _data["isDefaultChecked"] !== undefined ? _data["isDefaultChecked"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["isMandatory"] = this.isMandatory !== undefined ? this.isMandatory : <any>null;
        data["isDefaultChecked"] = this.isDefaultChecked !== undefined ? this.isDefaultChecked : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionInfoDTO {
        const json = this.toJSON();
        let result = new QuestionInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IQuestionInfoDTO extends IArchivableEntityInfoDTO {
    name: string;
    isGlobal: boolean;
    isMandatory: boolean;
    isDefaultChecked: boolean;
}

export class SystemUserContactInfoDTO extends SystemUserInfoDTO implements ISystemUserContactInfoDTO {
    email!: string | null;
    jobTitle!: string | null;
    mobilePhone!: string | null;
    countriesContactEmail!: string | null;

    constructor(data?: ISystemUserContactInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : <any>null;
            this.countriesContactEmail = _data["countriesContactEmail"] !== undefined ? _data["countriesContactEmail"] : <any>null;
        }
    }

    static fromJS(data: any): SystemUserContactInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserContactInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : <any>null;
        data["countriesContactEmail"] = this.countriesContactEmail !== undefined ? this.countriesContactEmail : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SystemUserContactInfoDTO {
        const json = this.toJSON();
        let result = new SystemUserContactInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISystemUserContactInfoDTO extends ISystemUserInfoDTO {
    email: string | null;
    jobTitle: string | null;
    mobilePhone: string | null;
    countriesContactEmail: string | null;
}

export class QueryResultOfCountryListQueryDTO implements IQueryResultOfCountryListQueryDTO {
    metaData!: QueryResultMetaDataOfCountryListQueryDTO;
    data!: CountryListQueryDTO[];

    constructor(data?: IQueryResultOfCountryListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfCountryListQueryDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CountryListQueryDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfCountryListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfCountryListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfCountryListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultOfCountryListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfCountryListQueryDTO {
    metaData: QueryResultMetaDataOfCountryListQueryDTO;
    data: CountryListQueryDTO[];
}

export class QueryResultMetaDataOfCountryListQueryDTO implements IQueryResultMetaDataOfCountryListQueryDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfCountryListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfCountryListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfCountryListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfCountryListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfCountryListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfCountryListQueryDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class CountryListQueryDTO extends ArchivableIconKeywordDetailDTO implements ICountryListQueryDTO {
    approvalRequirement!: EnumModel;
    approvalLevel!: ApprovalLevelInfoDTO;
    approveType!: EnumModel;

    constructor(data?: ICountryListQueryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.approvalRequirement = _data["approvalRequirement"] ? EnumModel.fromJS(_data["approvalRequirement"]) : <any>null;
            this.approvalLevel = _data["approvalLevel"] ? ApprovalLevelInfoDTO.fromJS(_data["approvalLevel"]) : <any>null;
            this.approveType = _data["approveType"] ? EnumModel.fromJS(_data["approveType"]) : <any>null;
        }
    }

    static fromJS(data: any): CountryListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalRequirement"] = this.approvalRequirement ? this.approvalRequirement.toJSON() : <any>null;
        data["approvalLevel"] = this.approvalLevel ? this.approvalLevel.toJSON() : <any>null;
        data["approveType"] = this.approveType ? this.approveType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CountryListQueryDTO {
        const json = this.toJSON();
        let result = new CountryListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryListQueryDTO extends IArchivableIconKeywordDetailDTO {
    approvalRequirement: EnumModel;
    approvalLevel: ApprovalLevelInfoDTO;
    approveType: EnumModel;
}

export enum CountryApprovalRequirement {
    NotRequired = 1,
    IsRequired = 2,
    ExceptTransit = 3,
}

export enum ApproveType {
    One = 1,
    All = 2,
    Any = 3,
}

export class CountrySettingsInfoDTO extends CountryInfoDTO implements ICountrySettingsInfoDTO {
    approvalRequirement!: CountryApprovalRequirement;
    approvalLevel!: ApprovalLevelInfoDTO;
    approveType!: ApproveType;
    specificCondition!: string | null;
    approvers!: SystemUserContactInfoDTO[];
    questions!: QuestionInfoDTO[];

    constructor(data?: ICountrySettingsInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.approvalRequirement = _data["approvalRequirement"] !== undefined ? _data["approvalRequirement"] : <any>null;
            this.approvalLevel = _data["approvalLevel"] ? ApprovalLevelInfoDTO.fromJS(_data["approvalLevel"]) : <any>null;
            this.approveType = _data["approveType"] !== undefined ? _data["approveType"] : <any>null;
            this.specificCondition = _data["specificCondition"] !== undefined ? _data["specificCondition"] : <any>null;
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.approvers = <any>null;
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionInfoDTO.fromJS(item));
            }
            else {
                this.questions = <any>null;
            }
        }
    }

    static fromJS(data: any): CountrySettingsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountrySettingsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalRequirement"] = this.approvalRequirement !== undefined ? this.approvalRequirement : <any>null;
        data["approvalLevel"] = this.approvalLevel ? this.approvalLevel.toJSON() : <any>null;
        data["approveType"] = this.approveType !== undefined ? this.approveType : <any>null;
        data["specificCondition"] = this.specificCondition !== undefined ? this.specificCondition : <any>null;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): CountrySettingsInfoDTO {
        const json = this.toJSON();
        let result = new CountrySettingsInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ICountrySettingsInfoDTO extends ICountryInfoDTO {
    approvalRequirement: CountryApprovalRequirement;
    approvalLevel: ApprovalLevelInfoDTO;
    approveType: ApproveType;
    specificCondition: string | null;
    approvers: SystemUserContactInfoDTO[];
    questions: QuestionInfoDTO[];
}

export abstract class CountryUpdateBaseDTO extends IconKeywordUpdateBaseDTO implements ICountryUpdateBaseDTO {
    isoCode2!: string;
    isoCode3!: string;
    updateISOSData!: boolean;
    approvalRequirement!: CountryApprovalRequirement;
    approvalLevelId!: number;
    approveType!: ApproveType;
    hasSpecificCondition!: boolean;
    specificCondition!: string | null;
    travelOverview!: string | null;
    genericEmailAddresses!: string[];
    approversUniqueIds!: string[];
    contacts!: CountryContactUpdateDTO[];

    constructor(data?: ICountryUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isoCode2 = _data["isoCode2"] !== undefined ? _data["isoCode2"] : <any>null;
            this.isoCode3 = _data["isoCode3"] !== undefined ? _data["isoCode3"] : <any>null;
            this.updateISOSData = _data["updateISOSData"] !== undefined ? _data["updateISOSData"] : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] !== undefined ? _data["approvalRequirement"] : <any>null;
            this.approvalLevelId = _data["approvalLevelId"] !== undefined ? _data["approvalLevelId"] : <any>null;
            this.approveType = _data["approveType"] !== undefined ? _data["approveType"] : <any>null;
            this.hasSpecificCondition = _data["hasSpecificCondition"] !== undefined ? _data["hasSpecificCondition"] : <any>null;
            this.specificCondition = _data["specificCondition"] !== undefined ? _data["specificCondition"] : <any>null;
            this.travelOverview = _data["travelOverview"] !== undefined ? _data["travelOverview"] : <any>null;
            if (Array.isArray(_data["genericEmailAddresses"])) {
                this.genericEmailAddresses = [] as any;
                for (let item of _data["genericEmailAddresses"])
                    this.genericEmailAddresses!.push(item);
            }
            else {
                this.genericEmailAddresses = <any>null;
            }
            if (Array.isArray(_data["approversUniqueIds"])) {
                this.approversUniqueIds = [] as any;
                for (let item of _data["approversUniqueIds"])
                    this.approversUniqueIds!.push(item);
            }
            else {
                this.approversUniqueIds = <any>null;
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CountryContactUpdateDTO.fromJS(item));
            }
            else {
                this.contacts = <any>null;
            }
        }
    }

    static fromJS(data: any): CountryUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'CountryUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isoCode2"] = this.isoCode2 !== undefined ? this.isoCode2 : <any>null;
        data["isoCode3"] = this.isoCode3 !== undefined ? this.isoCode3 : <any>null;
        data["updateISOSData"] = this.updateISOSData !== undefined ? this.updateISOSData : <any>null;
        data["approvalRequirement"] = this.approvalRequirement !== undefined ? this.approvalRequirement : <any>null;
        data["approvalLevelId"] = this.approvalLevelId !== undefined ? this.approvalLevelId : <any>null;
        data["approveType"] = this.approveType !== undefined ? this.approveType : <any>null;
        data["hasSpecificCondition"] = this.hasSpecificCondition !== undefined ? this.hasSpecificCondition : <any>null;
        data["specificCondition"] = this.specificCondition !== undefined ? this.specificCondition : <any>null;
        data["travelOverview"] = this.travelOverview !== undefined ? this.travelOverview : <any>null;
        if (Array.isArray(this.genericEmailAddresses)) {
            data["genericEmailAddresses"] = [];
            for (let item of this.genericEmailAddresses)
                data["genericEmailAddresses"].push(item);
        }
        if (Array.isArray(this.approversUniqueIds)) {
            data["approversUniqueIds"] = [];
            for (let item of this.approversUniqueIds)
                data["approversUniqueIds"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): CountryUpdateBaseDTO {
        throw new Error("The abstract class 'CountryUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface ICountryUpdateBaseDTO extends IIconKeywordUpdateBaseDTO {
    isoCode2: string;
    isoCode3: string;
    updateISOSData: boolean;
    approvalRequirement: CountryApprovalRequirement;
    approvalLevelId: number;
    approveType: ApproveType;
    hasSpecificCondition: boolean;
    specificCondition: string | null;
    travelOverview: string | null;
    genericEmailAddresses: string[];
    approversUniqueIds: string[];
    contacts: CountryContactUpdateDTO[];
}

export class CountryCreateDTO extends CountryUpdateBaseDTO implements ICountryCreateDTO {

    constructor(data?: ICountryCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CountryCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CountryCreateDTO {
        const json = this.toJSON();
        let result = new CountryCreateDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryCreateDTO extends ICountryUpdateBaseDTO {
}

export class CountryContactUpdateDTO implements ICountryContactUpdateDTO {
    uniqueId!: string;
    countriesContactEmail!: string | null;

    constructor(data?: ICountryContactUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : <any>null;
            this.countriesContactEmail = _data["countriesContactEmail"] !== undefined ? _data["countriesContactEmail"] : <any>null;
        }
    }

    static fromJS(data: any): CountryContactUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryContactUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : <any>null;
        data["countriesContactEmail"] = this.countriesContactEmail !== undefined ? this.countriesContactEmail : <any>null;
        return data;
    }

    clone(): CountryContactUpdateDTO {
        const json = this.toJSON();
        let result = new CountryContactUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryContactUpdateDTO {
    uniqueId: string;
    countriesContactEmail: string | null;
}

export class CountryUpdateDTO extends CountryUpdateBaseDTO implements ICountryUpdateDTO {

    constructor(data?: ICountryUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CountryUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): CountryUpdateDTO {
        const json = this.toJSON();
        let result = new CountryUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryUpdateDTO extends ICountryUpdateBaseDTO {
}

export class AddCountryApproverModel implements IAddCountryApproverModel {
    approverUniqueId!: string;

    constructor(data?: IAddCountryApproverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverUniqueId = _data["approverUniqueId"] !== undefined ? _data["approverUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): AddCountryApproverModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCountryApproverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverUniqueId"] = this.approverUniqueId !== undefined ? this.approverUniqueId : <any>null;
        return data;
    }

    clone(): AddCountryApproverModel {
        const json = this.toJSON();
        let result = new AddCountryApproverModel();
        result.init(json);
        return result;
    }
}

export interface IAddCountryApproverModel {
    approverUniqueId: string;
}

export class RemoveCountryApproverModel implements IRemoveCountryApproverModel {
    approverId!: number;

    constructor(data?: IRemoveCountryApproverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverId = _data["approverId"] !== undefined ? _data["approverId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveCountryApproverModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCountryApproverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverId"] = this.approverId !== undefined ? this.approverId : <any>null;
        return data;
    }

    clone(): RemoveCountryApproverModel {
        const json = this.toJSON();
        let result = new RemoveCountryApproverModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveCountryApproverModel {
    approverId: number;
}

export class AddCountryContactModel implements IAddCountryContactModel {
    contactUniqueId!: string;

    constructor(data?: IAddCountryContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUniqueId = _data["contactUniqueId"] !== undefined ? _data["contactUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): AddCountryContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddCountryContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUniqueId"] = this.contactUniqueId !== undefined ? this.contactUniqueId : <any>null;
        return data;
    }

    clone(): AddCountryContactModel {
        const json = this.toJSON();
        let result = new AddCountryContactModel();
        result.init(json);
        return result;
    }
}

export interface IAddCountryContactModel {
    contactUniqueId: string;
}

export class RemoveCountryContactModel implements IRemoveCountryContactModel {
    contactId!: number;

    constructor(data?: IRemoveCountryContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"] !== undefined ? _data["contactId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveCountryContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCountryContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId !== undefined ? this.contactId : <any>null;
        return data;
    }

    clone(): RemoveCountryContactModel {
        const json = this.toJSON();
        let result = new RemoveCountryContactModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveCountryContactModel {
    contactId: number;
}

export class CountryChangeRequestDetailDTO extends EntityDTO implements ICountryChangeRequestDetailDTO {
    country!: CountryInfoDTO;
    approvalRequirement!: EnumModel;
    approvalLevel!: ApprovalLevelInfoDTO;
    approveType!: EnumModel;
    approvers!: SystemUserContactInfoDTO[];
    note!: string | null;
    effectiveFrom!: string;
    requestedBy!: SystemUserContactInfoDTO;
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;

    constructor(data?: ICountryChangeRequestDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] ? EnumModel.fromJS(_data["approvalRequirement"]) : <any>null;
            this.approvalLevel = _data["approvalLevel"] ? ApprovalLevelInfoDTO.fromJS(_data["approvalLevel"]) : <any>null;
            this.approveType = _data["approveType"] ? EnumModel.fromJS(_data["approveType"]) : <any>null;
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.approvers = <any>null;
            }
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.effectiveFrom = _data["effectiveFrom"] !== undefined ? _data["effectiveFrom"] : <any>null;
            this.requestedBy = _data["requestedBy"] ? SystemUserContactInfoDTO.fromJS(_data["requestedBy"]) : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): CountryChangeRequestDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryChangeRequestDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["approvalRequirement"] = this.approvalRequirement ? this.approvalRequirement.toJSON() : <any>null;
        data["approvalLevel"] = this.approvalLevel ? this.approvalLevel.toJSON() : <any>null;
        data["approveType"] = this.approveType ? this.approveType.toJSON() : <any>null;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["effectiveFrom"] = this.effectiveFrom !== undefined ? this.effectiveFrom : <any>null;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): CountryChangeRequestDetailDTO {
        const json = this.toJSON();
        let result = new CountryChangeRequestDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryChangeRequestDetailDTO extends IEntityDTO {
    country: CountryInfoDTO;
    approvalRequirement: EnumModel;
    approvalLevel: ApprovalLevelInfoDTO;
    approveType: EnumModel;
    approvers: SystemUserContactInfoDTO[];
    note: string | null;
    effectiveFrom: string;
    requestedBy: SystemUserContactInfoDTO;
    createdOn: string;
    createdBy: SystemUserInfoDTO;
}

export class CountryChangeRequestCreateDTO implements ICountryChangeRequestCreateDTO {
    countryId!: number;
    approvalRequirement!: CountryApprovalRequirement;
    approvalLevelId!: number;
    approveType!: ApproveType;
    approversUniqueIds!: string[];
    note!: string | null;
    effectiveFrom!: string;
    requestedByUniqueId!: string;

    constructor(data?: ICountryChangeRequestCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] !== undefined ? _data["approvalRequirement"] : <any>null;
            this.approvalLevelId = _data["approvalLevelId"] !== undefined ? _data["approvalLevelId"] : <any>null;
            this.approveType = _data["approveType"] !== undefined ? _data["approveType"] : <any>null;
            if (Array.isArray(_data["approversUniqueIds"])) {
                this.approversUniqueIds = [] as any;
                for (let item of _data["approversUniqueIds"])
                    this.approversUniqueIds!.push(item);
            }
            else {
                this.approversUniqueIds = <any>null;
            }
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.effectiveFrom = _data["effectiveFrom"] !== undefined ? _data["effectiveFrom"] : <any>null;
            this.requestedByUniqueId = _data["requestedByUniqueId"] !== undefined ? _data["requestedByUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): CountryChangeRequestCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryChangeRequestCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["approvalRequirement"] = this.approvalRequirement !== undefined ? this.approvalRequirement : <any>null;
        data["approvalLevelId"] = this.approvalLevelId !== undefined ? this.approvalLevelId : <any>null;
        data["approveType"] = this.approveType !== undefined ? this.approveType : <any>null;
        if (Array.isArray(this.approversUniqueIds)) {
            data["approversUniqueIds"] = [];
            for (let item of this.approversUniqueIds)
                data["approversUniqueIds"].push(item);
        }
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["effectiveFrom"] = this.effectiveFrom !== undefined ? this.effectiveFrom : <any>null;
        data["requestedByUniqueId"] = this.requestedByUniqueId !== undefined ? this.requestedByUniqueId : <any>null;
        return data;
    }

    clone(): CountryChangeRequestCreateDTO {
        const json = this.toJSON();
        let result = new CountryChangeRequestCreateDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryChangeRequestCreateDTO {
    countryId: number;
    approvalRequirement: CountryApprovalRequirement;
    approvalLevelId: number;
    approveType: ApproveType;
    approversUniqueIds: string[];
    note: string | null;
    effectiveFrom: string;
    requestedByUniqueId: string;
}

export class DeviationRequestDetailModel implements IDeviationRequestDetailModel {
    deviationRequest!: DeviationRequestDetailDTO;
    permissions!: DeviationRequestPermissionsModel;
    workflowStrategy!: DeviationRequestWorkflowStrategyDTO;

    constructor(data?: IDeviationRequestDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviationRequest = _data["deviationRequest"] ? DeviationRequestDetailDTO.fromJS(_data["deviationRequest"]) : <any>null;
            this.permissions = _data["permissions"] ? DeviationRequestPermissionsModel.fromJS(_data["permissions"]) : <any>null;
            this.workflowStrategy = _data["workflowStrategy"] ? DeviationRequestWorkflowStrategyDTO.fromJS(_data["workflowStrategy"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviationRequest"] = this.deviationRequest ? this.deviationRequest.toJSON() : <any>null;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>null;
        data["workflowStrategy"] = this.workflowStrategy ? this.workflowStrategy.toJSON() : <any>null;
        return data;
    }

    clone(): DeviationRequestDetailModel {
        const json = this.toJSON();
        let result = new DeviationRequestDetailModel();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestDetailModel {
    deviationRequest: DeviationRequestDetailDTO;
    permissions: DeviationRequestPermissionsModel;
    workflowStrategy: DeviationRequestWorkflowStrategyDTO;
}

export class DeviationRequestDetailDTO extends ArchivableEntityDetailDTO implements IDeviationRequestDetailDTO {
    deviationType!: EnumModel;
    workflowType!: EnumModel;
    status!: EnumModel;
    requestedBy!: SystemUserContactInfoDTO;
    organisationEntity!: OrganisationEntityInfoDTO;
    validFrom!: string | null;
    validTo!: string | null;
    detail!: DeviationDetailDetailDTO;
    lineManagerName!: string | null;
    isSupportedByLineManager!: boolean | null;
    epra!: SystemUserContactInfoDTO | null;
    isSupportedByEPRA!: boolean | null;
    regionDirector!: DeviationTeamRegionDirectorInfoDTO | null;
    regionalEntityLeader!: SystemUserContactInfoDTO | null;
    isSupportedByRegionalEntityLeader!: boolean | null;
    sorLeader!: SystemUserContactInfoDTO | null;
    isSupportedBySORLeader!: boolean | null;
    aviationCOE!: SystemUserContactInfoDTO | null;
    isSupportedByAviationCOE!: boolean | null;
    seniorVPHSE!: SystemUserContactInfoDTO | null;
    isSupportedBySeniorVPHSE!: boolean | null;
    cfo!: SystemUserContactInfoDTO | null;
    isSupportedByCFO!: boolean | null;
    reason!: string;
    alternativeOptions!: string;
    riskManagement!: string;
    additionalInfo!: string | null;
    assignedOn!: string | null;
    assignedTo!: SystemUserContactInfoDTO | null;
    createdOn!: string;
    createdBy!: SystemUserContactInfoDTO;
    modifiedOn!: string | null;
    modifiedBy!: SystemUserContactInfoDTO | null;
    statusChangedOn!: string;
    statusChangedBy!: SystemUserContactInfoDTO;
    travellers!: SystemUserContactInfoDTO[];
    dueToExpireNotificationSent!: boolean | null;
    attachments!: UploadedFileDetailDTO[];
    changeHistories!: DeviationRequestChangeHistoryDetailDTO[];

    constructor(data?: IDeviationRequestDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviationType = _data["deviationType"] ? EnumModel.fromJS(_data["deviationType"]) : <any>null;
            this.workflowType = _data["workflowType"] ? EnumModel.fromJS(_data["workflowType"]) : <any>null;
            this.status = _data["status"] ? EnumModel.fromJS(_data["status"]) : <any>null;
            this.requestedBy = _data["requestedBy"] ? SystemUserContactInfoDTO.fromJS(_data["requestedBy"]) : <any>null;
            this.organisationEntity = _data["organisationEntity"] ? OrganisationEntityInfoDTO.fromJS(_data["organisationEntity"]) : <any>null;
            this.validFrom = _data["validFrom"] !== undefined ? _data["validFrom"] : <any>null;
            this.validTo = _data["validTo"] !== undefined ? _data["validTo"] : <any>null;
            this.detail = _data["detail"] ? DeviationDetailDetailDTO.fromJS(_data["detail"]) : <any>null;
            this.lineManagerName = _data["lineManagerName"] !== undefined ? _data["lineManagerName"] : <any>null;
            this.isSupportedByLineManager = _data["isSupportedByLineManager"] !== undefined ? _data["isSupportedByLineManager"] : <any>null;
            this.epra = _data["epra"] ? SystemUserContactInfoDTO.fromJS(_data["epra"]) : <any>null;
            this.isSupportedByEPRA = _data["isSupportedByEPRA"] !== undefined ? _data["isSupportedByEPRA"] : <any>null;
            this.regionDirector = _data["regionDirector"] ? DeviationTeamRegionDirectorInfoDTO.fromJS(_data["regionDirector"]) : <any>null;
            this.regionalEntityLeader = _data["regionalEntityLeader"] ? SystemUserContactInfoDTO.fromJS(_data["regionalEntityLeader"]) : <any>null;
            this.isSupportedByRegionalEntityLeader = _data["isSupportedByRegionalEntityLeader"] !== undefined ? _data["isSupportedByRegionalEntityLeader"] : <any>null;
            this.sorLeader = _data["sorLeader"] ? SystemUserContactInfoDTO.fromJS(_data["sorLeader"]) : <any>null;
            this.isSupportedBySORLeader = _data["isSupportedBySORLeader"] !== undefined ? _data["isSupportedBySORLeader"] : <any>null;
            this.aviationCOE = _data["aviationCOE"] ? SystemUserContactInfoDTO.fromJS(_data["aviationCOE"]) : <any>null;
            this.isSupportedByAviationCOE = _data["isSupportedByAviationCOE"] !== undefined ? _data["isSupportedByAviationCOE"] : <any>null;
            this.seniorVPHSE = _data["seniorVPHSE"] ? SystemUserContactInfoDTO.fromJS(_data["seniorVPHSE"]) : <any>null;
            this.isSupportedBySeniorVPHSE = _data["isSupportedBySeniorVPHSE"] !== undefined ? _data["isSupportedBySeniorVPHSE"] : <any>null;
            this.cfo = _data["cfo"] ? SystemUserContactInfoDTO.fromJS(_data["cfo"]) : <any>null;
            this.isSupportedByCFO = _data["isSupportedByCFO"] !== undefined ? _data["isSupportedByCFO"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.alternativeOptions = _data["alternativeOptions"] !== undefined ? _data["alternativeOptions"] : <any>null;
            this.riskManagement = _data["riskManagement"] !== undefined ? _data["riskManagement"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.assignedOn = _data["assignedOn"] !== undefined ? _data["assignedOn"] : <any>null;
            this.assignedTo = _data["assignedTo"] ? SystemUserContactInfoDTO.fromJS(_data["assignedTo"]) : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserContactInfoDTO.fromJS(_data["createdBy"]) : <any>null;
            this.modifiedOn = _data["modifiedOn"] !== undefined ? _data["modifiedOn"] : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? SystemUserContactInfoDTO.fromJS(_data["modifiedBy"]) : <any>null;
            this.statusChangedOn = _data["statusChangedOn"] !== undefined ? _data["statusChangedOn"] : <any>null;
            this.statusChangedBy = _data["statusChangedBy"] ? SystemUserContactInfoDTO.fromJS(_data["statusChangedBy"]) : <any>null;
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
            this.dueToExpireNotificationSent = _data["dueToExpireNotificationSent"] !== undefined ? _data["dueToExpireNotificationSent"] : <any>null;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(UploadedFileDetailDTO.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            if (Array.isArray(_data["changeHistories"])) {
                this.changeHistories = [] as any;
                for (let item of _data["changeHistories"])
                    this.changeHistories!.push(DeviationRequestChangeHistoryDetailDTO.fromJS(item));
            }
            else {
                this.changeHistories = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationRequestDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviationType"] = this.deviationType ? this.deviationType.toJSON() : <any>null;
        data["workflowType"] = this.workflowType ? this.workflowType.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>null;
        data["organisationEntity"] = this.organisationEntity ? this.organisationEntity.toJSON() : <any>null;
        data["validFrom"] = this.validFrom !== undefined ? this.validFrom : <any>null;
        data["validTo"] = this.validTo !== undefined ? this.validTo : <any>null;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>null;
        data["lineManagerName"] = this.lineManagerName !== undefined ? this.lineManagerName : <any>null;
        data["isSupportedByLineManager"] = this.isSupportedByLineManager !== undefined ? this.isSupportedByLineManager : <any>null;
        data["epra"] = this.epra ? this.epra.toJSON() : <any>null;
        data["isSupportedByEPRA"] = this.isSupportedByEPRA !== undefined ? this.isSupportedByEPRA : <any>null;
        data["regionDirector"] = this.regionDirector ? this.regionDirector.toJSON() : <any>null;
        data["regionalEntityLeader"] = this.regionalEntityLeader ? this.regionalEntityLeader.toJSON() : <any>null;
        data["isSupportedByRegionalEntityLeader"] = this.isSupportedByRegionalEntityLeader !== undefined ? this.isSupportedByRegionalEntityLeader : <any>null;
        data["sorLeader"] = this.sorLeader ? this.sorLeader.toJSON() : <any>null;
        data["isSupportedBySORLeader"] = this.isSupportedBySORLeader !== undefined ? this.isSupportedBySORLeader : <any>null;
        data["aviationCOE"] = this.aviationCOE ? this.aviationCOE.toJSON() : <any>null;
        data["isSupportedByAviationCOE"] = this.isSupportedByAviationCOE !== undefined ? this.isSupportedByAviationCOE : <any>null;
        data["seniorVPHSE"] = this.seniorVPHSE ? this.seniorVPHSE.toJSON() : <any>null;
        data["isSupportedBySeniorVPHSE"] = this.isSupportedBySeniorVPHSE !== undefined ? this.isSupportedBySeniorVPHSE : <any>null;
        data["cfo"] = this.cfo ? this.cfo.toJSON() : <any>null;
        data["isSupportedByCFO"] = this.isSupportedByCFO !== undefined ? this.isSupportedByCFO : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["alternativeOptions"] = this.alternativeOptions !== undefined ? this.alternativeOptions : <any>null;
        data["riskManagement"] = this.riskManagement !== undefined ? this.riskManagement : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["assignedOn"] = this.assignedOn !== undefined ? this.assignedOn : <any>null;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["modifiedOn"] = this.modifiedOn !== undefined ? this.modifiedOn : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        data["statusChangedOn"] = this.statusChangedOn !== undefined ? this.statusChangedOn : <any>null;
        data["statusChangedBy"] = this.statusChangedBy ? this.statusChangedBy.toJSON() : <any>null;
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        data["dueToExpireNotificationSent"] = this.dueToExpireNotificationSent !== undefined ? this.dueToExpireNotificationSent : <any>null;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.changeHistories)) {
            data["changeHistories"] = [];
            for (let item of this.changeHistories)
                data["changeHistories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeviationRequestDetailDTO {
        const json = this.toJSON();
        let result = new DeviationRequestDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestDetailDTO extends IArchivableEntityDetailDTO {
    deviationType: EnumModel;
    workflowType: EnumModel;
    status: EnumModel;
    requestedBy: SystemUserContactInfoDTO;
    organisationEntity: OrganisationEntityInfoDTO;
    validFrom: string | null;
    validTo: string | null;
    detail: DeviationDetailDetailDTO;
    lineManagerName: string | null;
    isSupportedByLineManager: boolean | null;
    epra: SystemUserContactInfoDTO | null;
    isSupportedByEPRA: boolean | null;
    regionDirector: DeviationTeamRegionDirectorInfoDTO | null;
    regionalEntityLeader: SystemUserContactInfoDTO | null;
    isSupportedByRegionalEntityLeader: boolean | null;
    sorLeader: SystemUserContactInfoDTO | null;
    isSupportedBySORLeader: boolean | null;
    aviationCOE: SystemUserContactInfoDTO | null;
    isSupportedByAviationCOE: boolean | null;
    seniorVPHSE: SystemUserContactInfoDTO | null;
    isSupportedBySeniorVPHSE: boolean | null;
    cfo: SystemUserContactInfoDTO | null;
    isSupportedByCFO: boolean | null;
    reason: string;
    alternativeOptions: string;
    riskManagement: string;
    additionalInfo: string | null;
    assignedOn: string | null;
    assignedTo: SystemUserContactInfoDTO | null;
    createdOn: string;
    createdBy: SystemUserContactInfoDTO;
    modifiedOn: string | null;
    modifiedBy: SystemUserContactInfoDTO | null;
    statusChangedOn: string;
    statusChangedBy: SystemUserContactInfoDTO;
    travellers: SystemUserContactInfoDTO[];
    dueToExpireNotificationSent: boolean | null;
    attachments: UploadedFileDetailDTO[];
    changeHistories: DeviationRequestChangeHistoryDetailDTO[];
}

export class OrganisationEntityInfoDTO extends ArchivableCodeKeywordInfoDTO implements IOrganisationEntityInfoDTO {

    constructor(data?: IOrganisationEntityInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationEntityInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationEntityInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganisationEntityInfoDTO {
        const json = this.toJSON();
        let result = new OrganisationEntityInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IOrganisationEntityInfoDTO extends IArchivableCodeKeywordInfoDTO {
}

export class DeviationDetailDetailDTO implements IDeviationDetailDetailDTO {
    detailType!: EnumModel;
    airline!: AirlineInfoDTO | null;
    airlineCustomName!: string | null;
    originCity!: CityInfoDTO | null;
    originCityCustomName!: string | null;
    originCountry!: CountryInfoDTO | null;
    destinationCity!: CityInfoDTO | null;
    destinationCityCustomName!: string | null;
    destinationCountry!: CountryInfoDTO | null;
    classOfTravel!: EnumModel | null;
    flightTime!: EnumModel | null;
    hotelName!: string | null;
    city!: CityInfoDTO | null;
    cityCustomName!: string | null;
    country!: CountryInfoDTO | null;

    constructor(data?: IDeviationDetailDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailType = _data["detailType"] ? EnumModel.fromJS(_data["detailType"]) : <any>null;
            this.airline = _data["airline"] ? AirlineInfoDTO.fromJS(_data["airline"]) : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.originCity = _data["originCity"] ? CityInfoDTO.fromJS(_data["originCity"]) : <any>null;
            this.originCityCustomName = _data["originCityCustomName"] !== undefined ? _data["originCityCustomName"] : <any>null;
            this.originCountry = _data["originCountry"] ? CountryInfoDTO.fromJS(_data["originCountry"]) : <any>null;
            this.destinationCity = _data["destinationCity"] ? CityInfoDTO.fromJS(_data["destinationCity"]) : <any>null;
            this.destinationCityCustomName = _data["destinationCityCustomName"] !== undefined ? _data["destinationCityCustomName"] : <any>null;
            this.destinationCountry = _data["destinationCountry"] ? CountryInfoDTO.fromJS(_data["destinationCountry"]) : <any>null;
            this.classOfTravel = _data["classOfTravel"] ? EnumModel.fromJS(_data["classOfTravel"]) : <any>null;
            this.flightTime = _data["flightTime"] ? EnumModel.fromJS(_data["flightTime"]) : <any>null;
            this.hotelName = _data["hotelName"] !== undefined ? _data["hotelName"] : <any>null;
            this.city = _data["city"] ? CityInfoDTO.fromJS(_data["city"]) : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviationDetailDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationDetailDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailType"] = this.detailType ? this.detailType.toJSON() : <any>null;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["originCity"] = this.originCity ? this.originCity.toJSON() : <any>null;
        data["originCityCustomName"] = this.originCityCustomName !== undefined ? this.originCityCustomName : <any>null;
        data["originCountry"] = this.originCountry ? this.originCountry.toJSON() : <any>null;
        data["destinationCity"] = this.destinationCity ? this.destinationCity.toJSON() : <any>null;
        data["destinationCityCustomName"] = this.destinationCityCustomName !== undefined ? this.destinationCityCustomName : <any>null;
        data["destinationCountry"] = this.destinationCountry ? this.destinationCountry.toJSON() : <any>null;
        data["classOfTravel"] = this.classOfTravel ? this.classOfTravel.toJSON() : <any>null;
        data["flightTime"] = this.flightTime ? this.flightTime.toJSON() : <any>null;
        data["hotelName"] = this.hotelName !== undefined ? this.hotelName : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        return data;
    }

    clone(): DeviationDetailDetailDTO {
        const json = this.toJSON();
        let result = new DeviationDetailDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationDetailDetailDTO {
    detailType: EnumModel;
    airline: AirlineInfoDTO | null;
    airlineCustomName: string | null;
    originCity: CityInfoDTO | null;
    originCityCustomName: string | null;
    originCountry: CountryInfoDTO | null;
    destinationCity: CityInfoDTO | null;
    destinationCityCustomName: string | null;
    destinationCountry: CountryInfoDTO | null;
    classOfTravel: EnumModel | null;
    flightTime: EnumModel | null;
    hotelName: string | null;
    city: CityInfoDTO | null;
    cityCustomName: string | null;
    country: CountryInfoDTO | null;
}

export class DeviationTeamRegionDirectorInfoDTO extends ArchivableEntityInfoDTO implements IDeviationTeamRegionDirectorInfoDTO {
    region!: string;
    director!: SystemUserContactInfoDTO;

    constructor(data?: IDeviationTeamRegionDirectorInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.director = _data["director"] ? SystemUserContactInfoDTO.fromJS(_data["director"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamRegionDirectorInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamRegionDirectorInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["director"] = this.director ? this.director.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamRegionDirectorInfoDTO {
        const json = this.toJSON();
        let result = new DeviationTeamRegionDirectorInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamRegionDirectorInfoDTO extends IArchivableEntityInfoDTO {
    region: string;
    director: SystemUserContactInfoDTO;
}

export class UploadedFileDetailDTO extends EntityDTO implements IUploadedFileDetailDTO {
    fileName!: string;
    extension!: string | null;
    sizeInBytes!: number;
    contentType!: string;
    context!: string | null;
    storageFileId!: string;
    uploadedOn!: string;
    uploadedBy!: SystemUserContactInfoDTO;

    constructor(data?: IUploadedFileDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : <any>null;
            this.sizeInBytes = _data["sizeInBytes"] !== undefined ? _data["sizeInBytes"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.context = _data["context"] !== undefined ? _data["context"] : <any>null;
            this.storageFileId = _data["storageFileId"] !== undefined ? _data["storageFileId"] : <any>null;
            this.uploadedOn = _data["uploadedOn"] !== undefined ? _data["uploadedOn"] : <any>null;
            this.uploadedBy = _data["uploadedBy"] ? SystemUserContactInfoDTO.fromJS(_data["uploadedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): UploadedFileDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFileDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["extension"] = this.extension !== undefined ? this.extension : <any>null;
        data["sizeInBytes"] = this.sizeInBytes !== undefined ? this.sizeInBytes : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["context"] = this.context !== undefined ? this.context : <any>null;
        data["storageFileId"] = this.storageFileId !== undefined ? this.storageFileId : <any>null;
        data["uploadedOn"] = this.uploadedOn !== undefined ? this.uploadedOn : <any>null;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): UploadedFileDetailDTO {
        const json = this.toJSON();
        let result = new UploadedFileDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IUploadedFileDetailDTO extends IEntityDTO {
    fileName: string;
    extension: string | null;
    sizeInBytes: number;
    contentType: string;
    context: string | null;
    storageFileId: string;
    uploadedOn: string;
    uploadedBy: SystemUserContactInfoDTO;
}

export class DeviationRequestChangeHistoryDetailDTO implements IDeviationRequestChangeHistoryDetailDTO {
    status!: EnumModel;
    assignedTo!: SystemUserInfoDTO | null;
    comment!: string | null;
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;

    constructor(data?: IDeviationRequestChangeHistoryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] ? EnumModel.fromJS(_data["status"]) : <any>null;
            this.assignedTo = _data["assignedTo"] ? SystemUserInfoDTO.fromJS(_data["assignedTo"]) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestChangeHistoryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestChangeHistoryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        return data;
    }

    clone(): DeviationRequestChangeHistoryDetailDTO {
        const json = this.toJSON();
        let result = new DeviationRequestChangeHistoryDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestChangeHistoryDetailDTO {
    status: EnumModel;
    assignedTo: SystemUserInfoDTO | null;
    comment: string | null;
    createdOn: string;
    createdBy: SystemUserInfoDTO;
}

export class DeviationRequestPermissionsModel implements IDeviationRequestPermissionsModel {
    canEdit!: boolean;
    canEditAttachment!: boolean;
    canAssign!: boolean;
    canEditWorkflowFields!: boolean;
    canSupportByRegionDirector!: boolean;
    canSupport!: boolean;
    canReject!: boolean;
    canRenew!: boolean;
    teamMembersToAssign!: SystemUserContactInfoDTO[];
    canArchive!: boolean;
    canUnarchive!: boolean;

    constructor(data?: IDeviationRequestPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEdit = _data["canEdit"] !== undefined ? _data["canEdit"] : <any>null;
            this.canEditAttachment = _data["canEditAttachment"] !== undefined ? _data["canEditAttachment"] : <any>null;
            this.canAssign = _data["canAssign"] !== undefined ? _data["canAssign"] : <any>null;
            this.canEditWorkflowFields = _data["canEditWorkflowFields"] !== undefined ? _data["canEditWorkflowFields"] : <any>null;
            this.canSupportByRegionDirector = _data["canSupportByRegionDirector"] !== undefined ? _data["canSupportByRegionDirector"] : <any>null;
            this.canSupport = _data["canSupport"] !== undefined ? _data["canSupport"] : <any>null;
            this.canReject = _data["canReject"] !== undefined ? _data["canReject"] : <any>null;
            this.canRenew = _data["canRenew"] !== undefined ? _data["canRenew"] : <any>null;
            if (Array.isArray(_data["teamMembersToAssign"])) {
                this.teamMembersToAssign = [] as any;
                for (let item of _data["teamMembersToAssign"])
                    this.teamMembersToAssign!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.teamMembersToAssign = <any>null;
            }
            this.canArchive = _data["canArchive"] !== undefined ? _data["canArchive"] : <any>null;
            this.canUnarchive = _data["canUnarchive"] !== undefined ? _data["canUnarchive"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEdit"] = this.canEdit !== undefined ? this.canEdit : <any>null;
        data["canEditAttachment"] = this.canEditAttachment !== undefined ? this.canEditAttachment : <any>null;
        data["canAssign"] = this.canAssign !== undefined ? this.canAssign : <any>null;
        data["canEditWorkflowFields"] = this.canEditWorkflowFields !== undefined ? this.canEditWorkflowFields : <any>null;
        data["canSupportByRegionDirector"] = this.canSupportByRegionDirector !== undefined ? this.canSupportByRegionDirector : <any>null;
        data["canSupport"] = this.canSupport !== undefined ? this.canSupport : <any>null;
        data["canReject"] = this.canReject !== undefined ? this.canReject : <any>null;
        data["canRenew"] = this.canRenew !== undefined ? this.canRenew : <any>null;
        if (Array.isArray(this.teamMembersToAssign)) {
            data["teamMembersToAssign"] = [];
            for (let item of this.teamMembersToAssign)
                data["teamMembersToAssign"].push(item.toJSON());
        }
        data["canArchive"] = this.canArchive !== undefined ? this.canArchive : <any>null;
        data["canUnarchive"] = this.canUnarchive !== undefined ? this.canUnarchive : <any>null;
        return data;
    }

    clone(): DeviationRequestPermissionsModel {
        const json = this.toJSON();
        let result = new DeviationRequestPermissionsModel();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestPermissionsModel {
    canEdit: boolean;
    canEditAttachment: boolean;
    canAssign: boolean;
    canEditWorkflowFields: boolean;
    canSupportByRegionDirector: boolean;
    canSupport: boolean;
    canReject: boolean;
    canRenew: boolean;
    teamMembersToAssign: SystemUserContactInfoDTO[];
    canArchive: boolean;
    canUnarchive: boolean;
}

export class DeviationRequestWorkflowStrategyDTO implements IDeviationRequestWorkflowStrategyDTO {
    hasAviationCOE!: boolean;
    hasSeniorVPHSE!: boolean;
    hasCFO!: boolean;
    hasEpra!: boolean;
    hasSORLeader!: boolean;
    hasRegionDirector!: boolean;
    hasLineManager!: boolean;

    constructor(data?: IDeviationRequestWorkflowStrategyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAviationCOE = _data["hasAviationCOE"] !== undefined ? _data["hasAviationCOE"] : <any>null;
            this.hasSeniorVPHSE = _data["hasSeniorVPHSE"] !== undefined ? _data["hasSeniorVPHSE"] : <any>null;
            this.hasCFO = _data["hasCFO"] !== undefined ? _data["hasCFO"] : <any>null;
            this.hasEpra = _data["hasEpra"] !== undefined ? _data["hasEpra"] : <any>null;
            this.hasSORLeader = _data["hasSORLeader"] !== undefined ? _data["hasSORLeader"] : <any>null;
            this.hasRegionDirector = _data["hasRegionDirector"] !== undefined ? _data["hasRegionDirector"] : <any>null;
            this.hasLineManager = _data["hasLineManager"] !== undefined ? _data["hasLineManager"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestWorkflowStrategyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestWorkflowStrategyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAviationCOE"] = this.hasAviationCOE !== undefined ? this.hasAviationCOE : <any>null;
        data["hasSeniorVPHSE"] = this.hasSeniorVPHSE !== undefined ? this.hasSeniorVPHSE : <any>null;
        data["hasCFO"] = this.hasCFO !== undefined ? this.hasCFO : <any>null;
        data["hasEpra"] = this.hasEpra !== undefined ? this.hasEpra : <any>null;
        data["hasSORLeader"] = this.hasSORLeader !== undefined ? this.hasSORLeader : <any>null;
        data["hasRegionDirector"] = this.hasRegionDirector !== undefined ? this.hasRegionDirector : <any>null;
        data["hasLineManager"] = this.hasLineManager !== undefined ? this.hasLineManager : <any>null;
        return data;
    }

    clone(): DeviationRequestWorkflowStrategyDTO {
        const json = this.toJSON();
        let result = new DeviationRequestWorkflowStrategyDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestWorkflowStrategyDTO {
    hasAviationCOE: boolean;
    hasSeniorVPHSE: boolean;
    hasCFO: boolean;
    hasEpra: boolean;
    hasSORLeader: boolean;
    hasRegionDirector: boolean;
    hasLineManager: boolean;
}

export class QueryResultOfDeviationRequestListQueryDTO implements IQueryResultOfDeviationRequestListQueryDTO {
    metaData!: QueryResultMetaDataOfDeviationRequestListQueryDTO;
    data!: DeviationRequestListQueryDTO[];

    constructor(data?: IQueryResultOfDeviationRequestListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfDeviationRequestListQueryDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DeviationRequestListQueryDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfDeviationRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfDeviationRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfDeviationRequestListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultOfDeviationRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfDeviationRequestListQueryDTO {
    metaData: QueryResultMetaDataOfDeviationRequestListQueryDTO;
    data: DeviationRequestListQueryDTO[];
}

export class QueryResultMetaDataOfDeviationRequestListQueryDTO implements IQueryResultMetaDataOfDeviationRequestListQueryDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfDeviationRequestListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfDeviationRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfDeviationRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfDeviationRequestListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfDeviationRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfDeviationRequestListQueryDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class DeviationRequestListQueryDTO extends ArchivableEntityInfoDTO implements IDeviationRequestListQueryDTO {
    typeInfo!: string;
    requestedBy!: PersonInfoDTO;
    assignedTo!: PersonInfoDTO | null;
    status!: EnumModel;
    statusChangedOn!: string;
    statusChangedBy!: PersonInfoDTO;
    deviationType!: EnumModel;
    workflowType!: EnumModel;
    detailType!: EnumModel;
    detailInfo!: string;
    detailAdditionalInfo!: string;
    validFrom!: string | null;
    validTo!: string | null;
    travellers!: PersonInfoDTO[];

    constructor(data?: IDeviationRequestListQueryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeInfo = _data["typeInfo"] !== undefined ? _data["typeInfo"] : <any>null;
            this.requestedBy = _data["requestedBy"] ? PersonInfoDTO.fromJS(_data["requestedBy"]) : <any>null;
            this.assignedTo = _data["assignedTo"] ? PersonInfoDTO.fromJS(_data["assignedTo"]) : <any>null;
            this.status = _data["status"] ? EnumModel.fromJS(_data["status"]) : <any>null;
            this.statusChangedOn = _data["statusChangedOn"] !== undefined ? _data["statusChangedOn"] : <any>null;
            this.statusChangedBy = _data["statusChangedBy"] ? PersonInfoDTO.fromJS(_data["statusChangedBy"]) : <any>null;
            this.deviationType = _data["deviationType"] ? EnumModel.fromJS(_data["deviationType"]) : <any>null;
            this.workflowType = _data["workflowType"] ? EnumModel.fromJS(_data["workflowType"]) : <any>null;
            this.detailType = _data["detailType"] ? EnumModel.fromJS(_data["detailType"]) : <any>null;
            this.detailInfo = _data["detailInfo"] !== undefined ? _data["detailInfo"] : <any>null;
            this.detailAdditionalInfo = _data["detailAdditionalInfo"] !== undefined ? _data["detailAdditionalInfo"] : <any>null;
            this.validFrom = _data["validFrom"] !== undefined ? _data["validFrom"] : <any>null;
            this.validTo = _data["validTo"] !== undefined ? _data["validTo"] : <any>null;
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(PersonInfoDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeInfo"] = this.typeInfo !== undefined ? this.typeInfo : <any>null;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>null;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : <any>null;
        data["status"] = this.status ? this.status.toJSON() : <any>null;
        data["statusChangedOn"] = this.statusChangedOn !== undefined ? this.statusChangedOn : <any>null;
        data["statusChangedBy"] = this.statusChangedBy ? this.statusChangedBy.toJSON() : <any>null;
        data["deviationType"] = this.deviationType ? this.deviationType.toJSON() : <any>null;
        data["workflowType"] = this.workflowType ? this.workflowType.toJSON() : <any>null;
        data["detailType"] = this.detailType ? this.detailType.toJSON() : <any>null;
        data["detailInfo"] = this.detailInfo !== undefined ? this.detailInfo : <any>null;
        data["detailAdditionalInfo"] = this.detailAdditionalInfo !== undefined ? this.detailAdditionalInfo : <any>null;
        data["validFrom"] = this.validFrom !== undefined ? this.validFrom : <any>null;
        data["validTo"] = this.validTo !== undefined ? this.validTo : <any>null;
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeviationRequestListQueryDTO {
        const json = this.toJSON();
        let result = new DeviationRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestListQueryDTO extends IArchivableEntityInfoDTO {
    typeInfo: string;
    requestedBy: PersonInfoDTO;
    assignedTo: PersonInfoDTO | null;
    status: EnumModel;
    statusChangedOn: string;
    statusChangedBy: PersonInfoDTO;
    deviationType: EnumModel;
    workflowType: EnumModel;
    detailType: EnumModel;
    detailInfo: string;
    detailAdditionalInfo: string;
    validFrom: string | null;
    validTo: string | null;
    travellers: PersonInfoDTO[];
}

export class PersonInfoDTO implements IPersonInfoDTO {
    firstName!: string | null;
    lastName!: string | null;
    fullName!: string;
    initials!: string;

    constructor(data?: IPersonInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.initials = _data["initials"] !== undefined ? _data["initials"] : <any>null;
        }
    }

    static fromJS(data: any): PersonInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PersonInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["initials"] = this.initials !== undefined ? this.initials : <any>null;
        return data;
    }

    clone(): PersonInfoDTO {
        const json = this.toJSON();
        let result = new PersonInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IPersonInfoDTO {
    firstName: string | null;
    lastName: string | null;
    fullName: string;
    initials: string;
}

export enum DeviationRequestStatus {
    Pending = 1,
    Supported = 2,
    Rejected = 3,
    Expired = 4,
    SupportedByRegionDirector = 5,
}

export enum DeviationType {
    SingleInstance = 1,
    EntityWide = 2,
}

export enum DeviationWorkflowType {
    Aviation = 1,
    Health = 2,
    Security = 3,
}

export enum DeviationDetailType {
    Airline = 1,
    ClassOfTravel = 2,
    Hotel = 3,
    AirlineExtended = 4,
}

export abstract class DeviationRequestUpdateBaseDTO implements IDeviationRequestUpdateBaseDTO {
    requestedByUniqueId!: string;
    organisationEntityId!: number;
    detail!: DeviationDetailUpdateDTO;
    reason!: string;
    alternativeOptions!: string;
    riskManagement!: string;
    additionalInfo!: string | null;
    lineManagerName!: string | null;
    isSupportedByLineManager!: boolean | null;
    regionDirectorId!: number | null;
    epraId!: number | null;
    isSupportedByEPRA!: boolean | null;
    regionalEntityLeaderUniqueId!: string | null;
    isSupportedByRegionalEntityLeader!: boolean | null;
    sorLeaderUniqueId!: string | null;
    isSupportedBySORLeader!: boolean | null;
    validFrom!: string | null;
    validTo!: string | null;
    travellersUniqueIds!: string[];
    uploadedFilesIds!: number[];

    constructor(data?: IDeviationRequestUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.detail = new DeviationDetailUpdateDTO();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedByUniqueId = _data["requestedByUniqueId"] !== undefined ? _data["requestedByUniqueId"] : <any>null;
            this.organisationEntityId = _data["organisationEntityId"] !== undefined ? _data["organisationEntityId"] : <any>null;
            this.detail = _data["detail"] ? DeviationDetailUpdateDTO.fromJS(_data["detail"]) : new DeviationDetailUpdateDTO();
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.alternativeOptions = _data["alternativeOptions"] !== undefined ? _data["alternativeOptions"] : <any>null;
            this.riskManagement = _data["riskManagement"] !== undefined ? _data["riskManagement"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.lineManagerName = _data["lineManagerName"] !== undefined ? _data["lineManagerName"] : <any>null;
            this.isSupportedByLineManager = _data["isSupportedByLineManager"] !== undefined ? _data["isSupportedByLineManager"] : <any>null;
            this.regionDirectorId = _data["regionDirectorId"] !== undefined ? _data["regionDirectorId"] : <any>null;
            this.epraId = _data["epraId"] !== undefined ? _data["epraId"] : <any>null;
            this.isSupportedByEPRA = _data["isSupportedByEPRA"] !== undefined ? _data["isSupportedByEPRA"] : <any>null;
            this.regionalEntityLeaderUniqueId = _data["regionalEntityLeaderUniqueId"] !== undefined ? _data["regionalEntityLeaderUniqueId"] : <any>null;
            this.isSupportedByRegionalEntityLeader = _data["isSupportedByRegionalEntityLeader"] !== undefined ? _data["isSupportedByRegionalEntityLeader"] : <any>null;
            this.sorLeaderUniqueId = _data["sorLeaderUniqueId"] !== undefined ? _data["sorLeaderUniqueId"] : <any>null;
            this.isSupportedBySORLeader = _data["isSupportedBySORLeader"] !== undefined ? _data["isSupportedBySORLeader"] : <any>null;
            this.validFrom = _data["validFrom"] !== undefined ? _data["validFrom"] : <any>null;
            this.validTo = _data["validTo"] !== undefined ? _data["validTo"] : <any>null;
            if (Array.isArray(_data["travellersUniqueIds"])) {
                this.travellersUniqueIds = [] as any;
                for (let item of _data["travellersUniqueIds"])
                    this.travellersUniqueIds!.push(item);
            }
            else {
                this.travellersUniqueIds = <any>null;
            }
            if (Array.isArray(_data["uploadedFilesIds"])) {
                this.uploadedFilesIds = [] as any;
                for (let item of _data["uploadedFilesIds"])
                    this.uploadedFilesIds!.push(item);
            }
            else {
                this.uploadedFilesIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationRequestUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DeviationRequestUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedByUniqueId"] = this.requestedByUniqueId !== undefined ? this.requestedByUniqueId : <any>null;
        data["organisationEntityId"] = this.organisationEntityId !== undefined ? this.organisationEntityId : <any>null;
        data["detail"] = this.detail ? this.detail.toJSON() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["alternativeOptions"] = this.alternativeOptions !== undefined ? this.alternativeOptions : <any>null;
        data["riskManagement"] = this.riskManagement !== undefined ? this.riskManagement : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["lineManagerName"] = this.lineManagerName !== undefined ? this.lineManagerName : <any>null;
        data["isSupportedByLineManager"] = this.isSupportedByLineManager !== undefined ? this.isSupportedByLineManager : <any>null;
        data["regionDirectorId"] = this.regionDirectorId !== undefined ? this.regionDirectorId : <any>null;
        data["epraId"] = this.epraId !== undefined ? this.epraId : <any>null;
        data["isSupportedByEPRA"] = this.isSupportedByEPRA !== undefined ? this.isSupportedByEPRA : <any>null;
        data["regionalEntityLeaderUniqueId"] = this.regionalEntityLeaderUniqueId !== undefined ? this.regionalEntityLeaderUniqueId : <any>null;
        data["isSupportedByRegionalEntityLeader"] = this.isSupportedByRegionalEntityLeader !== undefined ? this.isSupportedByRegionalEntityLeader : <any>null;
        data["sorLeaderUniqueId"] = this.sorLeaderUniqueId !== undefined ? this.sorLeaderUniqueId : <any>null;
        data["isSupportedBySORLeader"] = this.isSupportedBySORLeader !== undefined ? this.isSupportedBySORLeader : <any>null;
        data["validFrom"] = this.validFrom !== undefined ? this.validFrom : <any>null;
        data["validTo"] = this.validTo !== undefined ? this.validTo : <any>null;
        if (Array.isArray(this.travellersUniqueIds)) {
            data["travellersUniqueIds"] = [];
            for (let item of this.travellersUniqueIds)
                data["travellersUniqueIds"].push(item);
        }
        if (Array.isArray(this.uploadedFilesIds)) {
            data["uploadedFilesIds"] = [];
            for (let item of this.uploadedFilesIds)
                data["uploadedFilesIds"].push(item);
        }
        return data;
    }

    clone(): DeviationRequestUpdateBaseDTO {
        throw new Error("The abstract class 'DeviationRequestUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IDeviationRequestUpdateBaseDTO {
    requestedByUniqueId: string;
    organisationEntityId: number;
    detail: DeviationDetailUpdateDTO;
    reason: string;
    alternativeOptions: string;
    riskManagement: string;
    additionalInfo: string | null;
    lineManagerName: string | null;
    isSupportedByLineManager: boolean | null;
    regionDirectorId: number | null;
    epraId: number | null;
    isSupportedByEPRA: boolean | null;
    regionalEntityLeaderUniqueId: string | null;
    isSupportedByRegionalEntityLeader: boolean | null;
    sorLeaderUniqueId: string | null;
    isSupportedBySORLeader: boolean | null;
    validFrom: string | null;
    validTo: string | null;
    travellersUniqueIds: string[];
    uploadedFilesIds: number[];
}

export class DeviationRequestCreateDTO extends DeviationRequestUpdateBaseDTO implements IDeviationRequestCreateDTO {
    deviationType!: DeviationType;
    workflowType!: DeviationWorkflowType;

    constructor(data?: IDeviationRequestCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.deviationType = _data["deviationType"] !== undefined ? _data["deviationType"] : <any>null;
            this.workflowType = _data["workflowType"] !== undefined ? _data["workflowType"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviationType"] = this.deviationType !== undefined ? this.deviationType : <any>null;
        data["workflowType"] = this.workflowType !== undefined ? this.workflowType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviationRequestCreateDTO {
        const json = this.toJSON();
        let result = new DeviationRequestCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestCreateDTO extends IDeviationRequestUpdateBaseDTO {
    deviationType: DeviationType;
    workflowType: DeviationWorkflowType;
}

export class DeviationDetailUpdateDTO implements IDeviationDetailUpdateDTO {
    detailType!: DeviationDetailType;
    airlineId!: number | null;
    airlineCustomName!: string | null;
    originCityId!: number | null;
    originCityCustomName!: string | null;
    originCountryId!: number | null;
    destinationCityId!: number | null;
    destinationCityCustomName!: string | null;
    destinationCountryId!: number | null;
    classOfTravel!: ClassOfTravel | null;
    flightTime!: FlightTime | null;
    hotelName!: string | null;
    cityId!: number | null;
    cityCustomName!: string | null;
    countryId!: number | null;

    constructor(data?: IDeviationDetailUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailType = _data["detailType"] !== undefined ? _data["detailType"] : <any>null;
            this.airlineId = _data["airlineId"] !== undefined ? _data["airlineId"] : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.originCityId = _data["originCityId"] !== undefined ? _data["originCityId"] : <any>null;
            this.originCityCustomName = _data["originCityCustomName"] !== undefined ? _data["originCityCustomName"] : <any>null;
            this.originCountryId = _data["originCountryId"] !== undefined ? _data["originCountryId"] : <any>null;
            this.destinationCityId = _data["destinationCityId"] !== undefined ? _data["destinationCityId"] : <any>null;
            this.destinationCityCustomName = _data["destinationCityCustomName"] !== undefined ? _data["destinationCityCustomName"] : <any>null;
            this.destinationCountryId = _data["destinationCountryId"] !== undefined ? _data["destinationCountryId"] : <any>null;
            this.classOfTravel = _data["classOfTravel"] !== undefined ? _data["classOfTravel"] : <any>null;
            this.flightTime = _data["flightTime"] !== undefined ? _data["flightTime"] : <any>null;
            this.hotelName = _data["hotelName"] !== undefined ? _data["hotelName"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationDetailUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationDetailUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailType"] = this.detailType !== undefined ? this.detailType : <any>null;
        data["airlineId"] = this.airlineId !== undefined ? this.airlineId : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["originCityId"] = this.originCityId !== undefined ? this.originCityId : <any>null;
        data["originCityCustomName"] = this.originCityCustomName !== undefined ? this.originCityCustomName : <any>null;
        data["originCountryId"] = this.originCountryId !== undefined ? this.originCountryId : <any>null;
        data["destinationCityId"] = this.destinationCityId !== undefined ? this.destinationCityId : <any>null;
        data["destinationCityCustomName"] = this.destinationCityCustomName !== undefined ? this.destinationCityCustomName : <any>null;
        data["destinationCountryId"] = this.destinationCountryId !== undefined ? this.destinationCountryId : <any>null;
        data["classOfTravel"] = this.classOfTravel !== undefined ? this.classOfTravel : <any>null;
        data["flightTime"] = this.flightTime !== undefined ? this.flightTime : <any>null;
        data["hotelName"] = this.hotelName !== undefined ? this.hotelName : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        return data;
    }

    clone(): DeviationDetailUpdateDTO {
        const json = this.toJSON();
        let result = new DeviationDetailUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationDetailUpdateDTO {
    detailType: DeviationDetailType;
    airlineId: number | null;
    airlineCustomName: string | null;
    originCityId: number | null;
    originCityCustomName: string | null;
    originCountryId: number | null;
    destinationCityId: number | null;
    destinationCityCustomName: string | null;
    destinationCountryId: number | null;
    classOfTravel: ClassOfTravel | null;
    flightTime: FlightTime | null;
    hotelName: string | null;
    cityId: number | null;
    cityCustomName: string | null;
    countryId: number | null;
}

export enum ClassOfTravel {
    Economy = 1,
    Business = 2,
}

export enum FlightTime {
    Short = 1,
    Medium = 2,
    Long = 3,
}

export class DeviationRequestUpdateDTO extends DeviationRequestUpdateBaseDTO implements IDeviationRequestUpdateDTO {
    aviationCOEUniqueId!: string | null;
    isSupportedByAviationCOE!: boolean | null;
    seniorVPHSEUniqueId!: string | null;
    isSupportedBySeniorVPHSE!: boolean | null;
    cfoUniqueId!: string | null;
    isSupportedByCFO!: boolean | null;

    constructor(data?: IDeviationRequestUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.aviationCOEUniqueId = _data["aviationCOEUniqueId"] !== undefined ? _data["aviationCOEUniqueId"] : <any>null;
            this.isSupportedByAviationCOE = _data["isSupportedByAviationCOE"] !== undefined ? _data["isSupportedByAviationCOE"] : <any>null;
            this.seniorVPHSEUniqueId = _data["seniorVPHSEUniqueId"] !== undefined ? _data["seniorVPHSEUniqueId"] : <any>null;
            this.isSupportedBySeniorVPHSE = _data["isSupportedBySeniorVPHSE"] !== undefined ? _data["isSupportedBySeniorVPHSE"] : <any>null;
            this.cfoUniqueId = _data["cfoUniqueId"] !== undefined ? _data["cfoUniqueId"] : <any>null;
            this.isSupportedByCFO = _data["isSupportedByCFO"] !== undefined ? _data["isSupportedByCFO"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationRequestUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aviationCOEUniqueId"] = this.aviationCOEUniqueId !== undefined ? this.aviationCOEUniqueId : <any>null;
        data["isSupportedByAviationCOE"] = this.isSupportedByAviationCOE !== undefined ? this.isSupportedByAviationCOE : <any>null;
        data["seniorVPHSEUniqueId"] = this.seniorVPHSEUniqueId !== undefined ? this.seniorVPHSEUniqueId : <any>null;
        data["isSupportedBySeniorVPHSE"] = this.isSupportedBySeniorVPHSE !== undefined ? this.isSupportedBySeniorVPHSE : <any>null;
        data["cfoUniqueId"] = this.cfoUniqueId !== undefined ? this.cfoUniqueId : <any>null;
        data["isSupportedByCFO"] = this.isSupportedByCFO !== undefined ? this.isSupportedByCFO : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviationRequestUpdateDTO {
        const json = this.toJSON();
        let result = new DeviationRequestUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestUpdateDTO extends IDeviationRequestUpdateBaseDTO {
    aviationCOEUniqueId: string | null;
    isSupportedByAviationCOE: boolean | null;
    seniorVPHSEUniqueId: string | null;
    isSupportedBySeniorVPHSE: boolean | null;
    cfoUniqueId: string | null;
    isSupportedByCFO: boolean | null;
}

export class DeviationRequestAttachmentUpdateDTO implements IDeviationRequestAttachmentUpdateDTO {
    uploadedFilesIds!: number[];

    constructor(data?: IDeviationRequestAttachmentUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uploadedFilesIds"])) {
                this.uploadedFilesIds = [] as any;
                for (let item of _data["uploadedFilesIds"])
                    this.uploadedFilesIds!.push(item);
            }
            else {
                this.uploadedFilesIds = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationRequestAttachmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationRequestAttachmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uploadedFilesIds)) {
            data["uploadedFilesIds"] = [];
            for (let item of this.uploadedFilesIds)
                data["uploadedFilesIds"].push(item);
        }
        return data;
    }

    clone(): DeviationRequestAttachmentUpdateDTO {
        const json = this.toJSON();
        let result = new DeviationRequestAttachmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationRequestAttachmentUpdateDTO {
    uploadedFilesIds: number[];
}

export class AssignDeviationToModel implements IAssignDeviationToModel {
    assignToId!: number | null;

    constructor(data?: IAssignDeviationToModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignToId = _data["assignToId"] !== undefined ? _data["assignToId"] : <any>null;
        }
    }

    static fromJS(data: any): AssignDeviationToModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssignDeviationToModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignToId"] = this.assignToId !== undefined ? this.assignToId : <any>null;
        return data;
    }

    clone(): AssignDeviationToModel {
        const json = this.toJSON();
        let result = new AssignDeviationToModel();
        result.init(json);
        return result;
    }
}

export interface IAssignDeviationToModel {
    assignToId: number | null;
}

export class ChangeDeviationStatusModel implements IChangeDeviationStatusModel {
    status!: DeviationRequestStatus;

    constructor(data?: IChangeDeviationStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeDeviationStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDeviationStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }

    clone(): ChangeDeviationStatusModel {
        const json = this.toJSON();
        let result = new ChangeDeviationStatusModel();
        result.init(json);
        return result;
    }
}

export interface IChangeDeviationStatusModel {
    status: DeviationRequestStatus;
}

export class AttachmentSettingsModel implements IAttachmentSettingsModel {
    allowedFileExtensions!: string[];
    maxFileSizeInBytes!: number | null;

    constructor(data?: IAttachmentSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedFileExtensions"])) {
                this.allowedFileExtensions = [] as any;
                for (let item of _data["allowedFileExtensions"])
                    this.allowedFileExtensions!.push(item);
            }
            else {
                this.allowedFileExtensions = <any>null;
            }
            this.maxFileSizeInBytes = _data["maxFileSizeInBytes"] !== undefined ? _data["maxFileSizeInBytes"] : <any>null;
        }
    }

    static fromJS(data: any): AttachmentSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedFileExtensions)) {
            data["allowedFileExtensions"] = [];
            for (let item of this.allowedFileExtensions)
                data["allowedFileExtensions"].push(item);
        }
        data["maxFileSizeInBytes"] = this.maxFileSizeInBytes !== undefined ? this.maxFileSizeInBytes : <any>null;
        return data;
    }

    clone(): AttachmentSettingsModel {
        const json = this.toJSON();
        let result = new AttachmentSettingsModel();
        result.init(json);
        return result;
    }
}

export interface IAttachmentSettingsModel {
    allowedFileExtensions: string[];
    maxFileSizeInBytes: number | null;
}

export class DeviationTeamDetailDTO extends EntityDTO implements IDeviationTeamDetailDTO {
    name!: string;
    teamType!: EnumModel;
    teamStrategy!: DeviationTeamTypeStrategyDTO;
    emailAddress!: string | null;
    teamLeader!: SystemUserContactInfoDTO | null;
    members!: SystemUserContactInfoDTO[];
    regionDirectors!: DeviationTeamRegionDirectorDetailDTO[];

    constructor(data?: IDeviationTeamDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.teamType = _data["teamType"] ? EnumModel.fromJS(_data["teamType"]) : <any>null;
            this.teamStrategy = _data["teamStrategy"] ? DeviationTeamTypeStrategyDTO.fromJS(_data["teamStrategy"]) : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.teamLeader = _data["teamLeader"] ? SystemUserContactInfoDTO.fromJS(_data["teamLeader"]) : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.members = <any>null;
            }
            if (Array.isArray(_data["regionDirectors"])) {
                this.regionDirectors = [] as any;
                for (let item of _data["regionDirectors"])
                    this.regionDirectors!.push(DeviationTeamRegionDirectorDetailDTO.fromJS(item));
            }
            else {
                this.regionDirectors = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationTeamDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["teamType"] = this.teamType ? this.teamType.toJSON() : <any>null;
        data["teamStrategy"] = this.teamStrategy ? this.teamStrategy.toJSON() : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["teamLeader"] = this.teamLeader ? this.teamLeader.toJSON() : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.regionDirectors)) {
            data["regionDirectors"] = [];
            for (let item of this.regionDirectors)
                data["regionDirectors"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamDetailDTO {
        const json = this.toJSON();
        let result = new DeviationTeamDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamDetailDTO extends IEntityDTO {
    name: string;
    teamType: EnumModel;
    teamStrategy: DeviationTeamTypeStrategyDTO;
    emailAddress: string | null;
    teamLeader: SystemUserContactInfoDTO | null;
    members: SystemUserContactInfoDTO[];
    regionDirectors: DeviationTeamRegionDirectorDetailDTO[];
}

export class DeviationTeamTypeStrategyDTO implements IDeviationTeamTypeStrategyDTO {
    hasTeamLeader!: boolean;
    hasEmailAddress!: boolean;
    hasMembers!: boolean;
    hasDirectors!: boolean;
    order!: number;

    constructor(data?: IDeviationTeamTypeStrategyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTeamLeader = _data["hasTeamLeader"] !== undefined ? _data["hasTeamLeader"] : <any>null;
            this.hasEmailAddress = _data["hasEmailAddress"] !== undefined ? _data["hasEmailAddress"] : <any>null;
            this.hasMembers = _data["hasMembers"] !== undefined ? _data["hasMembers"] : <any>null;
            this.hasDirectors = _data["hasDirectors"] !== undefined ? _data["hasDirectors"] : <any>null;
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamTypeStrategyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamTypeStrategyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTeamLeader"] = this.hasTeamLeader !== undefined ? this.hasTeamLeader : <any>null;
        data["hasEmailAddress"] = this.hasEmailAddress !== undefined ? this.hasEmailAddress : <any>null;
        data["hasMembers"] = this.hasMembers !== undefined ? this.hasMembers : <any>null;
        data["hasDirectors"] = this.hasDirectors !== undefined ? this.hasDirectors : <any>null;
        data["order"] = this.order !== undefined ? this.order : <any>null;
        return data;
    }

    clone(): DeviationTeamTypeStrategyDTO {
        const json = this.toJSON();
        let result = new DeviationTeamTypeStrategyDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamTypeStrategyDTO {
    hasTeamLeader: boolean;
    hasEmailAddress: boolean;
    hasMembers: boolean;
    hasDirectors: boolean;
    order: number;
}

export class DeviationTeamRegionDirectorDetailDTO extends ArchivableEntityDetailDTO implements IDeviationTeamRegionDirectorDetailDTO {
    region!: string;
    director!: SystemUserContactInfoDTO;

    constructor(data?: IDeviationTeamRegionDirectorDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.director = _data["director"] ? SystemUserContactInfoDTO.fromJS(_data["director"]) : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamRegionDirectorDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamRegionDirectorDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["director"] = this.director ? this.director.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamRegionDirectorDetailDTO {
        const json = this.toJSON();
        let result = new DeviationTeamRegionDirectorDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamRegionDirectorDetailDTO extends IArchivableEntityDetailDTO {
    region: string;
    director: SystemUserContactInfoDTO;
}

export abstract class KeywordDTO extends EntityDTO implements IKeywordDTO {
    name!: string;

    constructor(data?: IKeywordDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): KeywordDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'KeywordDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): KeywordDTO {
        throw new Error("The abstract class 'KeywordDTO' cannot be instantiated.");
    }
}

export interface IKeywordDTO extends IEntityDTO {
    name: string;
}

export class DeviationTeamInfoDTO extends KeywordDTO implements IDeviationTeamInfoDTO {
    teamType!: EnumModel;
    teamLeader!: SystemUserContactInfoDTO | null;
    members!: SystemUserContactInfoDTO[];
    regionDirectors!: DeviationTeamRegionDirectorInfoDTO[];

    constructor(data?: IDeviationTeamInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.teamType = _data["teamType"] ? EnumModel.fromJS(_data["teamType"]) : <any>null;
            this.teamLeader = _data["teamLeader"] ? SystemUserContactInfoDTO.fromJS(_data["teamLeader"]) : <any>null;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.members = <any>null;
            }
            if (Array.isArray(_data["regionDirectors"])) {
                this.regionDirectors = [] as any;
                for (let item of _data["regionDirectors"])
                    this.regionDirectors!.push(DeviationTeamRegionDirectorInfoDTO.fromJS(item));
            }
            else {
                this.regionDirectors = <any>null;
            }
        }
    }

    static fromJS(data: any): DeviationTeamInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamType"] = this.teamType ? this.teamType.toJSON() : <any>null;
        data["teamLeader"] = this.teamLeader ? this.teamLeader.toJSON() : <any>null;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.regionDirectors)) {
            data["regionDirectors"] = [];
            for (let item of this.regionDirectors)
                data["regionDirectors"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamInfoDTO {
        const json = this.toJSON();
        let result = new DeviationTeamInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamInfoDTO extends IKeywordDTO {
    teamType: EnumModel;
    teamLeader: SystemUserContactInfoDTO | null;
    members: SystemUserContactInfoDTO[];
    regionDirectors: DeviationTeamRegionDirectorInfoDTO[];
}

export class DeviationTeamUpdateDTO implements IDeviationTeamUpdateDTO {
    name!: string | null;
    emailAddress!: string | null;
    teamLeaderUniqueId!: string | null;

    constructor(data?: IDeviationTeamUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
            this.teamLeaderUniqueId = _data["teamLeaderUniqueId"] !== undefined ? _data["teamLeaderUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        data["teamLeaderUniqueId"] = this.teamLeaderUniqueId !== undefined ? this.teamLeaderUniqueId : <any>null;
        return data;
    }

    clone(): DeviationTeamUpdateDTO {
        const json = this.toJSON();
        let result = new DeviationTeamUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamUpdateDTO {
    name: string | null;
    emailAddress: string | null;
    teamLeaderUniqueId: string | null;
}

export class AddTeamMemberModel implements IAddTeamMemberModel {
    teamMemberUniqueId!: string;

    constructor(data?: IAddTeamMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberUniqueId = _data["teamMemberUniqueId"] !== undefined ? _data["teamMemberUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): AddTeamMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddTeamMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberUniqueId"] = this.teamMemberUniqueId !== undefined ? this.teamMemberUniqueId : <any>null;
        return data;
    }

    clone(): AddTeamMemberModel {
        const json = this.toJSON();
        let result = new AddTeamMemberModel();
        result.init(json);
        return result;
    }
}

export interface IAddTeamMemberModel {
    teamMemberUniqueId: string;
}

export class RemoveTeamMember implements IRemoveTeamMember {
    teamMemberId!: number;

    constructor(data?: IRemoveTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"] !== undefined ? _data["teamMemberId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveTeamMember {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId !== undefined ? this.teamMemberId : <any>null;
        return data;
    }

    clone(): RemoveTeamMember {
        const json = this.toJSON();
        let result = new RemoveTeamMember();
        result.init(json);
        return result;
    }
}

export interface IRemoveTeamMember {
    teamMemberId: number;
}

export class DeviationTeamRegionDirectorUpdateBaseDTO implements IDeviationTeamRegionDirectorUpdateBaseDTO {
    region!: string;
    directorUniqueId!: string;

    constructor(data?: IDeviationTeamRegionDirectorUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"] !== undefined ? _data["region"] : <any>null;
            this.directorUniqueId = _data["directorUniqueId"] !== undefined ? _data["directorUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamRegionDirectorUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamRegionDirectorUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["directorUniqueId"] = this.directorUniqueId !== undefined ? this.directorUniqueId : <any>null;
        return data;
    }

    clone(): DeviationTeamRegionDirectorUpdateBaseDTO {
        const json = this.toJSON();
        let result = new DeviationTeamRegionDirectorUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamRegionDirectorUpdateBaseDTO {
    region: string;
    directorUniqueId: string;
}

export class DeviationTeamRegionDirectorCreateDTO extends DeviationTeamRegionDirectorUpdateBaseDTO implements IDeviationTeamRegionDirectorCreateDTO {

    constructor(data?: IDeviationTeamRegionDirectorCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DeviationTeamRegionDirectorCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamRegionDirectorCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamRegionDirectorCreateDTO {
        const json = this.toJSON();
        let result = new DeviationTeamRegionDirectorCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamRegionDirectorCreateDTO extends IDeviationTeamRegionDirectorUpdateBaseDTO {
}

export class DeviationTeamRegionDirectorUpdateDTO extends DeviationTeamRegionDirectorUpdateBaseDTO implements IDeviationTeamRegionDirectorUpdateDTO {
    id!: number;

    constructor(data?: IDeviationTeamRegionDirectorUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): DeviationTeamRegionDirectorUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DeviationTeamRegionDirectorUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): DeviationTeamRegionDirectorUpdateDTO {
        const json = this.toJSON();
        let result = new DeviationTeamRegionDirectorUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IDeviationTeamRegionDirectorUpdateDTO extends IDeviationTeamRegionDirectorUpdateBaseDTO {
    id: number;
}

export class ChangeActiveRegionDirector implements IChangeActiveRegionDirector {
    regionDirectorId!: number;

    constructor(data?: IChangeActiveRegionDirector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regionDirectorId = _data["regionDirectorId"] !== undefined ? _data["regionDirectorId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeActiveRegionDirector {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeActiveRegionDirector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionDirectorId"] = this.regionDirectorId !== undefined ? this.regionDirectorId : <any>null;
        return data;
    }

    clone(): ChangeActiveRegionDirector {
        const json = this.toJSON();
        let result = new ChangeActiveRegionDirector();
        result.init(json);
        return result;
    }
}

export interface IChangeActiveRegionDirector {
    regionDirectorId: number;
}

export class HolidayTripDetailModel implements IHolidayTripDetailModel {
    holidayTrip!: HolidayTripDetailDTO;
    permissions!: HolidayTripPermissionsModel;

    constructor(data?: IHolidayTripDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.holidayTrip = _data["holidayTrip"] ? HolidayTripDetailDTO.fromJS(_data["holidayTrip"]) : <any>null;
            this.permissions = _data["permissions"] ? HolidayTripPermissionsModel.fromJS(_data["permissions"]) : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holidayTrip"] = this.holidayTrip ? this.holidayTrip.toJSON() : <any>null;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>null;
        return data;
    }

    clone(): HolidayTripDetailModel {
        const json = this.toJSON();
        let result = new HolidayTripDetailModel();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripDetailModel {
    holidayTrip: HolidayTripDetailDTO;
    permissions: HolidayTripPermissionsModel;
}

export class HolidayTripDetailDTO extends ArchivableEntityDetailDTO implements IHolidayTripDetailDTO {
    name!: string;
    startDate!: string;
    endDate!: string;
    accommodationSegments!: HolidayTripAccommodationSegmentDetailDTO[];
    citySegments!: HolidayTripCitySegmentDetailDTO[];
    transportationSegments!: HolidayTripTransportationSegmentDetailDTO[];
    noteSegments!: HolidayTripNoteSegmentDetailDTO[];
    countries!: CountryInfoDTO[];
    travellers!: HolidayTripTravellerDetailDTO[];
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;
    modifiedOn!: string | null;
    modifiedBy!: SystemUserInfoDTO | null;

    constructor(data?: IHolidayTripDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            if (Array.isArray(_data["accommodationSegments"])) {
                this.accommodationSegments = [] as any;
                for (let item of _data["accommodationSegments"])
                    this.accommodationSegments!.push(HolidayTripAccommodationSegmentDetailDTO.fromJS(item));
            }
            else {
                this.accommodationSegments = <any>null;
            }
            if (Array.isArray(_data["citySegments"])) {
                this.citySegments = [] as any;
                for (let item of _data["citySegments"])
                    this.citySegments!.push(HolidayTripCitySegmentDetailDTO.fromJS(item));
            }
            else {
                this.citySegments = <any>null;
            }
            if (Array.isArray(_data["transportationSegments"])) {
                this.transportationSegments = [] as any;
                for (let item of _data["transportationSegments"])
                    this.transportationSegments!.push(HolidayTripTransportationSegmentDetailDTO.fromJS(item));
            }
            else {
                this.transportationSegments = <any>null;
            }
            if (Array.isArray(_data["noteSegments"])) {
                this.noteSegments = [] as any;
                for (let item of _data["noteSegments"])
                    this.noteSegments!.push(HolidayTripNoteSegmentDetailDTO.fromJS(item));
            }
            else {
                this.noteSegments = <any>null;
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(HolidayTripTravellerDetailDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
            this.modifiedOn = _data["modifiedOn"] !== undefined ? _data["modifiedOn"] : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? SystemUserInfoDTO.fromJS(_data["modifiedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        if (Array.isArray(this.accommodationSegments)) {
            data["accommodationSegments"] = [];
            for (let item of this.accommodationSegments)
                data["accommodationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.citySegments)) {
            data["citySegments"] = [];
            for (let item of this.citySegments)
                data["citySegments"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationSegments)) {
            data["transportationSegments"] = [];
            for (let item of this.transportationSegments)
                data["transportationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.noteSegments)) {
            data["noteSegments"] = [];
            for (let item of this.noteSegments)
                data["noteSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["modifiedOn"] = this.modifiedOn !== undefined ? this.modifiedOn : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripDetailDTO extends IArchivableEntityDetailDTO {
    name: string;
    startDate: string;
    endDate: string;
    accommodationSegments: HolidayTripAccommodationSegmentDetailDTO[];
    citySegments: HolidayTripCitySegmentDetailDTO[];
    transportationSegments: HolidayTripTransportationSegmentDetailDTO[];
    noteSegments: HolidayTripNoteSegmentDetailDTO[];
    countries: CountryInfoDTO[];
    travellers: HolidayTripTravellerDetailDTO[];
    createdOn: string;
    createdBy: SystemUserInfoDTO;
    modifiedOn: string | null;
    modifiedBy: SystemUserInfoDTO | null;
}

export class HolidayTripSegmentDetailDTO implements IHolidayTripSegmentDetailDTO {
    ordinalNumber!: number;

    constructor(data?: IHolidayTripSegmentDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinalNumber = _data["ordinalNumber"] !== undefined ? _data["ordinalNumber"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinalNumber"] = this.ordinalNumber !== undefined ? this.ordinalNumber : <any>null;
        return data;
    }

    clone(): HolidayTripSegmentDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripSegmentDetailDTO {
    ordinalNumber: number;
}

export class HolidayTripAccommodationSegmentDetailDTO extends HolidayTripSegmentDetailDTO implements IHolidayTripAccommodationSegmentDetailDTO {
    arrivalDate!: string;
    departureDate!: string;
    accommodationType!: AccommodationTypeInfoDTO;
    name!: string | null;
    address!: string | null;
    city!: CityInfoDTO | null;
    cityCustomName!: string | null;
    country!: CountryInfoDTO | null;

    constructor(data?: IHolidayTripAccommodationSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.accommodationType = _data["accommodationType"] ? AccommodationTypeInfoDTO.fromJS(_data["accommodationType"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] ? CityInfoDTO.fromJS(_data["city"]) : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripAccommodationSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripAccommodationSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["accommodationType"] = this.accommodationType ? this.accommodationType.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripAccommodationSegmentDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripAccommodationSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripAccommodationSegmentDetailDTO extends IHolidayTripSegmentDetailDTO {
    arrivalDate: string;
    departureDate: string;
    accommodationType: AccommodationTypeInfoDTO;
    name: string | null;
    address: string | null;
    city: CityInfoDTO | null;
    cityCustomName: string | null;
    country: CountryInfoDTO | null;
}

export class HolidayTripCitySegmentDetailDTO extends HolidayTripSegmentDetailDTO implements IHolidayTripCitySegmentDetailDTO {
    arrivalDate!: string;
    departureDate!: string;
    city!: CityInfoDTO;

    constructor(data?: IHolidayTripCitySegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.city = _data["city"] ? CityInfoDTO.fromJS(_data["city"]) : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripCitySegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripCitySegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripCitySegmentDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripCitySegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripCitySegmentDetailDTO extends IHolidayTripSegmentDetailDTO {
    arrivalDate: string;
    departureDate: string;
    city: CityInfoDTO;
}

export class HolidayTripTransportationSegmentDetailDTO extends HolidayTripSegmentDetailDTO implements IHolidayTripTransportationSegmentDetailDTO {
    tripDate!: string;
    transportationType!: TransportationTypeInfoDTO;
    airline!: AirlineInfoDTO | null;
    airlineCustomName!: string | null;
    flightNumber!: string | null;
    note!: string | null;

    constructor(data?: IHolidayTripTransportationSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripDate = _data["tripDate"] !== undefined ? _data["tripDate"] : <any>null;
            this.transportationType = _data["transportationType"] ? TransportationTypeInfoDTO.fromJS(_data["transportationType"]) : <any>null;
            this.airline = _data["airline"] ? AirlineInfoDTO.fromJS(_data["airline"]) : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripTransportationSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripTransportationSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripDate"] = this.tripDate !== undefined ? this.tripDate : <any>null;
        data["transportationType"] = this.transportationType ? this.transportationType.toJSON() : <any>null;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripTransportationSegmentDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripTransportationSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripTransportationSegmentDetailDTO extends IHolidayTripSegmentDetailDTO {
    tripDate: string;
    transportationType: TransportationTypeInfoDTO;
    airline: AirlineInfoDTO | null;
    airlineCustomName: string | null;
    flightNumber: string | null;
    note: string | null;
}

export class TransportationTypeInfoDTO extends ArchivableOrderIconKeywordInfoDTO implements ITransportationTypeInfoDTO {
    transportationSystemType!: TransportationSystemType;

    constructor(data?: ITransportationTypeInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportationSystemType = _data["transportationSystemType"] !== undefined ? _data["transportationSystemType"] : <any>null;
        }
    }

    static fromJS(data: any): TransportationTypeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationTypeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportationSystemType"] = this.transportationSystemType !== undefined ? this.transportationSystemType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TransportationTypeInfoDTO {
        const json = this.toJSON();
        let result = new TransportationTypeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ITransportationTypeInfoDTO extends IArchivableOrderIconKeywordInfoDTO {
    transportationSystemType: TransportationSystemType;
}

export enum TransportationSystemType {
    Other = 1,
    Plane = 2,
}

export class HolidayTripNoteSegmentDetailDTO extends HolidayTripSegmentDetailDTO implements IHolidayTripNoteSegmentDetailDTO {
    note!: string;

    constructor(data?: IHolidayTripNoteSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripNoteSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripNoteSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripNoteSegmentDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripNoteSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripNoteSegmentDetailDTO extends IHolidayTripSegmentDetailDTO {
    note: string;
}

export class HolidayTripTravellerDetailDTO implements IHolidayTripTravellerDetailDTO {
    user!: SystemUserContactInfoDTO;
    personalNumber!: string | null;
    relatedTravellers!: HolidayTripRelatedTravellerDetailDTO[];

    constructor(data?: IHolidayTripTravellerDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? SystemUserContactInfoDTO.fromJS(_data["user"]) : <any>null;
            this.personalNumber = _data["personalNumber"] !== undefined ? _data["personalNumber"] : <any>null;
            if (Array.isArray(_data["relatedTravellers"])) {
                this.relatedTravellers = [] as any;
                for (let item of _data["relatedTravellers"])
                    this.relatedTravellers!.push(HolidayTripRelatedTravellerDetailDTO.fromJS(item));
            }
            else {
                this.relatedTravellers = <any>null;
            }
        }
    }

    static fromJS(data: any): HolidayTripTravellerDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripTravellerDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["personalNumber"] = this.personalNumber !== undefined ? this.personalNumber : <any>null;
        if (Array.isArray(this.relatedTravellers)) {
            data["relatedTravellers"] = [];
            for (let item of this.relatedTravellers)
                data["relatedTravellers"].push(item.toJSON());
        }
        return data;
    }

    clone(): HolidayTripTravellerDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripTravellerDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripTravellerDetailDTO {
    user: SystemUserContactInfoDTO;
    personalNumber: string | null;
    relatedTravellers: HolidayTripRelatedTravellerDetailDTO[];
}

export class HolidayTripRelatedTravellerDetailDTO implements IHolidayTripRelatedTravellerDetailDTO {
    name!: string;
    relation!: string;

    constructor(data?: IHolidayTripRelatedTravellerDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripRelatedTravellerDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripRelatedTravellerDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        return data;
    }

    clone(): HolidayTripRelatedTravellerDetailDTO {
        const json = this.toJSON();
        let result = new HolidayTripRelatedTravellerDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripRelatedTravellerDetailDTO {
    name: string;
    relation: string;
}

export class HolidayTripPermissionsModel implements IHolidayTripPermissionsModel {
    canEdit!: boolean;
    canArchive!: boolean;
    canUnarchive!: boolean;

    constructor(data?: IHolidayTripPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEdit = _data["canEdit"] !== undefined ? _data["canEdit"] : <any>null;
            this.canArchive = _data["canArchive"] !== undefined ? _data["canArchive"] : <any>null;
            this.canUnarchive = _data["canUnarchive"] !== undefined ? _data["canUnarchive"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEdit"] = this.canEdit !== undefined ? this.canEdit : <any>null;
        data["canArchive"] = this.canArchive !== undefined ? this.canArchive : <any>null;
        data["canUnarchive"] = this.canUnarchive !== undefined ? this.canUnarchive : <any>null;
        return data;
    }

    clone(): HolidayTripPermissionsModel {
        const json = this.toJSON();
        let result = new HolidayTripPermissionsModel();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripPermissionsModel {
    canEdit: boolean;
    canArchive: boolean;
    canUnarchive: boolean;
}

export class QueryResultOfHolidayTripListQueryDTO implements IQueryResultOfHolidayTripListQueryDTO {
    metaData!: QueryResultMetaDataOfHolidayTripListQueryDTO;
    data!: HolidayTripListQueryDTO[];

    constructor(data?: IQueryResultOfHolidayTripListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfHolidayTripListQueryDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(HolidayTripListQueryDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfHolidayTripListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfHolidayTripListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfHolidayTripListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultOfHolidayTripListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfHolidayTripListQueryDTO {
    metaData: QueryResultMetaDataOfHolidayTripListQueryDTO;
    data: HolidayTripListQueryDTO[];
}

export class QueryResultMetaDataOfHolidayTripListQueryDTO implements IQueryResultMetaDataOfHolidayTripListQueryDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfHolidayTripListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfHolidayTripListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfHolidayTripListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfHolidayTripListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfHolidayTripListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfHolidayTripListQueryDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class HolidayTripListQueryDTO extends ArchivableEntityInfoDTO implements IHolidayTripListQueryDTO {
    name!: string;
    startDate!: string;
    endDate!: string;
    countries!: CountryInfoDTO[];
    travellers!: SystemUserInfoDTO[];

    constructor(data?: IHolidayTripListQueryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(SystemUserInfoDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
        }
    }

    static fromJS(data: any): HolidayTripListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripListQueryDTO {
        const json = this.toJSON();
        let result = new HolidayTripListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripListQueryDTO extends IArchivableEntityInfoDTO {
    name: string;
    startDate: string;
    endDate: string;
    countries: CountryInfoDTO[];
    travellers: SystemUserInfoDTO[];
}

export abstract class HolidayTripUpdateBaseDTO implements IHolidayTripUpdateBaseDTO {
    name!: string;
    accommodationSegments!: HolidayTripAccommodationSegmentUpdateDTO[];
    citySegments!: HolidayTripCitySegmentUpdateDTO[];
    transportationSegments!: HolidayTripTransportationSegmentUpdateDTO[];
    noteSegments!: HolidayTripNoteSegmentUpdateDTO[];
    travellers!: HolidayTripTravellerUpdateDTO[];

    constructor(data?: IHolidayTripUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["accommodationSegments"])) {
                this.accommodationSegments = [] as any;
                for (let item of _data["accommodationSegments"])
                    this.accommodationSegments!.push(HolidayTripAccommodationSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.accommodationSegments = <any>null;
            }
            if (Array.isArray(_data["citySegments"])) {
                this.citySegments = [] as any;
                for (let item of _data["citySegments"])
                    this.citySegments!.push(HolidayTripCitySegmentUpdateDTO.fromJS(item));
            }
            else {
                this.citySegments = <any>null;
            }
            if (Array.isArray(_data["transportationSegments"])) {
                this.transportationSegments = [] as any;
                for (let item of _data["transportationSegments"])
                    this.transportationSegments!.push(HolidayTripTransportationSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.transportationSegments = <any>null;
            }
            if (Array.isArray(_data["noteSegments"])) {
                this.noteSegments = [] as any;
                for (let item of _data["noteSegments"])
                    this.noteSegments!.push(HolidayTripNoteSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.noteSegments = <any>null;
            }
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(HolidayTripTravellerUpdateDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
        }
    }

    static fromJS(data: any): HolidayTripUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HolidayTripUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.accommodationSegments)) {
            data["accommodationSegments"] = [];
            for (let item of this.accommodationSegments)
                data["accommodationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.citySegments)) {
            data["citySegments"] = [];
            for (let item of this.citySegments)
                data["citySegments"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationSegments)) {
            data["transportationSegments"] = [];
            for (let item of this.transportationSegments)
                data["transportationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.noteSegments)) {
            data["noteSegments"] = [];
            for (let item of this.noteSegments)
                data["noteSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        return data;
    }

    clone(): HolidayTripUpdateBaseDTO {
        throw new Error("The abstract class 'HolidayTripUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IHolidayTripUpdateBaseDTO {
    name: string;
    accommodationSegments: HolidayTripAccommodationSegmentUpdateDTO[];
    citySegments: HolidayTripCitySegmentUpdateDTO[];
    transportationSegments: HolidayTripTransportationSegmentUpdateDTO[];
    noteSegments: HolidayTripNoteSegmentUpdateDTO[];
    travellers: HolidayTripTravellerUpdateDTO[];
}

export class HolidayTripCreateDTO extends HolidayTripUpdateBaseDTO implements IHolidayTripCreateDTO {

    constructor(data?: IHolidayTripCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HolidayTripCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripCreateDTO {
        const json = this.toJSON();
        let result = new HolidayTripCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripCreateDTO extends IHolidayTripUpdateBaseDTO {
}

export abstract class HolidayTripSegmentUpdateBaseDTO implements IHolidayTripSegmentUpdateBaseDTO {
    ordinalNumber!: number;

    constructor(data?: IHolidayTripSegmentUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinalNumber = _data["ordinalNumber"] !== undefined ? _data["ordinalNumber"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripSegmentUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'HolidayTripSegmentUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinalNumber"] = this.ordinalNumber !== undefined ? this.ordinalNumber : <any>null;
        return data;
    }

    clone(): HolidayTripSegmentUpdateBaseDTO {
        throw new Error("The abstract class 'HolidayTripSegmentUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IHolidayTripSegmentUpdateBaseDTO {
    ordinalNumber: number;
}

export class HolidayTripAccommodationSegmentUpdateDTO extends HolidayTripSegmentUpdateBaseDTO implements IHolidayTripAccommodationSegmentUpdateDTO {
    arrivalDate!: string;
    departureDate!: string;
    accommodationTypeId!: number;
    name!: string;
    address!: string | null;
    cityId!: number | null;
    cityCustomName!: string | null;
    countryId!: number;

    constructor(data?: IHolidayTripAccommodationSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.accommodationTypeId = _data["accommodationTypeId"] !== undefined ? _data["accommodationTypeId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripAccommodationSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripAccommodationSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["accommodationTypeId"] = this.accommodationTypeId !== undefined ? this.accommodationTypeId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripAccommodationSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripAccommodationSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripAccommodationSegmentUpdateDTO extends IHolidayTripSegmentUpdateBaseDTO {
    arrivalDate: string;
    departureDate: string;
    accommodationTypeId: number;
    name: string;
    address: string | null;
    cityId: number | null;
    cityCustomName: string | null;
    countryId: number;
}

export class HolidayTripCitySegmentUpdateDTO extends HolidayTripSegmentUpdateBaseDTO implements IHolidayTripCitySegmentUpdateDTO {
    arrivalDate!: string;
    departureDate!: string;
    cityId!: number;

    constructor(data?: IHolidayTripCitySegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripCitySegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripCitySegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripCitySegmentUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripCitySegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripCitySegmentUpdateDTO extends IHolidayTripSegmentUpdateBaseDTO {
    arrivalDate: string;
    departureDate: string;
    cityId: number;
}

export class HolidayTripTransportationSegmentUpdateDTO extends HolidayTripSegmentUpdateBaseDTO implements IHolidayTripTransportationSegmentUpdateDTO {
    tripDate!: string;
    transportationTypeId!: number;
    airlineId!: number | null;
    airlineCustomName!: string | null;
    flightNumber!: string | null;
    note!: string | null;

    constructor(data?: IHolidayTripTransportationSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripDate = _data["tripDate"] !== undefined ? _data["tripDate"] : <any>null;
            this.transportationTypeId = _data["transportationTypeId"] !== undefined ? _data["transportationTypeId"] : <any>null;
            this.airlineId = _data["airlineId"] !== undefined ? _data["airlineId"] : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripTransportationSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripTransportationSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripDate"] = this.tripDate !== undefined ? this.tripDate : <any>null;
        data["transportationTypeId"] = this.transportationTypeId !== undefined ? this.transportationTypeId : <any>null;
        data["airlineId"] = this.airlineId !== undefined ? this.airlineId : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripTransportationSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripTransportationSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripTransportationSegmentUpdateDTO extends IHolidayTripSegmentUpdateBaseDTO {
    tripDate: string;
    transportationTypeId: number;
    airlineId: number | null;
    airlineCustomName: string | null;
    flightNumber: string | null;
    note: string | null;
}

export class HolidayTripNoteSegmentUpdateDTO extends HolidayTripSegmentUpdateBaseDTO implements IHolidayTripNoteSegmentUpdateDTO {
    note!: string;

    constructor(data?: IHolidayTripNoteSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripNoteSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripNoteSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripNoteSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripNoteSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripNoteSegmentUpdateDTO extends IHolidayTripSegmentUpdateBaseDTO {
    note: string;
}

export class HolidayTripTravellerUpdateDTO implements IHolidayTripTravellerUpdateDTO {
    userUniqueId!: string;
    personalNumber!: string | null;
    relatedTravellers!: HolidayTripRelatedTravellerUpdateDTO[];

    constructor(data?: IHolidayTripTravellerUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userUniqueId = _data["userUniqueId"] !== undefined ? _data["userUniqueId"] : <any>null;
            this.personalNumber = _data["personalNumber"] !== undefined ? _data["personalNumber"] : <any>null;
            if (Array.isArray(_data["relatedTravellers"])) {
                this.relatedTravellers = [] as any;
                for (let item of _data["relatedTravellers"])
                    this.relatedTravellers!.push(HolidayTripRelatedTravellerUpdateDTO.fromJS(item));
            }
            else {
                this.relatedTravellers = <any>null;
            }
        }
    }

    static fromJS(data: any): HolidayTripTravellerUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripTravellerUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userUniqueId"] = this.userUniqueId !== undefined ? this.userUniqueId : <any>null;
        data["personalNumber"] = this.personalNumber !== undefined ? this.personalNumber : <any>null;
        if (Array.isArray(this.relatedTravellers)) {
            data["relatedTravellers"] = [];
            for (let item of this.relatedTravellers)
                data["relatedTravellers"].push(item.toJSON());
        }
        return data;
    }

    clone(): HolidayTripTravellerUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripTravellerUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripTravellerUpdateDTO {
    userUniqueId: string;
    personalNumber: string | null;
    relatedTravellers: HolidayTripRelatedTravellerUpdateDTO[];
}

export class HolidayTripRelatedTravellerUpdateDTO implements IHolidayTripRelatedTravellerUpdateDTO {
    name!: string;
    relation!: string;

    constructor(data?: IHolidayTripRelatedTravellerUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.relation = _data["relation"] !== undefined ? _data["relation"] : <any>null;
        }
    }

    static fromJS(data: any): HolidayTripRelatedTravellerUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripRelatedTravellerUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["relation"] = this.relation !== undefined ? this.relation : <any>null;
        return data;
    }

    clone(): HolidayTripRelatedTravellerUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripRelatedTravellerUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripRelatedTravellerUpdateDTO {
    name: string;
    relation: string;
}

export class HolidayTripUpdateDTO extends HolidayTripUpdateBaseDTO implements IHolidayTripUpdateDTO {

    constructor(data?: IHolidayTripUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): HolidayTripUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayTripUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): HolidayTripUpdateDTO {
        const json = this.toJSON();
        let result = new HolidayTripUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IHolidayTripUpdateDTO extends IHolidayTripUpdateBaseDTO {
}

export class MapZoneDetailDTO extends ArchivableKeywordDetailDTO implements IMapZoneDetailDTO {
    featureCollection!: string;
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;
    modifiedOn!: string | null;
    modifiedBy!: SystemUserInfoDTO | null;

    constructor(data?: IMapZoneDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.featureCollection = _data["featureCollection"] !== undefined ? _data["featureCollection"] : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
            this.modifiedOn = _data["modifiedOn"] !== undefined ? _data["modifiedOn"] : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? SystemUserInfoDTO.fromJS(_data["modifiedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): MapZoneDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapZoneDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureCollection"] = this.featureCollection !== undefined ? this.featureCollection : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["modifiedOn"] = this.modifiedOn !== undefined ? this.modifiedOn : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): MapZoneDetailDTO {
        const json = this.toJSON();
        let result = new MapZoneDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IMapZoneDetailDTO extends IArchivableKeywordDetailDTO {
    featureCollection: string;
    createdOn: string;
    createdBy: SystemUserInfoDTO;
    modifiedOn: string | null;
    modifiedBy: SystemUserInfoDTO | null;
}

export class QueryResultOfMapZoneDetailDTO implements IQueryResultOfMapZoneDetailDTO {
    metaData!: QueryResultMetaDataOfMapZoneDetailDTO;
    data!: MapZoneDetailDTO[];

    constructor(data?: IQueryResultOfMapZoneDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfMapZoneDetailDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MapZoneDetailDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfMapZoneDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfMapZoneDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfMapZoneDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultOfMapZoneDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfMapZoneDetailDTO {
    metaData: QueryResultMetaDataOfMapZoneDetailDTO;
    data: MapZoneDetailDTO[];
}

export class QueryResultMetaDataOfMapZoneDetailDTO implements IQueryResultMetaDataOfMapZoneDetailDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfMapZoneDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfMapZoneDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfMapZoneDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfMapZoneDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfMapZoneDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfMapZoneDetailDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class MapZoneInfoDTO extends ArchivableKeywordInfoDTO implements IMapZoneInfoDTO {

    constructor(data?: IMapZoneInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MapZoneInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapZoneInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MapZoneInfoDTO {
        const json = this.toJSON();
        let result = new MapZoneInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IMapZoneInfoDTO extends IArchivableKeywordInfoDTO {
}

export class MapZoneUpdateBaseDTO extends KeywordUpdateBaseDTO implements IMapZoneUpdateBaseDTO {
    featureCollection!: string;

    constructor(data?: IMapZoneUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.featureCollection = _data["featureCollection"] !== undefined ? _data["featureCollection"] : <any>null;
        }
    }

    static fromJS(data: any): MapZoneUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapZoneUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureCollection"] = this.featureCollection !== undefined ? this.featureCollection : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): MapZoneUpdateBaseDTO {
        const json = this.toJSON();
        let result = new MapZoneUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface IMapZoneUpdateBaseDTO extends IKeywordUpdateBaseDTO {
    featureCollection: string;
}

export class MapZoneCreateDTO extends MapZoneUpdateBaseDTO implements IMapZoneCreateDTO {

    constructor(data?: IMapZoneCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MapZoneCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapZoneCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MapZoneCreateDTO {
        const json = this.toJSON();
        let result = new MapZoneCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IMapZoneCreateDTO extends IMapZoneUpdateBaseDTO {
}

export class MapZoneUpdateDTO extends MapZoneUpdateBaseDTO implements IMapZoneUpdateDTO {

    constructor(data?: IMapZoneUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MapZoneUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MapZoneUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MapZoneUpdateDTO {
        const json = this.toJSON();
        let result = new MapZoneUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IMapZoneUpdateDTO extends IMapZoneUpdateBaseDTO {
}

export class UsersLatestLocationsModel implements IUsersLatestLocationsModel {
    usersLatestLocations!: UserLocationDTO[];
    countryUsersCounts!: CountryUsersCountDTO[];

    constructor(data?: IUsersLatestLocationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usersLatestLocations"])) {
                this.usersLatestLocations = [] as any;
                for (let item of _data["usersLatestLocations"])
                    this.usersLatestLocations!.push(UserLocationDTO.fromJS(item));
            }
            else {
                this.usersLatestLocations = <any>null;
            }
            if (Array.isArray(_data["countryUsersCounts"])) {
                this.countryUsersCounts = [] as any;
                for (let item of _data["countryUsersCounts"])
                    this.countryUsersCounts!.push(CountryUsersCountDTO.fromJS(item));
            }
            else {
                this.countryUsersCounts = <any>null;
            }
        }
    }

    static fromJS(data: any): UsersLatestLocationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLatestLocationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usersLatestLocations)) {
            data["usersLatestLocations"] = [];
            for (let item of this.usersLatestLocations)
                data["usersLatestLocations"].push(item.toJSON());
        }
        if (Array.isArray(this.countryUsersCounts)) {
            data["countryUsersCounts"] = [];
            for (let item of this.countryUsersCounts)
                data["countryUsersCounts"].push(item.toJSON());
        }
        return data;
    }

    clone(): UsersLatestLocationsModel {
        const json = this.toJSON();
        let result = new UsersLatestLocationsModel();
        result.init(json);
        return result;
    }
}

export interface IUsersLatestLocationsModel {
    usersLatestLocations: UserLocationDTO[];
    countryUsersCounts: CountryUsersCountDTO[];
}

export class UserLocationDTO implements IUserLocationDTO {
    user!: UserDTO;
    location!: LocationDTO;

    constructor(data?: IUserLocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : <any>null;
            this.location = _data["location"] ? LocationDTO.fromJS(_data["location"]) : <any>null;
        }
    }

    static fromJS(data: any): UserLocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        return data;
    }

    clone(): UserLocationDTO {
        const json = this.toJSON();
        let result = new UserLocationDTO();
        result.init(json);
        return result;
    }
}

export interface IUserLocationDTO {
    user: UserDTO;
    location: LocationDTO;
}

export class UserDTO implements IUserDTO {
    uniqueId!: string;
    loginName!: string | null;
    fullName!: string | null;
    email!: string | null;
    phoneNumber!: string | null;
    otherPhoneNumbers!: string[];

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : <any>null;
            this.loginName = _data["loginName"] !== undefined ? _data["loginName"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            if (Array.isArray(_data["otherPhoneNumbers"])) {
                this.otherPhoneNumbers = [] as any;
                for (let item of _data["otherPhoneNumbers"])
                    this.otherPhoneNumbers!.push(item);
            }
            else {
                this.otherPhoneNumbers = <any>null;
            }
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : <any>null;
        data["loginName"] = this.loginName !== undefined ? this.loginName : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        if (Array.isArray(this.otherPhoneNumbers)) {
            data["otherPhoneNumbers"] = [];
            for (let item of this.otherPhoneNumbers)
                data["otherPhoneNumbers"].push(item);
        }
        return data;
    }

    clone(): UserDTO {
        const json = this.toJSON();
        let result = new UserDTO();
        result.init(json);
        return result;
    }
}

export interface IUserDTO {
    uniqueId: string;
    loginName: string | null;
    fullName: string | null;
    email: string | null;
    phoneNumber: string | null;
    otherPhoneNumbers: string[];
}

export class LocationDTO implements ILocationDTO {
    id!: string;
    timeStamp!: string;
    currentnessStatus!: LocationCurrentnessStatus;
    country!: CountryInfoDTO | null;
    coordinates!: number[];

    constructor(data?: ILocationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.timeStamp = _data["timeStamp"] !== undefined ? _data["timeStamp"] : <any>null;
            this.currentnessStatus = _data["currentnessStatus"] !== undefined ? _data["currentnessStatus"] : <any>null;
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            if (Array.isArray(_data["coordinates"])) {
                this.coordinates = [] as any;
                for (let item of _data["coordinates"])
                    this.coordinates!.push(item);
            }
            else {
                this.coordinates = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["timeStamp"] = this.timeStamp !== undefined ? this.timeStamp : <any>null;
        data["currentnessStatus"] = this.currentnessStatus !== undefined ? this.currentnessStatus : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        if (Array.isArray(this.coordinates)) {
            data["coordinates"] = [];
            for (let item of this.coordinates)
                data["coordinates"].push(item);
        }
        return data;
    }

    clone(): LocationDTO {
        const json = this.toJSON();
        let result = new LocationDTO();
        result.init(json);
        return result;
    }
}

export interface ILocationDTO {
    id: string;
    timeStamp: string;
    currentnessStatus: LocationCurrentnessStatus;
    country: CountryInfoDTO | null;
    coordinates: number[];
}

export enum LocationCurrentnessStatus {
    OneHour = 1,
    OneDay = 2,
    Older = 3,
}

export class CountryUsersCountDTO implements ICountryUsersCountDTO {
    country!: CountryInfoDTO;
    usersCount!: number;

    constructor(data?: ICountryUsersCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.usersCount = _data["usersCount"] !== undefined ? _data["usersCount"] : <any>null;
        }
    }

    static fromJS(data: any): CountryUsersCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryUsersCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["usersCount"] = this.usersCount !== undefined ? this.usersCount : <any>null;
        return data;
    }

    clone(): CountryUsersCountDTO {
        const json = this.toJSON();
        let result = new CountryUsersCountDTO();
        result.init(json);
        return result;
    }
}

export interface ICountryUsersCountDTO {
    country: CountryInfoDTO;
    usersCount: number;
}

export class ActiveUsersDTO implements IActiveUsersDTO {
    dateRangeName!: string;
    usersCount!: number;

    constructor(data?: IActiveUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRangeName = _data["dateRangeName"] !== undefined ? _data["dateRangeName"] : <any>null;
            this.usersCount = _data["usersCount"] !== undefined ? _data["usersCount"] : <any>null;
        }
    }

    static fromJS(data: any): ActiveUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRangeName"] = this.dateRangeName !== undefined ? this.dateRangeName : <any>null;
        data["usersCount"] = this.usersCount !== undefined ? this.usersCount : <any>null;
        return data;
    }

    clone(): ActiveUsersDTO {
        const json = this.toJSON();
        let result = new ActiveUsersDTO();
        result.init(json);
        return result;
    }
}

export interface IActiveUsersDTO {
    dateRangeName: string;
    usersCount: number;
}

export class InstallationInfoDTO implements IInstallationInfoDTO {
    version!: Version | null;
    count!: number;

    constructor(data?: IInstallationInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] ? Version.fromJS(_data["version"]) : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): InstallationInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InstallationInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version ? this.version.toJSON() : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): InstallationInfoDTO {
        const json = this.toJSON();
        let result = new InstallationInfoDTO();
        result.init(json);
        return result;
    }
}

export interface IInstallationInfoDTO {
    version: Version | null;
    count: number;
}

export class Version implements IVersion {
    major!: number;
    minor!: number;
    patch!: number;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.major = _data["major"] !== undefined ? _data["major"] : <any>null;
            this.minor = _data["minor"] !== undefined ? _data["minor"] : <any>null;
            this.patch = _data["patch"] !== undefined ? _data["patch"] : <any>null;
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["major"] = this.major !== undefined ? this.major : <any>null;
        data["minor"] = this.minor !== undefined ? this.minor : <any>null;
        data["patch"] = this.patch !== undefined ? this.patch : <any>null;
        return data;
    }

    clone(): Version {
        const json = this.toJSON();
        let result = new Version();
        result.init(json);
        return result;
    }
}

export interface IVersion {
    major: number;
    minor: number;
    patch: number;
}

export class PanicRequestDTO implements IPanicRequestDTO {
    id!: string;
    timeStamp!: string;
    user!: UserDTO;
    isActive!: boolean;
    isTest!: boolean;
    cannotSpeak!: boolean;
    cannotSpeakOptions!: EnumerationDTO[];
    location!: LocationDetailDTO | null;

    constructor(data?: IPanicRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.timeStamp = _data["timeStamp"] !== undefined ? _data["timeStamp"] : <any>null;
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.isTest = _data["isTest"] !== undefined ? _data["isTest"] : <any>null;
            this.cannotSpeak = _data["cannotSpeak"] !== undefined ? _data["cannotSpeak"] : <any>null;
            if (Array.isArray(_data["cannotSpeakOptions"])) {
                this.cannotSpeakOptions = [] as any;
                for (let item of _data["cannotSpeakOptions"])
                    this.cannotSpeakOptions!.push(EnumerationDTO.fromJS(item));
            }
            else {
                this.cannotSpeakOptions = <any>null;
            }
            this.location = _data["location"] ? LocationDetailDTO.fromJS(_data["location"]) : <any>null;
        }
    }

    static fromJS(data: any): PanicRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PanicRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["timeStamp"] = this.timeStamp !== undefined ? this.timeStamp : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["isTest"] = this.isTest !== undefined ? this.isTest : <any>null;
        data["cannotSpeak"] = this.cannotSpeak !== undefined ? this.cannotSpeak : <any>null;
        if (Array.isArray(this.cannotSpeakOptions)) {
            data["cannotSpeakOptions"] = [];
            for (let item of this.cannotSpeakOptions)
                data["cannotSpeakOptions"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        return data;
    }

    clone(): PanicRequestDTO {
        const json = this.toJSON();
        let result = new PanicRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IPanicRequestDTO {
    id: string;
    timeStamp: string;
    user: UserDTO;
    isActive: boolean;
    isTest: boolean;
    cannotSpeak: boolean;
    cannotSpeakOptions: EnumerationDTO[];
    location: LocationDetailDTO | null;
}

export class EnumerationDTO implements IEnumerationDTO {
    id!: string | null;
    name!: string | null;

    constructor(data?: IEnumerationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): EnumerationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnumerationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }

    clone(): EnumerationDTO {
        const json = this.toJSON();
        let result = new EnumerationDTO();
        result.init(json);
        return result;
    }
}

export interface IEnumerationDTO {
    id: string | null;
    name: string | null;
}

export class LocationMetadataDTO implements ILocationMetadataDTO {
    id!: string | null;
    timestamp!: string;
    accuracy!: number;
    altitude!: number;
    altitudeAccuracy!: number;
    heading!: number;
    headingAccuracy!: number;
    speed!: number;
    speedAccuracy!: number;
    activity!: LocationActivityDTO | null;
    event!: LocationEvent;
    mode!: TrackingMode | null;

    constructor(data?: ILocationMetadataDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.timestamp = _data["timestamp"] !== undefined ? _data["timestamp"] : <any>null;
            this.accuracy = _data["accuracy"] !== undefined ? _data["accuracy"] : <any>null;
            this.altitude = _data["altitude"] !== undefined ? _data["altitude"] : <any>null;
            this.altitudeAccuracy = _data["altitudeAccuracy"] !== undefined ? _data["altitudeAccuracy"] : <any>null;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : <any>null;
            this.headingAccuracy = _data["headingAccuracy"] !== undefined ? _data["headingAccuracy"] : <any>null;
            this.speed = _data["speed"] !== undefined ? _data["speed"] : <any>null;
            this.speedAccuracy = _data["speedAccuracy"] !== undefined ? _data["speedAccuracy"] : <any>null;
            this.activity = _data["activity"] ? LocationActivityDTO.fromJS(_data["activity"]) : <any>null;
            this.event = _data["event"] !== undefined ? _data["event"] : <any>null;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : <any>null;
        }
    }

    static fromJS(data: any): LocationMetadataDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationMetadataDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["timestamp"] = this.timestamp !== undefined ? this.timestamp : <any>null;
        data["accuracy"] = this.accuracy !== undefined ? this.accuracy : <any>null;
        data["altitude"] = this.altitude !== undefined ? this.altitude : <any>null;
        data["altitudeAccuracy"] = this.altitudeAccuracy !== undefined ? this.altitudeAccuracy : <any>null;
        data["heading"] = this.heading !== undefined ? this.heading : <any>null;
        data["headingAccuracy"] = this.headingAccuracy !== undefined ? this.headingAccuracy : <any>null;
        data["speed"] = this.speed !== undefined ? this.speed : <any>null;
        data["speedAccuracy"] = this.speedAccuracy !== undefined ? this.speedAccuracy : <any>null;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>null;
        data["event"] = this.event !== undefined ? this.event : <any>null;
        data["mode"] = this.mode !== undefined ? this.mode : <any>null;
        return data;
    }

    clone(): LocationMetadataDTO {
        const json = this.toJSON();
        let result = new LocationMetadataDTO();
        result.init(json);
        return result;
    }
}

export interface ILocationMetadataDTO {
    id: string | null;
    timestamp: string;
    accuracy: number;
    altitude: number;
    altitudeAccuracy: number;
    heading: number;
    headingAccuracy: number;
    speed: number;
    speedAccuracy: number;
    activity: LocationActivityDTO | null;
    event: LocationEvent;
    mode: TrackingMode | null;
}

export class LocationDetailDTO extends LocationMetadataDTO implements ILocationDetailDTO {
    latitude!: number;
    longitude!: number;

    constructor(data?: ILocationDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): LocationDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): LocationDetailDTO {
        const json = this.toJSON();
        let result = new LocationDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ILocationDetailDTO extends ILocationMetadataDTO {
    latitude: number;
    longitude: number;
}

export class LocationActivityDTO implements ILocationActivityDTO {
    type!: string | null;
    confidence!: number;

    constructor(data?: ILocationActivityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.confidence = _data["confidence"] !== undefined ? _data["confidence"] : <any>null;
        }
    }

    static fromJS(data: any): LocationActivityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LocationActivityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["confidence"] = this.confidence !== undefined ? this.confidence : <any>null;
        return data;
    }

    clone(): LocationActivityDTO {
        const json = this.toJSON();
        let result = new LocationActivityDTO();
        result.init(json);
        return result;
    }
}

export interface ILocationActivityDTO {
    type: string | null;
    confidence: number;
}

export enum LocationEvent {
    TrackMe = 1,
    TrackingStart = 2,
    TrackingStop = 3,
    CheckIn = 4,
    Panic = 5,
    Explicit = 6,
    Unknown = 999,
}

export enum TrackingMode {
    PowerSaving = 1,
    Balanced = 10,
    Precise = 20,
}

export class DelayedPanicRequestDTO implements IDelayedPanicRequestDTO {
    id!: string;
    createdOn!: string;
    delayedUntil!: string | null;
    user!: UserDTO;
    state!: EnumModel;
    stateUpdatedOn!: string;
    isTest!: boolean;
    panicRequestId!: string | null;

    constructor(data?: IDelayedPanicRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.delayedUntil = _data["delayedUntil"] !== undefined ? _data["delayedUntil"] : <any>null;
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : <any>null;
            this.state = _data["state"] ? EnumModel.fromJS(_data["state"]) : <any>null;
            this.stateUpdatedOn = _data["stateUpdatedOn"] !== undefined ? _data["stateUpdatedOn"] : <any>null;
            this.isTest = _data["isTest"] !== undefined ? _data["isTest"] : <any>null;
            this.panicRequestId = _data["panicRequestId"] !== undefined ? _data["panicRequestId"] : <any>null;
        }
    }

    static fromJS(data: any): DelayedPanicRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DelayedPanicRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["delayedUntil"] = this.delayedUntil !== undefined ? this.delayedUntil : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["state"] = this.state ? this.state.toJSON() : <any>null;
        data["stateUpdatedOn"] = this.stateUpdatedOn !== undefined ? this.stateUpdatedOn : <any>null;
        data["isTest"] = this.isTest !== undefined ? this.isTest : <any>null;
        data["panicRequestId"] = this.panicRequestId !== undefined ? this.panicRequestId : <any>null;
        return data;
    }

    clone(): DelayedPanicRequestDTO {
        const json = this.toJSON();
        let result = new DelayedPanicRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IDelayedPanicRequestDTO {
    id: string;
    createdOn: string;
    delayedUntil: string | null;
    user: UserDTO;
    state: EnumModel;
    stateUpdatedOn: string;
    isTest: boolean;
    panicRequestId: string | null;
}

export class TrackingUsersDTO implements ITrackingUsersDTO {
    dateRangeName!: string;
    trackingUsersCount!: number;
    checkInUsersCount!: number;

    constructor(data?: ITrackingUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRangeName = _data["dateRangeName"] !== undefined ? _data["dateRangeName"] : <any>null;
            this.trackingUsersCount = _data["trackingUsersCount"] !== undefined ? _data["trackingUsersCount"] : <any>null;
            this.checkInUsersCount = _data["checkInUsersCount"] !== undefined ? _data["checkInUsersCount"] : <any>null;
        }
    }

    static fromJS(data: any): TrackingUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRangeName"] = this.dateRangeName !== undefined ? this.dateRangeName : <any>null;
        data["trackingUsersCount"] = this.trackingUsersCount !== undefined ? this.trackingUsersCount : <any>null;
        data["checkInUsersCount"] = this.checkInUsersCount !== undefined ? this.checkInUsersCount : <any>null;
        return data;
    }

    clone(): TrackingUsersDTO {
        const json = this.toJSON();
        let result = new TrackingUsersDTO();
        result.init(json);
        return result;
    }
}

export interface ITrackingUsersDTO {
    dateRangeName: string;
    trackingUsersCount: number;
    checkInUsersCount: number;
}

export class TrackingHourlyDTO implements ITrackingHourlyDTO {
    dateTime!: string;
    count!: number;

    constructor(data?: ITrackingHourlyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] !== undefined ? _data["dateTime"] : <any>null;
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
        }
    }

    static fromJS(data: any): TrackingHourlyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TrackingHourlyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime !== undefined ? this.dateTime : <any>null;
        data["count"] = this.count !== undefined ? this.count : <any>null;
        return data;
    }

    clone(): TrackingHourlyDTO {
        const json = this.toJSON();
        let result = new TrackingHourlyDTO();
        result.init(json);
        return result;
    }
}

export interface ITrackingHourlyDTO {
    dateTime: string;
    count: number;
}

export class UserLocationRequestDTO implements IUserLocationRequestDTO {
    id!: string;
    requestedByName!: string;
    userUniqueId!: string;
    userName!: string | null;
    userEmail!: string | null;
    state!: EnumModel;
    stateUpdatedOn!: string;
    requestedOn!: string;

    constructor(data?: IUserLocationRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.requestedByName = _data["requestedByName"] !== undefined ? _data["requestedByName"] : <any>null;
            this.userUniqueId = _data["userUniqueId"] !== undefined ? _data["userUniqueId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : <any>null;
            this.state = _data["state"] ? EnumModel.fromJS(_data["state"]) : <any>null;
            this.stateUpdatedOn = _data["stateUpdatedOn"] !== undefined ? _data["stateUpdatedOn"] : <any>null;
            this.requestedOn = _data["requestedOn"] !== undefined ? _data["requestedOn"] : <any>null;
        }
    }

    static fromJS(data: any): UserLocationRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocationRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["requestedByName"] = this.requestedByName !== undefined ? this.requestedByName : <any>null;
        data["userUniqueId"] = this.userUniqueId !== undefined ? this.userUniqueId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : <any>null;
        data["state"] = this.state ? this.state.toJSON() : <any>null;
        data["stateUpdatedOn"] = this.stateUpdatedOn !== undefined ? this.stateUpdatedOn : <any>null;
        data["requestedOn"] = this.requestedOn !== undefined ? this.requestedOn : <any>null;
        return data;
    }

    clone(): UserLocationRequestDTO {
        const json = this.toJSON();
        let result = new UserLocationRequestDTO();
        result.init(json);
        return result;
    }
}

export interface IUserLocationRequestDTO {
    id: string;
    requestedByName: string;
    userUniqueId: string;
    userName: string | null;
    userEmail: string | null;
    state: EnumModel;
    stateUpdatedOn: string;
    requestedOn: string;
}

export class OrganisationEntityDetailDTO extends ArchivableCodeKeywordDetailDTO implements IOrganisationEntityDetailDTO {

    constructor(data?: IOrganisationEntityDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationEntityDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationEntityDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganisationEntityDetailDTO {
        const json = this.toJSON();
        let result = new OrganisationEntityDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IOrganisationEntityDetailDTO extends IArchivableCodeKeywordDetailDTO {
}

export class QueryResultOfOrganisationEntityDetailDTO implements IQueryResultOfOrganisationEntityDetailDTO {
    metaData!: QueryResultMetaDataOfOrganisationEntityDetailDTO;
    data!: OrganisationEntityDetailDTO[];

    constructor(data?: IQueryResultOfOrganisationEntityDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfOrganisationEntityDetailDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OrganisationEntityDetailDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfOrganisationEntityDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfOrganisationEntityDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfOrganisationEntityDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultOfOrganisationEntityDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfOrganisationEntityDetailDTO {
    metaData: QueryResultMetaDataOfOrganisationEntityDetailDTO;
    data: OrganisationEntityDetailDTO[];
}

export class QueryResultMetaDataOfOrganisationEntityDetailDTO implements IQueryResultMetaDataOfOrganisationEntityDetailDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfOrganisationEntityDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfOrganisationEntityDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfOrganisationEntityDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfOrganisationEntityDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfOrganisationEntityDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfOrganisationEntityDetailDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export abstract class OrganisationEntityUpdateBaseDTO extends CodeKeywordUpdateBaseDTO implements IOrganisationEntityUpdateBaseDTO {

    constructor(data?: IOrganisationEntityUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationEntityUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrganisationEntityUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganisationEntityUpdateBaseDTO {
        throw new Error("The abstract class 'OrganisationEntityUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IOrganisationEntityUpdateBaseDTO extends ICodeKeywordUpdateBaseDTO {
}

export class OrganisationEntityCreateDTO extends OrganisationEntityUpdateBaseDTO implements IOrganisationEntityCreateDTO {

    constructor(data?: IOrganisationEntityCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationEntityCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationEntityCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganisationEntityCreateDTO {
        const json = this.toJSON();
        let result = new OrganisationEntityCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IOrganisationEntityCreateDTO extends IOrganisationEntityUpdateBaseDTO {
}

export class OrganisationEntityUpdateDTO extends OrganisationEntityUpdateBaseDTO implements IOrganisationEntityUpdateDTO {

    constructor(data?: IOrganisationEntityUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): OrganisationEntityUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationEntityUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganisationEntityUpdateDTO {
        const json = this.toJSON();
        let result = new OrganisationEntityUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IOrganisationEntityUpdateDTO extends IOrganisationEntityUpdateBaseDTO {
}

export class QuestionDetailDTO extends ArchivableEntityDetailDTO implements IQuestionDetailDTO {
    name!: string;
    isGlobal!: boolean;
    isMandatory!: boolean;
    isDefaultChecked!: boolean;
    countries!: CountryInfoDTO[];

    constructor(data?: IQuestionDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.isMandatory = _data["isMandatory"] !== undefined ? _data["isMandatory"] : <any>null;
            this.isDefaultChecked = _data["isDefaultChecked"] !== undefined ? _data["isDefaultChecked"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
        }
    }

    static fromJS(data: any): QuestionDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["isMandatory"] = this.isMandatory !== undefined ? this.isMandatory : <any>null;
        data["isDefaultChecked"] = this.isDefaultChecked !== undefined ? this.isDefaultChecked : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): QuestionDetailDTO {
        const json = this.toJSON();
        let result = new QuestionDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQuestionDetailDTO extends IArchivableEntityDetailDTO {
    name: string;
    isGlobal: boolean;
    isMandatory: boolean;
    isDefaultChecked: boolean;
    countries: CountryInfoDTO[];
}

export abstract class QuestionUpdateBaseDTO implements IQuestionUpdateBaseDTO {
    name!: string;
    isMandatory!: boolean;
    isDefaultChecked!: boolean;

    constructor(data?: IQuestionUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isMandatory = _data["isMandatory"] !== undefined ? _data["isMandatory"] : <any>null;
            this.isDefaultChecked = _data["isDefaultChecked"] !== undefined ? _data["isDefaultChecked"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QuestionUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isMandatory"] = this.isMandatory !== undefined ? this.isMandatory : <any>null;
        data["isDefaultChecked"] = this.isDefaultChecked !== undefined ? this.isDefaultChecked : <any>null;
        return data;
    }

    clone(): QuestionUpdateBaseDTO {
        throw new Error("The abstract class 'QuestionUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface IQuestionUpdateBaseDTO {
    name: string;
    isMandatory: boolean;
    isDefaultChecked: boolean;
}

export class QuestionCreateDTO extends QuestionUpdateBaseDTO implements IQuestionCreateDTO {

    constructor(data?: IQuestionCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): QuestionCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): QuestionCreateDTO {
        const json = this.toJSON();
        let result = new QuestionCreateDTO();
        result.init(json);
        return result;
    }
}

export interface IQuestionCreateDTO extends IQuestionUpdateBaseDTO {
}

export class QuestionUpdateDTO extends QuestionUpdateBaseDTO implements IQuestionUpdateDTO {

    constructor(data?: IQuestionUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): QuestionUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): QuestionUpdateDTO {
        const json = this.toJSON();
        let result = new QuestionUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface IQuestionUpdateDTO extends IQuestionUpdateBaseDTO {
}

export class QuestionCountryModel implements IQuestionCountryModel {
    countryId!: number;

    constructor(data?: IQuestionCountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): QuestionCountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionCountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        return data;
    }

    clone(): QuestionCountryModel {
        const json = this.toJSON();
        let result = new QuestionCountryModel();
        result.init(json);
        return result;
    }
}

export interface IQuestionCountryModel {
    countryId: number;
}

export class SiteInfoDTO extends EntityDTO implements ISiteInfoDTO {
    name!: string;
    address!: string | null;
    assetType!: string | null;
    operation!: string | null;
    countryId!: number;
    latitude!: number | null;
    longitude!: number | null;
    siteType!: SiteTypeInfoDTO;

    constructor(data?: ISiteInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.assetType = _data["assetType"] !== undefined ? _data["assetType"] : <any>null;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.siteType = _data["siteType"] ? SiteTypeInfoDTO.fromJS(_data["siteType"]) : <any>null;
        }
    }

    static fromJS(data: any): SiteInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SiteInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["assetType"] = this.assetType !== undefined ? this.assetType : <any>null;
        data["operation"] = this.operation !== undefined ? this.operation : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["siteType"] = this.siteType ? this.siteType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SiteInfoDTO {
        const json = this.toJSON();
        let result = new SiteInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISiteInfoDTO extends IEntityDTO {
    name: string;
    address: string | null;
    assetType: string | null;
    operation: string | null;
    countryId: number;
    latitude: number | null;
    longitude: number | null;
    siteType: SiteTypeInfoDTO;
}

export class SiteTypeInfoDTO extends ArchivableIconKeywordInfoDTO implements ISiteTypeInfoDTO {
    typeKeywords!: string;
    isDefault!: boolean;
    typeKeywordsList!: string[];

    constructor(data?: ISiteTypeInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.typeKeywords = _data["typeKeywords"] !== undefined ? _data["typeKeywords"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            if (Array.isArray(_data["typeKeywordsList"])) {
                this.typeKeywordsList = [] as any;
                for (let item of _data["typeKeywordsList"])
                    this.typeKeywordsList!.push(item);
            }
            else {
                this.typeKeywordsList = <any>null;
            }
        }
    }

    static fromJS(data: any): SiteTypeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SiteTypeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeKeywords"] = this.typeKeywords !== undefined ? this.typeKeywords : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        if (Array.isArray(this.typeKeywordsList)) {
            data["typeKeywordsList"] = [];
            for (let item of this.typeKeywordsList)
                data["typeKeywordsList"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): SiteTypeInfoDTO {
        const json = this.toJSON();
        let result = new SiteTypeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ISiteTypeInfoDTO extends IArchivableIconKeywordInfoDTO {
    typeKeywords: string;
    isDefault: boolean;
    typeKeywordsList: string[];
}

export class EnumsModelDTO implements IEnumsModelDTO {
    airlineRatings!: EnumModel[];
    airlineStatuses!: EnumModel[];
    approvalRequirements!: EnumModel[];
    approvalStatuses!: EnumModel[];
    approveTypes!: EnumModel[];
    classesOfTravel!: EnumModel[];
    deviationTypes!: EnumModel[];
    deviationWorkflowTypes!: EnumModel[];
    deviationDetailTypes!: EnumModel[];
    deviationRequestStatuses!: EnumModel[];
    flightTimes!: EnumModel[];
    locationCurrentnessStatuses!: EnumModel[];
    systemRoles!: EnumModel[];
    transportationSystemTypes!: EnumModel[];
    dateRanges!: EnumModel[];

    constructor(data?: IEnumsModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["airlineRatings"])) {
                this.airlineRatings = [] as any;
                for (let item of _data["airlineRatings"])
                    this.airlineRatings!.push(EnumModel.fromJS(item));
            }
            else {
                this.airlineRatings = <any>null;
            }
            if (Array.isArray(_data["airlineStatuses"])) {
                this.airlineStatuses = [] as any;
                for (let item of _data["airlineStatuses"])
                    this.airlineStatuses!.push(EnumModel.fromJS(item));
            }
            else {
                this.airlineStatuses = <any>null;
            }
            if (Array.isArray(_data["approvalRequirements"])) {
                this.approvalRequirements = [] as any;
                for (let item of _data["approvalRequirements"])
                    this.approvalRequirements!.push(EnumModel.fromJS(item));
            }
            else {
                this.approvalRequirements = <any>null;
            }
            if (Array.isArray(_data["approvalStatuses"])) {
                this.approvalStatuses = [] as any;
                for (let item of _data["approvalStatuses"])
                    this.approvalStatuses!.push(EnumModel.fromJS(item));
            }
            else {
                this.approvalStatuses = <any>null;
            }
            if (Array.isArray(_data["approveTypes"])) {
                this.approveTypes = [] as any;
                for (let item of _data["approveTypes"])
                    this.approveTypes!.push(EnumModel.fromJS(item));
            }
            else {
                this.approveTypes = <any>null;
            }
            if (Array.isArray(_data["classesOfTravel"])) {
                this.classesOfTravel = [] as any;
                for (let item of _data["classesOfTravel"])
                    this.classesOfTravel!.push(EnumModel.fromJS(item));
            }
            else {
                this.classesOfTravel = <any>null;
            }
            if (Array.isArray(_data["deviationTypes"])) {
                this.deviationTypes = [] as any;
                for (let item of _data["deviationTypes"])
                    this.deviationTypes!.push(EnumModel.fromJS(item));
            }
            else {
                this.deviationTypes = <any>null;
            }
            if (Array.isArray(_data["deviationWorkflowTypes"])) {
                this.deviationWorkflowTypes = [] as any;
                for (let item of _data["deviationWorkflowTypes"])
                    this.deviationWorkflowTypes!.push(EnumModel.fromJS(item));
            }
            else {
                this.deviationWorkflowTypes = <any>null;
            }
            if (Array.isArray(_data["deviationDetailTypes"])) {
                this.deviationDetailTypes = [] as any;
                for (let item of _data["deviationDetailTypes"])
                    this.deviationDetailTypes!.push(EnumModel.fromJS(item));
            }
            else {
                this.deviationDetailTypes = <any>null;
            }
            if (Array.isArray(_data["deviationRequestStatuses"])) {
                this.deviationRequestStatuses = [] as any;
                for (let item of _data["deviationRequestStatuses"])
                    this.deviationRequestStatuses!.push(EnumModel.fromJS(item));
            }
            else {
                this.deviationRequestStatuses = <any>null;
            }
            if (Array.isArray(_data["flightTimes"])) {
                this.flightTimes = [] as any;
                for (let item of _data["flightTimes"])
                    this.flightTimes!.push(EnumModel.fromJS(item));
            }
            else {
                this.flightTimes = <any>null;
            }
            if (Array.isArray(_data["locationCurrentnessStatuses"])) {
                this.locationCurrentnessStatuses = [] as any;
                for (let item of _data["locationCurrentnessStatuses"])
                    this.locationCurrentnessStatuses!.push(EnumModel.fromJS(item));
            }
            else {
                this.locationCurrentnessStatuses = <any>null;
            }
            if (Array.isArray(_data["systemRoles"])) {
                this.systemRoles = [] as any;
                for (let item of _data["systemRoles"])
                    this.systemRoles!.push(EnumModel.fromJS(item));
            }
            else {
                this.systemRoles = <any>null;
            }
            if (Array.isArray(_data["transportationSystemTypes"])) {
                this.transportationSystemTypes = [] as any;
                for (let item of _data["transportationSystemTypes"])
                    this.transportationSystemTypes!.push(EnumModel.fromJS(item));
            }
            else {
                this.transportationSystemTypes = <any>null;
            }
            if (Array.isArray(_data["dateRanges"])) {
                this.dateRanges = [] as any;
                for (let item of _data["dateRanges"])
                    this.dateRanges!.push(EnumModel.fromJS(item));
            }
            else {
                this.dateRanges = <any>null;
            }
        }
    }

    static fromJS(data: any): EnumsModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EnumsModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.airlineRatings)) {
            data["airlineRatings"] = [];
            for (let item of this.airlineRatings)
                data["airlineRatings"].push(item.toJSON());
        }
        if (Array.isArray(this.airlineStatuses)) {
            data["airlineStatuses"] = [];
            for (let item of this.airlineStatuses)
                data["airlineStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.approvalRequirements)) {
            data["approvalRequirements"] = [];
            for (let item of this.approvalRequirements)
                data["approvalRequirements"].push(item.toJSON());
        }
        if (Array.isArray(this.approvalStatuses)) {
            data["approvalStatuses"] = [];
            for (let item of this.approvalStatuses)
                data["approvalStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.approveTypes)) {
            data["approveTypes"] = [];
            for (let item of this.approveTypes)
                data["approveTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.classesOfTravel)) {
            data["classesOfTravel"] = [];
            for (let item of this.classesOfTravel)
                data["classesOfTravel"].push(item.toJSON());
        }
        if (Array.isArray(this.deviationTypes)) {
            data["deviationTypes"] = [];
            for (let item of this.deviationTypes)
                data["deviationTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.deviationWorkflowTypes)) {
            data["deviationWorkflowTypes"] = [];
            for (let item of this.deviationWorkflowTypes)
                data["deviationWorkflowTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.deviationDetailTypes)) {
            data["deviationDetailTypes"] = [];
            for (let item of this.deviationDetailTypes)
                data["deviationDetailTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.deviationRequestStatuses)) {
            data["deviationRequestStatuses"] = [];
            for (let item of this.deviationRequestStatuses)
                data["deviationRequestStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.flightTimes)) {
            data["flightTimes"] = [];
            for (let item of this.flightTimes)
                data["flightTimes"].push(item.toJSON());
        }
        if (Array.isArray(this.locationCurrentnessStatuses)) {
            data["locationCurrentnessStatuses"] = [];
            for (let item of this.locationCurrentnessStatuses)
                data["locationCurrentnessStatuses"].push(item.toJSON());
        }
        if (Array.isArray(this.systemRoles)) {
            data["systemRoles"] = [];
            for (let item of this.systemRoles)
                data["systemRoles"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationSystemTypes)) {
            data["transportationSystemTypes"] = [];
            for (let item of this.transportationSystemTypes)
                data["transportationSystemTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.dateRanges)) {
            data["dateRanges"] = [];
            for (let item of this.dateRanges)
                data["dateRanges"].push(item.toJSON());
        }
        return data;
    }

    clone(): EnumsModelDTO {
        const json = this.toJSON();
        let result = new EnumsModelDTO();
        result.init(json);
        return result;
    }
}

export interface IEnumsModelDTO {
    airlineRatings: EnumModel[];
    airlineStatuses: EnumModel[];
    approvalRequirements: EnumModel[];
    approvalStatuses: EnumModel[];
    approveTypes: EnumModel[];
    classesOfTravel: EnumModel[];
    deviationTypes: EnumModel[];
    deviationWorkflowTypes: EnumModel[];
    deviationDetailTypes: EnumModel[];
    deviationRequestStatuses: EnumModel[];
    flightTimes: EnumModel[];
    locationCurrentnessStatuses: EnumModel[];
    systemRoles: EnumModel[];
    transportationSystemTypes: EnumModel[];
    dateRanges: EnumModel[];
}

export class FeaturesModelDTO implements IFeaturesModelDTO {
    apiVersion!: string | null;
    contactPhoneNumber!: string | null;
    contactEmail!: string | null;
    contactWebUrl!: string | null;

    constructor(data?: IFeaturesModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiVersion = _data["apiVersion"] !== undefined ? _data["apiVersion"] : <any>null;
            this.contactPhoneNumber = _data["contactPhoneNumber"] !== undefined ? _data["contactPhoneNumber"] : <any>null;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            this.contactWebUrl = _data["contactWebUrl"] !== undefined ? _data["contactWebUrl"] : <any>null;
        }
    }

    static fromJS(data: any): FeaturesModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeaturesModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiVersion"] = this.apiVersion !== undefined ? this.apiVersion : <any>null;
        data["contactPhoneNumber"] = this.contactPhoneNumber !== undefined ? this.contactPhoneNumber : <any>null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        data["contactWebUrl"] = this.contactWebUrl !== undefined ? this.contactWebUrl : <any>null;
        return data;
    }

    clone(): FeaturesModelDTO {
        const json = this.toJSON();
        let result = new FeaturesModelDTO();
        result.init(json);
        return result;
    }
}

export interface IFeaturesModelDTO {
    apiVersion: string | null;
    contactPhoneNumber: string | null;
    contactEmail: string | null;
    contactWebUrl: string | null;
}

export class SystemUserDetailDTO extends ArchivableEntityDetailDTO implements ISystemUserDetailDTO {
    uniqueId!: string;
    loginName!: string | null;
    firstName!: string | null;
    lastName!: string | null;
    email!: string | null;
    jobTitle!: string | null;
    mobilePhone!: string | null;
    countriesContactEmail!: string | null;
    fullName!: string;
    initials!: string;
    systemRoles!: FlagsEnumModel;

    constructor(data?: ISystemUserDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : <any>null;
            this.loginName = _data["loginName"] !== undefined ? _data["loginName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : <any>null;
            this.countriesContactEmail = _data["countriesContactEmail"] !== undefined ? _data["countriesContactEmail"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.initials = _data["initials"] !== undefined ? _data["initials"] : <any>null;
            this.systemRoles = _data["systemRoles"] ? FlagsEnumModel.fromJS(_data["systemRoles"]) : <any>null;
        }
    }

    static fromJS(data: any): SystemUserDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : <any>null;
        data["loginName"] = this.loginName !== undefined ? this.loginName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : <any>null;
        data["countriesContactEmail"] = this.countriesContactEmail !== undefined ? this.countriesContactEmail : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["initials"] = this.initials !== undefined ? this.initials : <any>null;
        data["systemRoles"] = this.systemRoles ? this.systemRoles.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): SystemUserDetailDTO {
        const json = this.toJSON();
        let result = new SystemUserDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ISystemUserDetailDTO extends IArchivableEntityDetailDTO {
    uniqueId: string;
    loginName: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    jobTitle: string | null;
    mobilePhone: string | null;
    countriesContactEmail: string | null;
    fullName: string;
    initials: string;
    systemRoles: FlagsEnumModel;
}

export class FlagsEnumModel extends EnumModel implements IFlagsEnumModel {
    flags!: EnumModel[];

    constructor(data?: IFlagsEnumModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(EnumModel.fromJS(item));
            }
            else {
                this.flags = <any>null;
            }
        }
    }

    static fromJS(data: any): FlagsEnumModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlagsEnumModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): FlagsEnumModel {
        const json = this.toJSON();
        let result = new FlagsEnumModel();
        result.init(json);
        return result;
    }
}

export interface IFlagsEnumModel extends IEnumModel {
    flags: EnumModel[];
}

export class ADUserSearchResult implements IADUserSearchResult {
    uniqueId!: string;
    loginName!: string | null;
    firstName!: string | null;
    lastName!: string | null;
    email!: string | null;
    jobTitle!: string | null;
    mobilePhone!: string | null;
    countriesContactEmail!: string | null;
    fullName!: string;

    constructor(data?: IADUserSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"] !== undefined ? _data["uniqueId"] : <any>null;
            this.loginName = _data["loginName"] !== undefined ? _data["loginName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : <any>null;
            this.countriesContactEmail = _data["countriesContactEmail"] !== undefined ? _data["countriesContactEmail"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): ADUserSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new ADUserSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId !== undefined ? this.uniqueId : <any>null;
        data["loginName"] = this.loginName !== undefined ? this.loginName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["mobilePhone"] = this.mobilePhone !== undefined ? this.mobilePhone : <any>null;
        data["countriesContactEmail"] = this.countriesContactEmail !== undefined ? this.countriesContactEmail : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }

    clone(): ADUserSearchResult {
        const json = this.toJSON();
        let result = new ADUserSearchResult();
        result.init(json);
        return result;
    }
}

export interface IADUserSearchResult {
    uniqueId: string;
    loginName: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    jobTitle: string | null;
    mobilePhone: string | null;
    countriesContactEmail: string | null;
    fullName: string;
}

export class SystemUserCountryRoleInfoModel implements ISystemUserCountryRoleInfoModel {
    user!: SystemUserDetailDTO;
    approverDelegates!: SystemUserContactInfoDTO[];
    countriesApprove!: CountryInfoDTO[];
    countriesContact!: CountryInfoDTO[];
    delegateApprovers!: SystemUserContactInfoDTO[];

    constructor(data?: ISystemUserCountryRoleInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? SystemUserDetailDTO.fromJS(_data["user"]) : <any>null;
            if (Array.isArray(_data["approverDelegates"])) {
                this.approverDelegates = [] as any;
                for (let item of _data["approverDelegates"])
                    this.approverDelegates!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.approverDelegates = <any>null;
            }
            if (Array.isArray(_data["countriesApprove"])) {
                this.countriesApprove = [] as any;
                for (let item of _data["countriesApprove"])
                    this.countriesApprove!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                this.countriesApprove = <any>null;
            }
            if (Array.isArray(_data["countriesContact"])) {
                this.countriesContact = [] as any;
                for (let item of _data["countriesContact"])
                    this.countriesContact!.push(CountryInfoDTO.fromJS(item));
            }
            else {
                this.countriesContact = <any>null;
            }
            if (Array.isArray(_data["delegateApprovers"])) {
                this.delegateApprovers = [] as any;
                for (let item of _data["delegateApprovers"])
                    this.delegateApprovers!.push(SystemUserContactInfoDTO.fromJS(item));
            }
            else {
                this.delegateApprovers = <any>null;
            }
        }
    }

    static fromJS(data: any): SystemUserCountryRoleInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserCountryRoleInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        if (Array.isArray(this.approverDelegates)) {
            data["approverDelegates"] = [];
            for (let item of this.approverDelegates)
                data["approverDelegates"].push(item.toJSON());
        }
        if (Array.isArray(this.countriesApprove)) {
            data["countriesApprove"] = [];
            for (let item of this.countriesApprove)
                data["countriesApprove"].push(item.toJSON());
        }
        if (Array.isArray(this.countriesContact)) {
            data["countriesContact"] = [];
            for (let item of this.countriesContact)
                data["countriesContact"].push(item.toJSON());
        }
        if (Array.isArray(this.delegateApprovers)) {
            data["delegateApprovers"] = [];
            for (let item of this.delegateApprovers)
                data["delegateApprovers"].push(item.toJSON());
        }
        return data;
    }

    clone(): SystemUserCountryRoleInfoModel {
        const json = this.toJSON();
        let result = new SystemUserCountryRoleInfoModel();
        result.init(json);
        return result;
    }
}

export interface ISystemUserCountryRoleInfoModel {
    user: SystemUserDetailDTO;
    approverDelegates: SystemUserContactInfoDTO[];
    countriesApprove: CountryInfoDTO[];
    countriesContact: CountryInfoDTO[];
    delegateApprovers: SystemUserContactInfoDTO[];
}

export class QueryResultOfSystemUserDetailDTO implements IQueryResultOfSystemUserDetailDTO {
    metaData!: QueryResultMetaDataOfSystemUserDetailDTO;
    data!: SystemUserDetailDTO[];

    constructor(data?: IQueryResultOfSystemUserDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfSystemUserDetailDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SystemUserDetailDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfSystemUserDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfSystemUserDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfSystemUserDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultOfSystemUserDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfSystemUserDetailDTO {
    metaData: QueryResultMetaDataOfSystemUserDetailDTO;
    data: SystemUserDetailDTO[];
}

export class QueryResultMetaDataOfSystemUserDetailDTO implements IQueryResultMetaDataOfSystemUserDetailDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfSystemUserDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfSystemUserDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfSystemUserDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfSystemUserDetailDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfSystemUserDetailDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfSystemUserDetailDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export enum SystemRole {
    User = 0,
    Administrator = 1,
    CountryApprover = 2,
    ApproverDelegate = 4,
    DeviationsTeamMember = 8,
    SystemTask = 16,
    CountryContact = 32,
}

export class TransferCountryUserModel implements ITransferCountryUserModel {
    countriesApproveIds!: number[];
    countriesContactIds!: number[];
    delegateApproversIds!: number[];
    transferToUniqueId!: string;

    constructor(data?: ITransferCountryUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countriesApproveIds"])) {
                this.countriesApproveIds = [] as any;
                for (let item of _data["countriesApproveIds"])
                    this.countriesApproveIds!.push(item);
            }
            else {
                this.countriesApproveIds = <any>null;
            }
            if (Array.isArray(_data["countriesContactIds"])) {
                this.countriesContactIds = [] as any;
                for (let item of _data["countriesContactIds"])
                    this.countriesContactIds!.push(item);
            }
            else {
                this.countriesContactIds = <any>null;
            }
            if (Array.isArray(_data["delegateApproversIds"])) {
                this.delegateApproversIds = [] as any;
                for (let item of _data["delegateApproversIds"])
                    this.delegateApproversIds!.push(item);
            }
            else {
                this.delegateApproversIds = <any>null;
            }
            this.transferToUniqueId = _data["transferToUniqueId"] !== undefined ? _data["transferToUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): TransferCountryUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferCountryUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countriesApproveIds)) {
            data["countriesApproveIds"] = [];
            for (let item of this.countriesApproveIds)
                data["countriesApproveIds"].push(item);
        }
        if (Array.isArray(this.countriesContactIds)) {
            data["countriesContactIds"] = [];
            for (let item of this.countriesContactIds)
                data["countriesContactIds"].push(item);
        }
        if (Array.isArray(this.delegateApproversIds)) {
            data["delegateApproversIds"] = [];
            for (let item of this.delegateApproversIds)
                data["delegateApproversIds"].push(item);
        }
        data["transferToUniqueId"] = this.transferToUniqueId !== undefined ? this.transferToUniqueId : <any>null;
        return data;
    }

    clone(): TransferCountryUserModel {
        const json = this.toJSON();
        let result = new TransferCountryUserModel();
        result.init(json);
        return result;
    }
}

export interface ITransferCountryUserModel {
    countriesApproveIds: number[];
    countriesContactIds: number[];
    delegateApproversIds: number[];
    transferToUniqueId: string;
}

export class SystemUserUpdateDTO implements ISystemUserUpdateDTO {
    countriesContactEmail!: string | null;

    constructor(data?: ISystemUserUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countriesContactEmail = _data["countriesContactEmail"] !== undefined ? _data["countriesContactEmail"] : <any>null;
        }
    }

    static fromJS(data: any): SystemUserUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countriesContactEmail"] = this.countriesContactEmail !== undefined ? this.countriesContactEmail : <any>null;
        return data;
    }

    clone(): SystemUserUpdateDTO {
        const json = this.toJSON();
        let result = new SystemUserUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ISystemUserUpdateDTO {
    countriesContactEmail: string | null;
}

export class AddApproverDelegateModel implements IAddApproverDelegateModel {
    delegateUniqueId!: string;

    constructor(data?: IAddApproverDelegateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegateUniqueId = _data["delegateUniqueId"] !== undefined ? _data["delegateUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): AddApproverDelegateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddApproverDelegateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegateUniqueId"] = this.delegateUniqueId !== undefined ? this.delegateUniqueId : <any>null;
        return data;
    }

    clone(): AddApproverDelegateModel {
        const json = this.toJSON();
        let result = new AddApproverDelegateModel();
        result.init(json);
        return result;
    }
}

export interface IAddApproverDelegateModel {
    delegateUniqueId: string;
}

export class RemoveApproverDelegateModel implements IRemoveApproverDelegateModel {
    delegateId!: number;

    constructor(data?: IRemoveApproverDelegateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegateId = _data["delegateId"] !== undefined ? _data["delegateId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveApproverDelegateModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveApproverDelegateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegateId"] = this.delegateId !== undefined ? this.delegateId : <any>null;
        return data;
    }

    clone(): RemoveApproverDelegateModel {
        const json = this.toJSON();
        let result = new RemoveApproverDelegateModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveApproverDelegateModel {
    delegateId: number;
}

export class AddDelegateApproverModel implements IAddDelegateApproverModel {
    approverUniqueId!: string;

    constructor(data?: IAddDelegateApproverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverUniqueId = _data["approverUniqueId"] !== undefined ? _data["approverUniqueId"] : <any>null;
        }
    }

    static fromJS(data: any): AddDelegateApproverModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddDelegateApproverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverUniqueId"] = this.approverUniqueId !== undefined ? this.approverUniqueId : <any>null;
        return data;
    }

    clone(): AddDelegateApproverModel {
        const json = this.toJSON();
        let result = new AddDelegateApproverModel();
        result.init(json);
        return result;
    }
}

export interface IAddDelegateApproverModel {
    approverUniqueId: string;
}

export class RemoveDelegateApproverModel implements IRemoveDelegateApproverModel {
    approverId!: number;

    constructor(data?: IRemoveDelegateApproverModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverId = _data["approverId"] !== undefined ? _data["approverId"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveDelegateApproverModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveDelegateApproverModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverId"] = this.approverId !== undefined ? this.approverId : <any>null;
        return data;
    }

    clone(): RemoveDelegateApproverModel {
        const json = this.toJSON();
        let result = new RemoveDelegateApproverModel();
        result.init(json);
        return result;
    }
}

export interface IRemoveDelegateApproverModel {
    approverId: number;
}

export class TransportationTypeDetailDTO extends ArchivableIconKeywordDetailDTO implements ITransportationTypeDetailDTO {
    transportationSystemType!: EnumModel;

    constructor(data?: ITransportationTypeDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportationSystemType = _data["transportationSystemType"] ? EnumModel.fromJS(_data["transportationSystemType"]) : <any>null;
        }
    }

    static fromJS(data: any): TransportationTypeDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationTypeDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportationSystemType"] = this.transportationSystemType ? this.transportationSystemType.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TransportationTypeDetailDTO {
        const json = this.toJSON();
        let result = new TransportationTypeDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITransportationTypeDetailDTO extends IArchivableIconKeywordDetailDTO {
    transportationSystemType: EnumModel;
}

export class TransportationTypeUpdateBaseDTO extends IconKeywordUpdateBaseDTO implements ITransportationTypeUpdateBaseDTO {
    transportationSystemType!: TransportationSystemType;

    constructor(data?: ITransportationTypeUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transportationSystemType = _data["transportationSystemType"] !== undefined ? _data["transportationSystemType"] : <any>null;
        }
    }

    static fromJS(data: any): TransportationTypeUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationTypeUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transportationSystemType"] = this.transportationSystemType !== undefined ? this.transportationSystemType : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TransportationTypeUpdateBaseDTO {
        const json = this.toJSON();
        let result = new TransportationTypeUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface ITransportationTypeUpdateBaseDTO extends IIconKeywordUpdateBaseDTO {
    transportationSystemType: TransportationSystemType;
}

export class TransportationTypeCreateDTO extends TransportationTypeUpdateBaseDTO implements ITransportationTypeCreateDTO {

    constructor(data?: ITransportationTypeCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TransportationTypeCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationTypeCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TransportationTypeCreateDTO {
        const json = this.toJSON();
        let result = new TransportationTypeCreateDTO();
        result.init(json);
        return result;
    }
}

export interface ITransportationTypeCreateDTO extends ITransportationTypeUpdateBaseDTO {
}

export class TransportationTypeUpdateDTO extends TransportationTypeUpdateBaseDTO implements ITransportationTypeUpdateDTO {

    constructor(data?: ITransportationTypeUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TransportationTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TransportationTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TransportationTypeUpdateDTO {
        const json = this.toJSON();
        let result = new TransportationTypeUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITransportationTypeUpdateDTO extends ITransportationTypeUpdateBaseDTO {
}

export class TravelRequestDetailModel implements ITravelRequestDetailModel {
    travelRequest!: TravelRequestDetailDTO;
    permissions!: TravelRequestPermissionsModel;

    constructor(data?: ITravelRequestDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelRequest = _data["travelRequest"] ? TravelRequestDetailDTO.fromJS(_data["travelRequest"]) : <any>null;
            this.permissions = _data["permissions"] ? TravelRequestPermissionsModel.fromJS(_data["permissions"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelRequest"] = this.travelRequest ? this.travelRequest.toJSON() : <any>null;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>null;
        return data;
    }

    clone(): TravelRequestDetailModel {
        const json = this.toJSON();
        let result = new TravelRequestDetailModel();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestDetailModel {
    travelRequest: TravelRequestDetailDTO;
    permissions: TravelRequestPermissionsModel;
}

export class TravelRequestDetailDTO extends ArchivableEntityDetailDTO implements ITravelRequestDetailDTO {
    name!: string;
    startDate!: string;
    endDate!: string;
    travelType!: TravelTypeInfoDTO;
    localTravelArrangements!: string;
    reasonForTravel!: string;
    approvalStatus!: ApprovalStatus;
    accommodationSegments!: TravelRequestAccommodationSegmentDetailDTO[];
    citySegments!: TravelRequestCitySegmentDetailDTO[];
    transportationSegments!: TravelRequestTransportationSegmentDetailDTO[];
    noteSegments!: TravelRequestNoteSegmentDetailDTO[];
    travellers!: TravelRequestTravellerDetailDTO[];
    contractors!: TravelRequestContractorDetailDTO[];
    businessContacts!: TravelRequestBusinessContactDetailDTO[];
    countries!: TravelRequestCountryDetailDTO[];
    questions!: TravelRequestQuestionDTO[];
    attachments!: UploadedFileDetailDTO[];
    approvalHistories!: TravelRequestApprovalHistoryDetailDTO[];
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;
    modifiedOn!: string | null;
    modifiedBy!: SystemUserInfoDTO | null;
    approvalStatusChangeOn!: string;
    approvalStatusChangeBy!: SystemUserInfoDTO;

    constructor(data?: ITravelRequestDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.travelType = _data["travelType"] ? TravelTypeInfoDTO.fromJS(_data["travelType"]) : <any>null;
            this.localTravelArrangements = _data["localTravelArrangements"] !== undefined ? _data["localTravelArrangements"] : <any>null;
            this.reasonForTravel = _data["reasonForTravel"] !== undefined ? _data["reasonForTravel"] : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            if (Array.isArray(_data["accommodationSegments"])) {
                this.accommodationSegments = [] as any;
                for (let item of _data["accommodationSegments"])
                    this.accommodationSegments!.push(TravelRequestAccommodationSegmentDetailDTO.fromJS(item));
            }
            else {
                this.accommodationSegments = <any>null;
            }
            if (Array.isArray(_data["citySegments"])) {
                this.citySegments = [] as any;
                for (let item of _data["citySegments"])
                    this.citySegments!.push(TravelRequestCitySegmentDetailDTO.fromJS(item));
            }
            else {
                this.citySegments = <any>null;
            }
            if (Array.isArray(_data["transportationSegments"])) {
                this.transportationSegments = [] as any;
                for (let item of _data["transportationSegments"])
                    this.transportationSegments!.push(TravelRequestTransportationSegmentDetailDTO.fromJS(item));
            }
            else {
                this.transportationSegments = <any>null;
            }
            if (Array.isArray(_data["noteSegments"])) {
                this.noteSegments = [] as any;
                for (let item of _data["noteSegments"])
                    this.noteSegments!.push(TravelRequestNoteSegmentDetailDTO.fromJS(item));
            }
            else {
                this.noteSegments = <any>null;
            }
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(TravelRequestTravellerDetailDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
            if (Array.isArray(_data["contractors"])) {
                this.contractors = [] as any;
                for (let item of _data["contractors"])
                    this.contractors!.push(TravelRequestContractorDetailDTO.fromJS(item));
            }
            else {
                this.contractors = <any>null;
            }
            if (Array.isArray(_data["businessContacts"])) {
                this.businessContacts = [] as any;
                for (let item of _data["businessContacts"])
                    this.businessContacts!.push(TravelRequestBusinessContactDetailDTO.fromJS(item));
            }
            else {
                this.businessContacts = <any>null;
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestCountryDetailDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(TravelRequestQuestionDTO.fromJS(item));
            }
            else {
                this.questions = <any>null;
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(UploadedFileDetailDTO.fromJS(item));
            }
            else {
                this.attachments = <any>null;
            }
            if (Array.isArray(_data["approvalHistories"])) {
                this.approvalHistories = [] as any;
                for (let item of _data["approvalHistories"])
                    this.approvalHistories!.push(TravelRequestApprovalHistoryDetailDTO.fromJS(item));
            }
            else {
                this.approvalHistories = <any>null;
            }
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
            this.modifiedOn = _data["modifiedOn"] !== undefined ? _data["modifiedOn"] : <any>null;
            this.modifiedBy = _data["modifiedBy"] ? SystemUserInfoDTO.fromJS(_data["modifiedBy"]) : <any>null;
            this.approvalStatusChangeOn = _data["approvalStatusChangeOn"] !== undefined ? _data["approvalStatusChangeOn"] : <any>null;
            this.approvalStatusChangeBy = _data["approvalStatusChangeBy"] ? SystemUserInfoDTO.fromJS(_data["approvalStatusChangeBy"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["travelType"] = this.travelType ? this.travelType.toJSON() : <any>null;
        data["localTravelArrangements"] = this.localTravelArrangements !== undefined ? this.localTravelArrangements : <any>null;
        data["reasonForTravel"] = this.reasonForTravel !== undefined ? this.reasonForTravel : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        if (Array.isArray(this.accommodationSegments)) {
            data["accommodationSegments"] = [];
            for (let item of this.accommodationSegments)
                data["accommodationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.citySegments)) {
            data["citySegments"] = [];
            for (let item of this.citySegments)
                data["citySegments"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationSegments)) {
            data["transportationSegments"] = [];
            for (let item of this.transportationSegments)
                data["transportationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.noteSegments)) {
            data["noteSegments"] = [];
            for (let item of this.noteSegments)
                data["noteSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        if (Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        if (Array.isArray(this.businessContacts)) {
            data["businessContacts"] = [];
            for (let item of this.businessContacts)
                data["businessContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        if (Array.isArray(this.approvalHistories)) {
            data["approvalHistories"] = [];
            for (let item of this.approvalHistories)
                data["approvalHistories"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        data["modifiedOn"] = this.modifiedOn !== undefined ? this.modifiedOn : <any>null;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>null;
        data["approvalStatusChangeOn"] = this.approvalStatusChangeOn !== undefined ? this.approvalStatusChangeOn : <any>null;
        data["approvalStatusChangeBy"] = this.approvalStatusChangeBy ? this.approvalStatusChangeBy.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestDetailDTO extends IArchivableEntityDetailDTO {
    name: string;
    startDate: string;
    endDate: string;
    travelType: TravelTypeInfoDTO;
    localTravelArrangements: string;
    reasonForTravel: string;
    approvalStatus: ApprovalStatus;
    accommodationSegments: TravelRequestAccommodationSegmentDetailDTO[];
    citySegments: TravelRequestCitySegmentDetailDTO[];
    transportationSegments: TravelRequestTransportationSegmentDetailDTO[];
    noteSegments: TravelRequestNoteSegmentDetailDTO[];
    travellers: TravelRequestTravellerDetailDTO[];
    contractors: TravelRequestContractorDetailDTO[];
    businessContacts: TravelRequestBusinessContactDetailDTO[];
    countries: TravelRequestCountryDetailDTO[];
    questions: TravelRequestQuestionDTO[];
    attachments: UploadedFileDetailDTO[];
    approvalHistories: TravelRequestApprovalHistoryDetailDTO[];
    createdOn: string;
    createdBy: SystemUserInfoDTO;
    modifiedOn: string | null;
    modifiedBy: SystemUserInfoDTO | null;
    approvalStatusChangeOn: string;
    approvalStatusChangeBy: SystemUserInfoDTO;
}

export abstract class ArchivableOrderKeywordInfoDTO extends ArchivableKeywordInfoDTO implements IArchivableOrderKeywordInfoDTO {
    order!: number;

    constructor(data?: IArchivableOrderKeywordInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.order = _data["order"] !== undefined ? _data["order"] : <any>null;
        }
    }

    static fromJS(data: any): ArchivableOrderKeywordInfoDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ArchivableOrderKeywordInfoDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order !== undefined ? this.order : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): ArchivableOrderKeywordInfoDTO {
        throw new Error("The abstract class 'ArchivableOrderKeywordInfoDTO' cannot be instantiated.");
    }
}

export interface IArchivableOrderKeywordInfoDTO extends IArchivableKeywordInfoDTO {
    order: number;
}

export class TravelTypeInfoDTO extends ArchivableOrderKeywordInfoDTO implements ITravelTypeInfoDTO {

    constructor(data?: ITravelTypeInfoDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelTypeInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTypeInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelTypeInfoDTO {
        const json = this.toJSON();
        let result = new TravelTypeInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelTypeInfoDTO extends IArchivableOrderKeywordInfoDTO {
}

export enum ApprovalStatus {
    Draft = 0,
    Pending = 1,
    Approved = 2,
    Declined = 3,
    RequireMoreInfo = 4,
}

export class TravelRequestSegmentDetailDTO implements ITravelRequestSegmentDetailDTO {
    ordinalNumber!: number;

    constructor(data?: ITravelRequestSegmentDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinalNumber = _data["ordinalNumber"] !== undefined ? _data["ordinalNumber"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinalNumber"] = this.ordinalNumber !== undefined ? this.ordinalNumber : <any>null;
        return data;
    }

    clone(): TravelRequestSegmentDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestSegmentDetailDTO {
    ordinalNumber: number;
}

export class TravelRequestAccommodationSegmentDetailDTO extends TravelRequestSegmentDetailDTO implements ITravelRequestAccommodationSegmentDetailDTO {
    arrivalDate!: string;
    departureDate!: string;
    accommodationType!: AccommodationTypeInfoDTO;
    name!: string | null;
    address!: string | null;
    city!: CityInfoDTO | null;
    cityCustomName!: string | null;
    country!: CountryInfoDTO | null;

    constructor(data?: ITravelRequestAccommodationSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.accommodationType = _data["accommodationType"] ? AccommodationTypeInfoDTO.fromJS(_data["accommodationType"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] ? CityInfoDTO.fromJS(_data["city"]) : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestAccommodationSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestAccommodationSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["accommodationType"] = this.accommodationType ? this.accommodationType.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestAccommodationSegmentDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestAccommodationSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestAccommodationSegmentDetailDTO extends ITravelRequestSegmentDetailDTO {
    arrivalDate: string;
    departureDate: string;
    accommodationType: AccommodationTypeInfoDTO;
    name: string | null;
    address: string | null;
    city: CityInfoDTO | null;
    cityCustomName: string | null;
    country: CountryInfoDTO | null;
}

export class TravelRequestCitySegmentDetailDTO extends TravelRequestSegmentDetailDTO implements ITravelRequestCitySegmentDetailDTO {
    arrivalDate!: string;
    departureDate!: string;
    city!: CityInfoDTO;

    constructor(data?: ITravelRequestCitySegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.city = _data["city"] ? CityInfoDTO.fromJS(_data["city"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCitySegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCitySegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["city"] = this.city ? this.city.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestCitySegmentDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestCitySegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCitySegmentDetailDTO extends ITravelRequestSegmentDetailDTO {
    arrivalDate: string;
    departureDate: string;
    city: CityInfoDTO;
}

export class TravelRequestTransportationSegmentDetailDTO extends TravelRequestSegmentDetailDTO implements ITravelRequestTransportationSegmentDetailDTO {
    tripDate!: string;
    transportationType!: TransportationTypeInfoDTO;
    airline!: AirlineInfoDTO | null;
    airlineCustomName!: string | null;
    flightNumber!: string | null;
    note!: string | null;

    constructor(data?: ITravelRequestTransportationSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripDate = _data["tripDate"] !== undefined ? _data["tripDate"] : <any>null;
            this.transportationType = _data["transportationType"] ? TransportationTypeInfoDTO.fromJS(_data["transportationType"]) : <any>null;
            this.airline = _data["airline"] ? AirlineInfoDTO.fromJS(_data["airline"]) : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestTransportationSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTransportationSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripDate"] = this.tripDate !== undefined ? this.tripDate : <any>null;
        data["transportationType"] = this.transportationType ? this.transportationType.toJSON() : <any>null;
        data["airline"] = this.airline ? this.airline.toJSON() : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestTransportationSegmentDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestTransportationSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTransportationSegmentDetailDTO extends ITravelRequestSegmentDetailDTO {
    tripDate: string;
    transportationType: TransportationTypeInfoDTO;
    airline: AirlineInfoDTO | null;
    airlineCustomName: string | null;
    flightNumber: string | null;
    note: string | null;
}

export class TravelRequestNoteSegmentDetailDTO extends TravelRequestSegmentDetailDTO implements ITravelRequestNoteSegmentDetailDTO {
    note!: string;

    constructor(data?: ITravelRequestNoteSegmentDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestNoteSegmentDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestNoteSegmentDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestNoteSegmentDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestNoteSegmentDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestNoteSegmentDetailDTO extends ITravelRequestSegmentDetailDTO {
    note: string;
}

export class TravelRequestTravellerDetailDTO implements ITravelRequestTravellerDetailDTO {
    user!: SystemUserContactInfoDTO;
    countries!: TravelRequestTravellerContractorCountryDetailDTO[];

    constructor(data?: ITravelRequestTravellerDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? SystemUserContactInfoDTO.fromJS(_data["user"]) : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestTravellerContractorCountryDetailDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestTravellerDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTravellerDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }

    clone(): TravelRequestTravellerDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestTravellerDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTravellerDetailDTO {
    user: SystemUserContactInfoDTO;
    countries: TravelRequestTravellerContractorCountryDetailDTO[];
}

export class TravelRequestTravellerContractorCountryDetailDTO implements ITravelRequestTravellerContractorCountryDetailDTO {
    country!: CountryInfoDTO;
    isRevisit!: boolean;

    constructor(data?: ITravelRequestTravellerContractorCountryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.isRevisit = _data["isRevisit"] !== undefined ? _data["isRevisit"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestTravellerContractorCountryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTravellerContractorCountryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["isRevisit"] = this.isRevisit !== undefined ? this.isRevisit : <any>null;
        return data;
    }

    clone(): TravelRequestTravellerContractorCountryDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestTravellerContractorCountryDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTravellerContractorCountryDetailDTO {
    country: CountryInfoDTO;
    isRevisit: boolean;
}

export class TravelRequestContractorDetailDTO implements ITravelRequestContractorDetailDTO {
    firstName!: string;
    lastName!: string;
    contactNumber!: string;
    email!: string;
    organisationEntity!: OrganisationEntityInfoDTO;
    lineManager!: SystemUserContactInfoDTO;
    countries!: TravelRequestTravellerContractorCountryDetailDTO[];

    constructor(data?: ITravelRequestContractorDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.organisationEntity = _data["organisationEntity"] ? OrganisationEntityInfoDTO.fromJS(_data["organisationEntity"]) : <any>null;
            this.lineManager = _data["lineManager"] ? SystemUserContactInfoDTO.fromJS(_data["lineManager"]) : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestTravellerContractorCountryDetailDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestContractorDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestContractorDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["organisationEntity"] = this.organisationEntity ? this.organisationEntity.toJSON() : <any>null;
        data["lineManager"] = this.lineManager ? this.lineManager.toJSON() : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }

    clone(): TravelRequestContractorDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestContractorDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestContractorDetailDTO {
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    organisationEntity: OrganisationEntityInfoDTO;
    lineManager: SystemUserContactInfoDTO;
    countries: TravelRequestTravellerContractorCountryDetailDTO[];
}

export class TravelRequestBusinessContactDetailDTO implements ITravelRequestBusinessContactDetailDTO {
    name!: string;
    contactNumber!: string;
    email!: string;

    constructor(data?: ITravelRequestBusinessContactDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestBusinessContactDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestBusinessContactDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): TravelRequestBusinessContactDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestBusinessContactDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestBusinessContactDetailDTO {
    name: string;
    contactNumber: string;
    email: string;
}

export class TravelRequestCountryDetailDTO implements ITravelRequestCountryDetailDTO {
    country!: CountryInfoDTO;
    approvalRequirement!: CountryApprovalRequirement;
    approvalLevel!: ApprovalLevelInfoDTO;
    specificCondition!: string | null;
    isTransit!: boolean | null;
    approval!: TravelRequestCountryApprovalDetailDTO | null;

    constructor(data?: ITravelRequestCountryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] !== undefined ? _data["approvalRequirement"] : <any>null;
            this.approvalLevel = _data["approvalLevel"] ? ApprovalLevelInfoDTO.fromJS(_data["approvalLevel"]) : <any>null;
            this.specificCondition = _data["specificCondition"] !== undefined ? _data["specificCondition"] : <any>null;
            this.isTransit = _data["isTransit"] !== undefined ? _data["isTransit"] : <any>null;
            this.approval = _data["approval"] ? TravelRequestCountryApprovalDetailDTO.fromJS(_data["approval"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCountryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["approvalRequirement"] = this.approvalRequirement !== undefined ? this.approvalRequirement : <any>null;
        data["approvalLevel"] = this.approvalLevel ? this.approvalLevel.toJSON() : <any>null;
        data["specificCondition"] = this.specificCondition !== undefined ? this.specificCondition : <any>null;
        data["isTransit"] = this.isTransit !== undefined ? this.isTransit : <any>null;
        data["approval"] = this.approval ? this.approval.toJSON() : <any>null;
        return data;
    }

    clone(): TravelRequestCountryDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryDetailDTO {
    country: CountryInfoDTO;
    approvalRequirement: CountryApprovalRequirement;
    approvalLevel: ApprovalLevelInfoDTO;
    specificCondition: string | null;
    isTransit: boolean | null;
    approval: TravelRequestCountryApprovalDetailDTO | null;
}

export class TravelRequestCountryApprovalDetailDTO implements ITravelRequestCountryApprovalDetailDTO {
    approvalStatus!: ApprovalStatus;
    approveType!: ApproveType;
    approvers!: TravelRequestCountryApproverDetailDTO[];

    constructor(data?: ITravelRequestCountryApprovalDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            this.approveType = _data["approveType"] !== undefined ? _data["approveType"] : <any>null;
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers!.push(TravelRequestCountryApproverDetailDTO.fromJS(item));
            }
            else {
                this.approvers = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestCountryApprovalDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryApprovalDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        data["approveType"] = this.approveType !== undefined ? this.approveType : <any>null;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        return data;
    }

    clone(): TravelRequestCountryApprovalDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryApprovalDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryApprovalDetailDTO {
    approvalStatus: ApprovalStatus;
    approveType: ApproveType;
    approvers: TravelRequestCountryApproverDetailDTO[];
}

export class TravelRequestCountryApproverDetailDTO implements ITravelRequestCountryApproverDetailDTO {
    approver!: SystemUserInfoDTO;
    approvalStatus!: ApprovalStatus;
    comment!: string | null;
    changedOn!: string | null;
    changedBy!: SystemUserInfoDTO | null;

    constructor(data?: ITravelRequestCountryApproverDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approver = _data["approver"] ? SystemUserInfoDTO.fromJS(_data["approver"]) : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.changedOn = _data["changedOn"] !== undefined ? _data["changedOn"] : <any>null;
            this.changedBy = _data["changedBy"] ? SystemUserInfoDTO.fromJS(_data["changedBy"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCountryApproverDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryApproverDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approver"] = this.approver ? this.approver.toJSON() : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["changedOn"] = this.changedOn !== undefined ? this.changedOn : <any>null;
        data["changedBy"] = this.changedBy ? this.changedBy.toJSON() : <any>null;
        return data;
    }

    clone(): TravelRequestCountryApproverDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryApproverDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryApproverDetailDTO {
    approver: SystemUserInfoDTO;
    approvalStatus: ApprovalStatus;
    comment: string | null;
    changedOn: string | null;
    changedBy: SystemUserInfoDTO | null;
}

export class TravelRequestQuestionDTO implements ITravelRequestQuestionDTO {
    name!: string;
    isChecked!: boolean;

    constructor(data?: ITravelRequestQuestionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isChecked = _data["isChecked"] !== undefined ? _data["isChecked"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestQuestionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestQuestionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isChecked"] = this.isChecked !== undefined ? this.isChecked : <any>null;
        return data;
    }

    clone(): TravelRequestQuestionDTO {
        const json = this.toJSON();
        let result = new TravelRequestQuestionDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestQuestionDTO {
    name: string;
    isChecked: boolean;
}

export class TravelRequestApprovalHistoryDetailDTO implements ITravelRequestApprovalHistoryDetailDTO {
    country!: CountryInfoDTO | null;
    approver!: SystemUserInfoDTO | null;
    approvalStatus!: ApprovalStatus | null;
    overallApprovalStatus!: ApprovalStatus;
    comment!: string | null;
    createdOn!: string;
    createdBy!: SystemUserInfoDTO;

    constructor(data?: ITravelRequestApprovalHistoryDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.approver = _data["approver"] ? SystemUserInfoDTO.fromJS(_data["approver"]) : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            this.overallApprovalStatus = _data["overallApprovalStatus"] !== undefined ? _data["overallApprovalStatus"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.createdOn = _data["createdOn"] !== undefined ? _data["createdOn"] : <any>null;
            this.createdBy = _data["createdBy"] ? SystemUserInfoDTO.fromJS(_data["createdBy"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestApprovalHistoryDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestApprovalHistoryDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        data["overallApprovalStatus"] = this.overallApprovalStatus !== undefined ? this.overallApprovalStatus : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["createdOn"] = this.createdOn !== undefined ? this.createdOn : <any>null;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>null;
        return data;
    }

    clone(): TravelRequestApprovalHistoryDetailDTO {
        const json = this.toJSON();
        let result = new TravelRequestApprovalHistoryDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestApprovalHistoryDetailDTO {
    country: CountryInfoDTO | null;
    approver: SystemUserInfoDTO | null;
    approvalStatus: ApprovalStatus | null;
    overallApprovalStatus: ApprovalStatus;
    comment: string | null;
    createdOn: string;
    createdBy: SystemUserInfoDTO;
}

export class TravelRequestPermissionsModel implements ITravelRequestPermissionsModel {
    canEdit!: boolean;
    canChangeApproverApprovalStatus!: boolean;
    countryApprovers!: TravelRequestCountryApproverPermission[];
    canArchive!: boolean;
    canUnarchive!: boolean;

    constructor(data?: ITravelRequestPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEdit = _data["canEdit"] !== undefined ? _data["canEdit"] : <any>null;
            this.canChangeApproverApprovalStatus = _data["canChangeApproverApprovalStatus"] !== undefined ? _data["canChangeApproverApprovalStatus"] : <any>null;
            if (Array.isArray(_data["countryApprovers"])) {
                this.countryApprovers = [] as any;
                for (let item of _data["countryApprovers"])
                    this.countryApprovers!.push(TravelRequestCountryApproverPermission.fromJS(item));
            }
            else {
                this.countryApprovers = <any>null;
            }
            this.canArchive = _data["canArchive"] !== undefined ? _data["canArchive"] : <any>null;
            this.canUnarchive = _data["canUnarchive"] !== undefined ? _data["canUnarchive"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canEdit"] = this.canEdit !== undefined ? this.canEdit : <any>null;
        data["canChangeApproverApprovalStatus"] = this.canChangeApproverApprovalStatus !== undefined ? this.canChangeApproverApprovalStatus : <any>null;
        if (Array.isArray(this.countryApprovers)) {
            data["countryApprovers"] = [];
            for (let item of this.countryApprovers)
                data["countryApprovers"].push(item.toJSON());
        }
        data["canArchive"] = this.canArchive !== undefined ? this.canArchive : <any>null;
        data["canUnarchive"] = this.canUnarchive !== undefined ? this.canUnarchive : <any>null;
        return data;
    }

    clone(): TravelRequestPermissionsModel {
        const json = this.toJSON();
        let result = new TravelRequestPermissionsModel();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestPermissionsModel {
    canEdit: boolean;
    canChangeApproverApprovalStatus: boolean;
    countryApprovers: TravelRequestCountryApproverPermission[];
    canArchive: boolean;
    canUnarchive: boolean;
}

export class TravelRequestCountryApproverPermission implements ITravelRequestCountryApproverPermission {
    countryId!: number;
    approverId!: number;

    constructor(data?: ITravelRequestCountryApproverPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.approverId = _data["approverId"] !== undefined ? _data["approverId"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCountryApproverPermission {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryApproverPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["approverId"] = this.approverId !== undefined ? this.approverId : <any>null;
        return data;
    }

    clone(): TravelRequestCountryApproverPermission {
        const json = this.toJSON();
        let result = new TravelRequestCountryApproverPermission();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryApproverPermission {
    countryId: number;
    approverId: number;
}

export class QueryResultOfTravelRequestListQueryDTO implements IQueryResultOfTravelRequestListQueryDTO {
    metaData!: QueryResultMetaDataOfTravelRequestListQueryDTO;
    data!: TravelRequestListQueryDTO[];

    constructor(data?: IQueryResultOfTravelRequestListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfTravelRequestListQueryDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TravelRequestListQueryDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfTravelRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfTravelRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfTravelRequestListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultOfTravelRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfTravelRequestListQueryDTO {
    metaData: QueryResultMetaDataOfTravelRequestListQueryDTO;
    data: TravelRequestListQueryDTO[];
}

export class QueryResultMetaDataOfTravelRequestListQueryDTO implements IQueryResultMetaDataOfTravelRequestListQueryDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfTravelRequestListQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfTravelRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfTravelRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfTravelRequestListQueryDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfTravelRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfTravelRequestListQueryDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class TravelRequestListQueryDTO extends ArchivableEntityInfoDTO implements ITravelRequestListQueryDTO {
    name!: string;
    approvalStatus!: ApprovalStatus;
    startDate!: string;
    endDate!: string;
    countries!: TravelRequestCountryInfoDTO[];
    travellersAndContractors!: PersonInfoDTO[];
    approvalStatusChangeOn!: string;

    constructor(data?: ITravelRequestListQueryDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestCountryInfoDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["travellersAndContractors"])) {
                this.travellersAndContractors = [] as any;
                for (let item of _data["travellersAndContractors"])
                    this.travellersAndContractors!.push(PersonInfoDTO.fromJS(item));
            }
            else {
                this.travellersAndContractors = <any>null;
            }
            this.approvalStatusChangeOn = _data["approvalStatusChangeOn"] !== undefined ? _data["approvalStatusChangeOn"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestListQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestListQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.travellersAndContractors)) {
            data["travellersAndContractors"] = [];
            for (let item of this.travellersAndContractors)
                data["travellersAndContractors"].push(item.toJSON());
        }
        data["approvalStatusChangeOn"] = this.approvalStatusChangeOn !== undefined ? this.approvalStatusChangeOn : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestListQueryDTO {
        const json = this.toJSON();
        let result = new TravelRequestListQueryDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestListQueryDTO extends IArchivableEntityInfoDTO {
    name: string;
    approvalStatus: ApprovalStatus;
    startDate: string;
    endDate: string;
    countries: TravelRequestCountryInfoDTO[];
    travellersAndContractors: PersonInfoDTO[];
    approvalStatusChangeOn: string;
}

export class TravelRequestCountryInfoDTO implements ITravelRequestCountryInfoDTO {
    country!: CountryInfoDTO;
    approvalStatus!: ApprovalStatus | null;

    constructor(data?: ITravelRequestCountryInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] ? CountryInfoDTO.fromJS(_data["country"]) : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCountryInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        return data;
    }

    clone(): TravelRequestCountryInfoDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryInfoDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryInfoDTO {
    country: CountryInfoDTO;
    approvalStatus: ApprovalStatus | null;
}

export abstract class TravelRequestUpdateBaseDTO implements ITravelRequestUpdateBaseDTO {
    name!: string;
    travelTypeId!: number;
    localTravelArrangements!: string;
    reasonForTravel!: string;
    travellers!: TravelRequestTravellerUpdateDTO[];
    contractors!: TravelRequestContractorUpdateDTO[];
    businessContacts!: TravelRequestBusinessContactUpdateDTO[];
    countries!: TravelRequestCountryUpdateDTO[];
    accommodationSegments!: TravelRequestAccommodationSegmentUpdateDTO[];
    citySegments!: TravelRequestCitySegmentUpdateDTO[];
    transportationSegments!: TravelRequestTransportationSegmentUpdateDTO[];
    noteSegments!: TravelRequestNoteSegmentUpdateDTO[];
    questions!: TravelRequestQuestionDTO[];
    uploadedFilesIds!: number[];

    constructor(data?: ITravelRequestUpdateBaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.travelTypeId = _data["travelTypeId"] !== undefined ? _data["travelTypeId"] : <any>null;
            this.localTravelArrangements = _data["localTravelArrangements"] !== undefined ? _data["localTravelArrangements"] : <any>null;
            this.reasonForTravel = _data["reasonForTravel"] !== undefined ? _data["reasonForTravel"] : <any>null;
            if (Array.isArray(_data["travellers"])) {
                this.travellers = [] as any;
                for (let item of _data["travellers"])
                    this.travellers!.push(TravelRequestTravellerUpdateDTO.fromJS(item));
            }
            else {
                this.travellers = <any>null;
            }
            if (Array.isArray(_data["contractors"])) {
                this.contractors = [] as any;
                for (let item of _data["contractors"])
                    this.contractors!.push(TravelRequestContractorUpdateDTO.fromJS(item));
            }
            else {
                this.contractors = <any>null;
            }
            if (Array.isArray(_data["businessContacts"])) {
                this.businessContacts = [] as any;
                for (let item of _data["businessContacts"])
                    this.businessContacts!.push(TravelRequestBusinessContactUpdateDTO.fromJS(item));
            }
            else {
                this.businessContacts = <any>null;
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestCountryUpdateDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["accommodationSegments"])) {
                this.accommodationSegments = [] as any;
                for (let item of _data["accommodationSegments"])
                    this.accommodationSegments!.push(TravelRequestAccommodationSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.accommodationSegments = <any>null;
            }
            if (Array.isArray(_data["citySegments"])) {
                this.citySegments = [] as any;
                for (let item of _data["citySegments"])
                    this.citySegments!.push(TravelRequestCitySegmentUpdateDTO.fromJS(item));
            }
            else {
                this.citySegments = <any>null;
            }
            if (Array.isArray(_data["transportationSegments"])) {
                this.transportationSegments = [] as any;
                for (let item of _data["transportationSegments"])
                    this.transportationSegments!.push(TravelRequestTransportationSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.transportationSegments = <any>null;
            }
            if (Array.isArray(_data["noteSegments"])) {
                this.noteSegments = [] as any;
                for (let item of _data["noteSegments"])
                    this.noteSegments!.push(TravelRequestNoteSegmentUpdateDTO.fromJS(item));
            }
            else {
                this.noteSegments = <any>null;
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(TravelRequestQuestionDTO.fromJS(item));
            }
            else {
                this.questions = <any>null;
            }
            if (Array.isArray(_data["uploadedFilesIds"])) {
                this.uploadedFilesIds = [] as any;
                for (let item of _data["uploadedFilesIds"])
                    this.uploadedFilesIds!.push(item);
            }
            else {
                this.uploadedFilesIds = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TravelRequestUpdateBaseDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["travelTypeId"] = this.travelTypeId !== undefined ? this.travelTypeId : <any>null;
        data["localTravelArrangements"] = this.localTravelArrangements !== undefined ? this.localTravelArrangements : <any>null;
        data["reasonForTravel"] = this.reasonForTravel !== undefined ? this.reasonForTravel : <any>null;
        if (Array.isArray(this.travellers)) {
            data["travellers"] = [];
            for (let item of this.travellers)
                data["travellers"].push(item.toJSON());
        }
        if (Array.isArray(this.contractors)) {
            data["contractors"] = [];
            for (let item of this.contractors)
                data["contractors"].push(item.toJSON());
        }
        if (Array.isArray(this.businessContacts)) {
            data["businessContacts"] = [];
            for (let item of this.businessContacts)
                data["businessContacts"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.accommodationSegments)) {
            data["accommodationSegments"] = [];
            for (let item of this.accommodationSegments)
                data["accommodationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.citySegments)) {
            data["citySegments"] = [];
            for (let item of this.citySegments)
                data["citySegments"].push(item.toJSON());
        }
        if (Array.isArray(this.transportationSegments)) {
            data["transportationSegments"] = [];
            for (let item of this.transportationSegments)
                data["transportationSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.noteSegments)) {
            data["noteSegments"] = [];
            for (let item of this.noteSegments)
                data["noteSegments"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        if (Array.isArray(this.uploadedFilesIds)) {
            data["uploadedFilesIds"] = [];
            for (let item of this.uploadedFilesIds)
                data["uploadedFilesIds"].push(item);
        }
        return data;
    }

    clone(): TravelRequestUpdateBaseDTO {
        throw new Error("The abstract class 'TravelRequestUpdateBaseDTO' cannot be instantiated.");
    }
}

export interface ITravelRequestUpdateBaseDTO {
    name: string;
    travelTypeId: number;
    localTravelArrangements: string;
    reasonForTravel: string;
    travellers: TravelRequestTravellerUpdateDTO[];
    contractors: TravelRequestContractorUpdateDTO[];
    businessContacts: TravelRequestBusinessContactUpdateDTO[];
    countries: TravelRequestCountryUpdateDTO[];
    accommodationSegments: TravelRequestAccommodationSegmentUpdateDTO[];
    citySegments: TravelRequestCitySegmentUpdateDTO[];
    transportationSegments: TravelRequestTransportationSegmentUpdateDTO[];
    noteSegments: TravelRequestNoteSegmentUpdateDTO[];
    questions: TravelRequestQuestionDTO[];
    uploadedFilesIds: number[];
}

export class TravelRequestCreateDTO extends TravelRequestUpdateBaseDTO implements ITravelRequestCreateDTO {

    constructor(data?: ITravelRequestCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelRequestCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestCreateDTO {
        const json = this.toJSON();
        let result = new TravelRequestCreateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCreateDTO extends ITravelRequestUpdateBaseDTO {
}

export class TravelRequestTravellerUpdateDTO implements ITravelRequestTravellerUpdateDTO {
    userUniqueId!: string;
    countries!: TravelRequestTravellerContractorCountryUpdateDTO[];

    constructor(data?: ITravelRequestTravellerUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userUniqueId = _data["userUniqueId"] !== undefined ? _data["userUniqueId"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestTravellerContractorCountryUpdateDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestTravellerUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTravellerUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userUniqueId"] = this.userUniqueId !== undefined ? this.userUniqueId : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }

    clone(): TravelRequestTravellerUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestTravellerUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTravellerUpdateDTO {
    userUniqueId: string;
    countries: TravelRequestTravellerContractorCountryUpdateDTO[];
}

export class TravelRequestTravellerContractorCountryUpdateDTO implements ITravelRequestTravellerContractorCountryUpdateDTO {
    countryId!: number;
    isRevisit!: boolean;

    constructor(data?: ITravelRequestTravellerContractorCountryUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.isRevisit = _data["isRevisit"] !== undefined ? _data["isRevisit"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestTravellerContractorCountryUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTravellerContractorCountryUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["isRevisit"] = this.isRevisit !== undefined ? this.isRevisit : <any>null;
        return data;
    }

    clone(): TravelRequestTravellerContractorCountryUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestTravellerContractorCountryUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTravellerContractorCountryUpdateDTO {
    countryId: number;
    isRevisit: boolean;
}

export class TravelRequestContractorUpdateDTO implements ITravelRequestContractorUpdateDTO {
    firstName!: string;
    lastName!: string;
    contactNumber!: string;
    email!: string;
    organisationEntityId!: number;
    lineManagerUniqueId!: string;
    countries!: TravelRequestTravellerContractorCountryUpdateDTO[];

    constructor(data?: ITravelRequestContractorUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.organisationEntityId = _data["organisationEntityId"] !== undefined ? _data["organisationEntityId"] : <any>null;
            this.lineManagerUniqueId = _data["lineManagerUniqueId"] !== undefined ? _data["lineManagerUniqueId"] : <any>null;
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(TravelRequestTravellerContractorCountryUpdateDTO.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestContractorUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestContractorUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["organisationEntityId"] = this.organisationEntityId !== undefined ? this.organisationEntityId : <any>null;
        data["lineManagerUniqueId"] = this.lineManagerUniqueId !== undefined ? this.lineManagerUniqueId : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data;
    }

    clone(): TravelRequestContractorUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestContractorUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestContractorUpdateDTO {
    firstName: string;
    lastName: string;
    contactNumber: string;
    email: string;
    organisationEntityId: number;
    lineManagerUniqueId: string;
    countries: TravelRequestTravellerContractorCountryUpdateDTO[];
}

export class TravelRequestBusinessContactUpdateDTO implements ITravelRequestBusinessContactUpdateDTO {
    name!: string;
    contactNumber!: string;
    email!: string;

    constructor(data?: ITravelRequestBusinessContactUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.contactNumber = _data["contactNumber"] !== undefined ? _data["contactNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestBusinessContactUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestBusinessContactUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["contactNumber"] = this.contactNumber !== undefined ? this.contactNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }

    clone(): TravelRequestBusinessContactUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestBusinessContactUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestBusinessContactUpdateDTO {
    name: string;
    contactNumber: string;
    email: string;
}

export class TravelRequestCountryUpdateDTO implements ITravelRequestCountryUpdateDTO {
    countryId!: number;
    approvalRequirement!: CountryApprovalRequirement;
    approvalLevelId!: number;
    isTransit!: boolean | null;
    approval!: TravelRequestCountryApprovalUpdateDTO | null;

    constructor(data?: ITravelRequestCountryUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.approvalRequirement = _data["approvalRequirement"] !== undefined ? _data["approvalRequirement"] : <any>null;
            this.approvalLevelId = _data["approvalLevelId"] !== undefined ? _data["approvalLevelId"] : <any>null;
            this.isTransit = _data["isTransit"] !== undefined ? _data["isTransit"] : <any>null;
            this.approval = _data["approval"] ? TravelRequestCountryApprovalUpdateDTO.fromJS(_data["approval"]) : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCountryUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["approvalRequirement"] = this.approvalRequirement !== undefined ? this.approvalRequirement : <any>null;
        data["approvalLevelId"] = this.approvalLevelId !== undefined ? this.approvalLevelId : <any>null;
        data["isTransit"] = this.isTransit !== undefined ? this.isTransit : <any>null;
        data["approval"] = this.approval ? this.approval.toJSON() : <any>null;
        return data;
    }

    clone(): TravelRequestCountryUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryUpdateDTO {
    countryId: number;
    approvalRequirement: CountryApprovalRequirement;
    approvalLevelId: number;
    isTransit: boolean | null;
    approval: TravelRequestCountryApprovalUpdateDTO | null;
}

export class TravelRequestCountryApprovalUpdateDTO implements ITravelRequestCountryApprovalUpdateDTO {
    approveType!: ApproveType;
    approversIds!: number[];

    constructor(data?: ITravelRequestCountryApprovalUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approveType = _data["approveType"] !== undefined ? _data["approveType"] : <any>null;
            if (Array.isArray(_data["approversIds"])) {
                this.approversIds = [] as any;
                for (let item of _data["approversIds"])
                    this.approversIds!.push(item);
            }
            else {
                this.approversIds = <any>null;
            }
        }
    }

    static fromJS(data: any): TravelRequestCountryApprovalUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCountryApprovalUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approveType"] = this.approveType !== undefined ? this.approveType : <any>null;
        if (Array.isArray(this.approversIds)) {
            data["approversIds"] = [];
            for (let item of this.approversIds)
                data["approversIds"].push(item);
        }
        return data;
    }

    clone(): TravelRequestCountryApprovalUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestCountryApprovalUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCountryApprovalUpdateDTO {
    approveType: ApproveType;
    approversIds: number[];
}

export abstract class TravelRequestSegmentUpdateDTO implements ITravelRequestSegmentUpdateDTO {
    ordinalNumber!: number;

    constructor(data?: ITravelRequestSegmentUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinalNumber = _data["ordinalNumber"] !== undefined ? _data["ordinalNumber"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'TravelRequestSegmentUpdateDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinalNumber"] = this.ordinalNumber !== undefined ? this.ordinalNumber : <any>null;
        return data;
    }

    clone(): TravelRequestSegmentUpdateDTO {
        throw new Error("The abstract class 'TravelRequestSegmentUpdateDTO' cannot be instantiated.");
    }
}

export interface ITravelRequestSegmentUpdateDTO {
    ordinalNumber: number;
}

export class TravelRequestAccommodationSegmentUpdateDTO extends TravelRequestSegmentUpdateDTO implements ITravelRequestAccommodationSegmentUpdateDTO {
    arrivalDate!: string;
    departureDate!: string;
    accommodationTypeId!: number;
    name!: string;
    address!: string;
    cityId!: number | null;
    cityCustomName!: string | null;
    countryId!: number;

    constructor(data?: ITravelRequestAccommodationSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.accommodationTypeId = _data["accommodationTypeId"] !== undefined ? _data["accommodationTypeId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
            this.cityCustomName = _data["cityCustomName"] !== undefined ? _data["cityCustomName"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestAccommodationSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestAccommodationSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["accommodationTypeId"] = this.accommodationTypeId !== undefined ? this.accommodationTypeId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        data["cityCustomName"] = this.cityCustomName !== undefined ? this.cityCustomName : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestAccommodationSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestAccommodationSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestAccommodationSegmentUpdateDTO extends ITravelRequestSegmentUpdateDTO {
    arrivalDate: string;
    departureDate: string;
    accommodationTypeId: number;
    name: string;
    address: string;
    cityId: number | null;
    cityCustomName: string | null;
    countryId: number;
}

export class TravelRequestCitySegmentUpdateDTO extends TravelRequestSegmentUpdateDTO implements ITravelRequestCitySegmentUpdateDTO {
    arrivalDate!: string;
    departureDate!: string;
    cityId!: number;

    constructor(data?: ITravelRequestCitySegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.arrivalDate = _data["arrivalDate"] !== undefined ? _data["arrivalDate"] : <any>null;
            this.departureDate = _data["departureDate"] !== undefined ? _data["departureDate"] : <any>null;
            this.cityId = _data["cityId"] !== undefined ? _data["cityId"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestCitySegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestCitySegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arrivalDate"] = this.arrivalDate !== undefined ? this.arrivalDate : <any>null;
        data["departureDate"] = this.departureDate !== undefined ? this.departureDate : <any>null;
        data["cityId"] = this.cityId !== undefined ? this.cityId : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestCitySegmentUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestCitySegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestCitySegmentUpdateDTO extends ITravelRequestSegmentUpdateDTO {
    arrivalDate: string;
    departureDate: string;
    cityId: number;
}

export class TravelRequestTransportationSegmentUpdateDTO extends TravelRequestSegmentUpdateDTO implements ITravelRequestTransportationSegmentUpdateDTO {
    tripDate!: string;
    transportationTypeId!: number;
    airlineId!: number | null;
    airlineCustomName!: string | null;
    flightNumber!: string | null;
    note!: string | null;

    constructor(data?: ITravelRequestTransportationSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tripDate = _data["tripDate"] !== undefined ? _data["tripDate"] : <any>null;
            this.transportationTypeId = _data["transportationTypeId"] !== undefined ? _data["transportationTypeId"] : <any>null;
            this.airlineId = _data["airlineId"] !== undefined ? _data["airlineId"] : <any>null;
            this.airlineCustomName = _data["airlineCustomName"] !== undefined ? _data["airlineCustomName"] : <any>null;
            this.flightNumber = _data["flightNumber"] !== undefined ? _data["flightNumber"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestTransportationSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTransportationSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripDate"] = this.tripDate !== undefined ? this.tripDate : <any>null;
        data["transportationTypeId"] = this.transportationTypeId !== undefined ? this.transportationTypeId : <any>null;
        data["airlineId"] = this.airlineId !== undefined ? this.airlineId : <any>null;
        data["airlineCustomName"] = this.airlineCustomName !== undefined ? this.airlineCustomName : <any>null;
        data["flightNumber"] = this.flightNumber !== undefined ? this.flightNumber : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestTransportationSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestTransportationSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestTransportationSegmentUpdateDTO extends ITravelRequestSegmentUpdateDTO {
    tripDate: string;
    transportationTypeId: number;
    airlineId: number | null;
    airlineCustomName: string | null;
    flightNumber: string | null;
    note: string | null;
}

export class TravelRequestNoteSegmentUpdateDTO extends TravelRequestSegmentUpdateDTO implements ITravelRequestNoteSegmentUpdateDTO {
    note!: string;

    constructor(data?: ITravelRequestNoteSegmentUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): TravelRequestNoteSegmentUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestNoteSegmentUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : <any>null;
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestNoteSegmentUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestNoteSegmentUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestNoteSegmentUpdateDTO extends ITravelRequestSegmentUpdateDTO {
    note: string;
}

export class TravelRequestUpdateDTO extends TravelRequestUpdateBaseDTO implements ITravelRequestUpdateDTO {

    constructor(data?: ITravelRequestUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelRequestUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelRequestUpdateDTO {
        const json = this.toJSON();
        let result = new TravelRequestUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelRequestUpdateDTO extends ITravelRequestUpdateBaseDTO {
}

export class ChangeApproverApprovalStatusModel implements IChangeApproverApprovalStatusModel {
    countryId!: number;
    approverId!: number;
    approvalStatus!: ApprovalStatus;
    comment!: string | null;

    constructor(data?: IChangeApproverApprovalStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.approverId = _data["approverId"] !== undefined ? _data["approverId"] : <any>null;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeApproverApprovalStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeApproverApprovalStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["approverId"] = this.approverId !== undefined ? this.approverId : <any>null;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }

    clone(): ChangeApproverApprovalStatusModel {
        const json = this.toJSON();
        let result = new ChangeApproverApprovalStatusModel();
        result.init(json);
        return result;
    }
}

export interface IChangeApproverApprovalStatusModel {
    countryId: number;
    approverId: number;
    approvalStatus: ApprovalStatus;
    comment: string | null;
}

export class TravelTypeDetailDTO extends ArchivableKeywordDetailDTO implements ITravelTypeDetailDTO {

    constructor(data?: ITravelTypeDetailDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelTypeDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTypeDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelTypeDetailDTO {
        const json = this.toJSON();
        let result = new TravelTypeDetailDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelTypeDetailDTO extends IArchivableKeywordDetailDTO {
}

export class TravelTypeUpdateBaseDTO extends KeywordUpdateBaseDTO implements ITravelTypeUpdateBaseDTO {

    constructor(data?: ITravelTypeUpdateBaseDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelTypeUpdateBaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTypeUpdateBaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelTypeUpdateBaseDTO {
        const json = this.toJSON();
        let result = new TravelTypeUpdateBaseDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelTypeUpdateBaseDTO extends IKeywordUpdateBaseDTO {
}

export class TravelTypeCreateDTO extends TravelTypeUpdateBaseDTO implements ITravelTypeCreateDTO {

    constructor(data?: ITravelTypeCreateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelTypeCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTypeCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelTypeCreateDTO {
        const json = this.toJSON();
        let result = new TravelTypeCreateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelTypeCreateDTO extends ITravelTypeUpdateBaseDTO {
}

export class TravelTypeUpdateDTO extends TravelTypeUpdateBaseDTO implements ITravelTypeUpdateDTO {

    constructor(data?: ITravelTypeUpdateDTO) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TravelTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): TravelTypeUpdateDTO {
        const json = this.toJSON();
        let result = new TravelTypeUpdateDTO();
        result.init(json);
        return result;
    }
}

export interface ITravelTypeUpdateDTO extends ITravelTypeUpdateBaseDTO {
}

export class UsersLocationsFeaturesModelDTO implements IUsersLocationsFeaturesModelDTO {
    fromDisplayName!: string;
    fromEmailAddress!: string;

    constructor(data?: IUsersLocationsFeaturesModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDisplayName = _data["fromDisplayName"] !== undefined ? _data["fromDisplayName"] : <any>null;
            this.fromEmailAddress = _data["fromEmailAddress"] !== undefined ? _data["fromEmailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): UsersLocationsFeaturesModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLocationsFeaturesModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDisplayName"] = this.fromDisplayName !== undefined ? this.fromDisplayName : <any>null;
        data["fromEmailAddress"] = this.fromEmailAddress !== undefined ? this.fromEmailAddress : <any>null;
        return data;
    }

    clone(): UsersLocationsFeaturesModelDTO {
        const json = this.toJSON();
        let result = new UsersLocationsFeaturesModelDTO();
        result.init(json);
        return result;
    }
}

export interface IUsersLocationsFeaturesModelDTO {
    fromDisplayName: string;
    fromEmailAddress: string;
}

export class UsersLocationsModel implements IUsersLocationsModel {
    searchUniqueId!: string;
    usersLocationsForList!: QueryResultOfUserLocationRecordDTO;
    usersLocationsForMap!: UserLocationRecordDTO[];

    constructor(data?: IUsersLocationsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchUniqueId = _data["searchUniqueId"] !== undefined ? _data["searchUniqueId"] : <any>null;
            this.usersLocationsForList = _data["usersLocationsForList"] ? QueryResultOfUserLocationRecordDTO.fromJS(_data["usersLocationsForList"]) : <any>null;
            if (Array.isArray(_data["usersLocationsForMap"])) {
                this.usersLocationsForMap = [] as any;
                for (let item of _data["usersLocationsForMap"])
                    this.usersLocationsForMap!.push(UserLocationRecordDTO.fromJS(item));
            }
            else {
                this.usersLocationsForMap = <any>null;
            }
        }
    }

    static fromJS(data: any): UsersLocationsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLocationsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchUniqueId"] = this.searchUniqueId !== undefined ? this.searchUniqueId : <any>null;
        data["usersLocationsForList"] = this.usersLocationsForList ? this.usersLocationsForList.toJSON() : <any>null;
        if (Array.isArray(this.usersLocationsForMap)) {
            data["usersLocationsForMap"] = [];
            for (let item of this.usersLocationsForMap)
                data["usersLocationsForMap"].push(item.toJSON());
        }
        return data;
    }

    clone(): UsersLocationsModel {
        const json = this.toJSON();
        let result = new UsersLocationsModel();
        result.init(json);
        return result;
    }
}

export interface IUsersLocationsModel {
    searchUniqueId: string;
    usersLocationsForList: QueryResultOfUserLocationRecordDTO;
    usersLocationsForMap: UserLocationRecordDTO[];
}

export class QueryResultOfUserLocationRecordDTO implements IQueryResultOfUserLocationRecordDTO {
    metaData!: QueryResultMetaDataOfUserLocationRecordDTO;
    data!: UserLocationRecordDTO[];

    constructor(data?: IQueryResultOfUserLocationRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metaData = _data["metaData"] ? QueryResultMetaDataOfUserLocationRecordDTO.fromJS(_data["metaData"]) : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserLocationRecordDTO.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): QueryResultOfUserLocationRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfUserLocationRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metaData"] = this.metaData ? this.metaData.toJSON() : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }

    clone(): QueryResultOfUserLocationRecordDTO {
        const json = this.toJSON();
        let result = new QueryResultOfUserLocationRecordDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultOfUserLocationRecordDTO {
    metaData: QueryResultMetaDataOfUserLocationRecordDTO;
    data: UserLocationRecordDTO[];
}

export class QueryResultMetaDataOfUserLocationRecordDTO implements IQueryResultMetaDataOfUserLocationRecordDTO {
    offset!: number | null;
    limit!: number | null;
    totalRowCount!: number;

    constructor(data?: IQueryResultMetaDataOfUserLocationRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"] !== undefined ? _data["offset"] : <any>null;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : <any>null;
            this.totalRowCount = _data["totalRowCount"] !== undefined ? _data["totalRowCount"] : <any>null;
        }
    }

    static fromJS(data: any): QueryResultMetaDataOfUserLocationRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultMetaDataOfUserLocationRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset !== undefined ? this.offset : <any>null;
        data["limit"] = this.limit !== undefined ? this.limit : <any>null;
        data["totalRowCount"] = this.totalRowCount !== undefined ? this.totalRowCount : <any>null;
        return data;
    }

    clone(): QueryResultMetaDataOfUserLocationRecordDTO {
        const json = this.toJSON();
        let result = new QueryResultMetaDataOfUserLocationRecordDTO();
        result.init(json);
        return result;
    }
}

export interface IQueryResultMetaDataOfUserLocationRecordDTO {
    offset: number | null;
    limit: number | null;
    totalRowCount: number;
}

export class UserLocationRecordDTO implements IUserLocationRecordDTO {
    rowIndex!: number;
    user!: UserDTO;
    location!: LocationDTO | null;
    userLocationRequest!: UserLocationRequestDTO | null;
    locationExistsOrdering!: boolean;
    countryNameOrdering!: string | null;

    constructor(data?: IUserLocationRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"] !== undefined ? _data["rowIndex"] : <any>null;
            this.user = _data["user"] ? UserDTO.fromJS(_data["user"]) : <any>null;
            this.location = _data["location"] ? LocationDTO.fromJS(_data["location"]) : <any>null;
            this.userLocationRequest = _data["userLocationRequest"] ? UserLocationRequestDTO.fromJS(_data["userLocationRequest"]) : <any>null;
            this.locationExistsOrdering = _data["locationExistsOrdering"] !== undefined ? _data["locationExistsOrdering"] : <any>null;
            this.countryNameOrdering = _data["countryNameOrdering"] !== undefined ? _data["countryNameOrdering"] : <any>null;
        }
    }

    static fromJS(data: any): UserLocationRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocationRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        data["location"] = this.location ? this.location.toJSON() : <any>null;
        data["userLocationRequest"] = this.userLocationRequest ? this.userLocationRequest.toJSON() : <any>null;
        data["locationExistsOrdering"] = this.locationExistsOrdering !== undefined ? this.locationExistsOrdering : <any>null;
        data["countryNameOrdering"] = this.countryNameOrdering !== undefined ? this.countryNameOrdering : <any>null;
        return data;
    }

    clone(): UserLocationRecordDTO {
        const json = this.toJSON();
        let result = new UserLocationRecordDTO();
        result.init(json);
        return result;
    }
}

export interface IUserLocationRecordDTO {
    rowIndex: number;
    user: UserDTO;
    location: LocationDTO | null;
    userLocationRequest: UserLocationRequestDTO | null;
    locationExistsOrdering: boolean;
    countryNameOrdering: string | null;
}

export class UsersLocationsRequestModel implements IUsersLocationsRequestModel {
    searchUniqueId!: string;
    usersUniqueIds!: string[];

    constructor(data?: IUsersLocationsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchUniqueId = _data["searchUniqueId"] !== undefined ? _data["searchUniqueId"] : <any>null;
            if (Array.isArray(_data["usersUniqueIds"])) {
                this.usersUniqueIds = [] as any;
                for (let item of _data["usersUniqueIds"])
                    this.usersUniqueIds!.push(item);
            }
            else {
                this.usersUniqueIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UsersLocationsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersLocationsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchUniqueId"] = this.searchUniqueId !== undefined ? this.searchUniqueId : <any>null;
        if (Array.isArray(this.usersUniqueIds)) {
            data["usersUniqueIds"] = [];
            for (let item of this.usersUniqueIds)
                data["usersUniqueIds"].push(item);
        }
        return data;
    }

    clone(): UsersLocationsRequestModel {
        const json = this.toJSON();
        let result = new UsersLocationsRequestModel();
        result.init(json);
        return result;
    }
}

export interface IUsersLocationsRequestModel {
    searchUniqueId: string;
    usersUniqueIds: string[];
}

export class UserLocationEmailsModel implements IUserLocationEmailsModel {
    from!: MailAddressModel;
    recipients!: MailAddressModel[];
    subject!: string;
    htmlBody!: string;

    constructor(data?: IUserLocationEmailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new MailAddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? MailAddressModel.fromJS(_data["from"]) : new MailAddressModel();
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(MailAddressModel.fromJS(item));
            }
            else {
                this.recipients = <any>null;
            }
            this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            this.htmlBody = _data["htmlBody"] !== undefined ? _data["htmlBody"] : <any>null;
        }
    }

    static fromJS(data: any): UserLocationEmailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLocationEmailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>null;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item.toJSON());
        }
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["htmlBody"] = this.htmlBody !== undefined ? this.htmlBody : <any>null;
        return data;
    }

    clone(): UserLocationEmailsModel {
        const json = this.toJSON();
        let result = new UserLocationEmailsModel();
        result.init(json);
        return result;
    }
}

export interface IUserLocationEmailsModel {
    from: MailAddressModel;
    recipients: MailAddressModel[];
    subject: string;
    htmlBody: string;
}

export class MailAddressModel implements IMailAddressModel {
    name!: string;
    emailAddress!: string;

    constructor(data?: IMailAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : <any>null;
        }
    }

    static fromJS(data: any): MailAddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new MailAddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : <any>null;
        return data;
    }

    clone(): MailAddressModel {
        const json = this.toJSON();
        let result = new MailAddressModel();
        result.init(json);
        return result;
    }
}

export interface IMailAddressModel {
    name: string;
    emailAddress: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiCallException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiCallException = true;

    static isApiCallException(obj: any): obj is ApiCallException {
        return obj.isApiCallException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiCallException(message, status, response, headers, null);
}

export class ProblemDetails {
  type!: string | null;
  title!: string | null;
  status!: number | null;
  detail!: string | null;
  instance!: string | null;
  traceId!: string | null;
  customType!: string | null;
  validationErrors!: { [key: string]: [string] } | null;
  extensions!: { [key: string]: string } | null;

  constructor() {
    this.type = null;
    this.title = null;
    this.status = null;
    this.detail = null;
    this.instance = null;
    this.traceId = null;
    this.customType = null;
    this.validationErrors = null;
    this.extensions = null;
  }

  init(_data?: any) {
    if (_data) {
      for (const property in _data) {
        if (property === "type")
          this.type = _data[property];
        else if (property === "title")
          this.title = _data[property];
        else if (property === "status")
          this.status = _data[property];
        else if (property === "detail")
          this.detail = _data[property];
        else if (property === "instance")
          this.instance = _data[property];
        else if (property === "traceId")
          this.traceId = _data[property];
        else if (property === "customType")
          this.customType = _data[property];
        else if (property === "errors")
          this.validationErrors = _data[property];
        else {
          if (this.extensions === null)
            this.extensions = {} as { [key: string]: string };
          this.extensions[property] = _data[property];
        }
      }
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["type"] = this.type !== undefined ? this.type : <any>null;
    data["title"] = this.title !== undefined ? this.title : <any>null;
    data["status"] = this.status !== undefined ? this.status : <any>null;
    data["detail"] = this.detail !== undefined ? this.detail : <any>null;
    data["instance"] = this.instance !== undefined ? this.instance : <any>null;
    data["traceId"] = this.traceId !== undefined ? this.traceId : <any>null;
    data["customType"] = this.customType !== undefined ? this.customType : <any>null;
    data["errors"] = this.validationErrors !== undefined ? this.validationErrors : <any>null;
    if (this.extensions) {
      for (let key in this.extensions) {
        if (this.extensions.hasOwnProperty(key))
          data[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
      }
    }
    return data;
  }

  clone(): ProblemDetails {
    const json = this.toJSON();
    let result = new ProblemDetails();
    result.init(json);
    return result;
  }
}